var _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _g6, _g7, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _g8, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _g9, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutonomusopsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 167,
    viewBox: "0 0 187 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M146.045 165.661C162.022 165.661 174.974 158.408 174.974 149.46C174.974 140.512 162.022 133.258 146.045 133.258C130.068 133.258 117.116 140.512 117.116 149.46C117.116 158.408 130.068 165.661 146.045 165.661Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M146.045 165.231C161.598 165.231 174.206 158.169 174.206 149.459C174.206 140.749 161.598 133.688 146.045 133.688C130.493 133.688 117.885 140.749 117.885 149.459C117.885 158.169 130.493 165.231 146.045 165.231Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M146.045 164.802C161.173 164.802 173.437 157.933 173.437 149.46C173.437 140.988 161.173 134.119 146.045 134.119C130.916 134.119 118.652 140.988 118.652 149.46C118.652 157.933 130.916 164.802 146.045 164.802Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M146.045 164.373C160.749 164.373 172.669 157.697 172.669 149.462C172.669 141.227 160.749 134.551 146.045 134.551C131.341 134.551 119.421 141.227 119.421 149.462C119.421 157.697 131.341 164.373 146.045 164.373Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M146.045 163.942C160.325 163.942 171.901 157.459 171.901 149.461C171.901 141.464 160.325 134.98 146.045 134.98C131.765 134.98 120.189 141.464 120.189 149.461C120.189 157.459 131.765 163.942 146.045 163.942Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M146.045 163.511C159.901 163.511 171.133 157.22 171.133 149.461C171.133 141.701 159.901 135.41 146.045 135.41C132.19 135.41 120.958 141.701 120.958 149.461C120.958 157.22 132.19 163.511 146.045 163.511Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M146.045 163.08C159.476 163.08 170.364 156.982 170.364 149.46C170.364 141.938 159.476 135.84 146.045 135.84C132.614 135.84 121.726 141.938 121.726 149.46C121.726 156.982 132.614 163.08 146.045 163.08Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M146.045 162.649C159.052 162.649 169.596 156.744 169.596 149.459C169.596 142.175 159.052 136.27 146.045 136.27C133.038 136.27 122.494 142.175 122.494 149.459C122.494 156.744 133.038 162.649 146.045 162.649Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M146.044 162.218C158.627 162.218 168.827 156.506 168.827 149.459C168.827 142.412 158.627 136.699 146.044 136.699C133.462 136.699 123.262 142.412 123.262 149.459C123.262 156.506 133.462 162.218 146.044 162.218Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M146.046 161.789C158.204 161.789 168.06 156.269 168.06 149.46C168.06 142.651 158.204 137.131 146.046 137.131C133.887 137.131 124.031 142.651 124.031 149.46C124.031 156.269 133.887 161.789 146.046 161.789Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M146.045 161.358C157.779 161.358 167.291 156.031 167.291 149.46C167.291 142.888 157.779 137.561 146.045 137.561C134.311 137.561 124.799 142.888 124.799 149.46C124.799 156.031 134.311 161.358 146.045 161.358Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M146.044 160.93C157.354 160.93 166.522 155.795 166.522 149.461C166.522 143.127 157.354 137.992 146.044 137.992C134.735 137.992 125.566 143.127 125.566 149.461C125.566 155.795 134.735 160.93 146.044 160.93Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M146.044 160.499C156.93 160.499 165.754 155.557 165.754 149.46C165.754 143.364 156.93 138.422 146.044 138.422C135.159 138.422 126.335 143.364 126.335 149.46C126.335 155.557 135.159 160.499 146.044 160.499Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M146.045 160.068C156.506 160.068 164.986 155.318 164.986 149.46C164.986 143.601 156.506 138.852 146.045 138.852C135.584 138.852 127.104 143.601 127.104 149.46C127.104 155.318 135.584 160.068 146.045 160.068Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M146.045 159.637C156.082 159.637 164.218 155.08 164.218 149.459C164.218 143.838 156.082 139.281 146.045 139.281C136.008 139.281 127.872 143.838 127.872 149.459C127.872 155.08 136.008 159.637 146.045 159.637Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M146.045 159.206C155.657 159.206 163.45 154.842 163.45 149.459C163.45 144.075 155.657 139.711 146.045 139.711C136.433 139.711 128.641 144.075 128.641 149.459C128.641 154.842 136.433 159.206 146.045 159.206Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M146.044 158.777C155.232 158.777 162.681 154.606 162.681 149.46C162.681 144.314 155.232 140.143 146.044 140.143C136.857 140.143 129.408 144.314 129.408 149.46C129.408 154.606 136.857 158.777 146.044 158.777Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M146.045 158.346C154.808 158.346 161.913 154.367 161.913 149.459C161.913 144.551 154.808 140.572 146.045 140.572C137.281 140.572 130.177 144.551 130.177 149.459C130.177 154.367 137.281 158.346 146.045 158.346Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M146.045 157.917C154.384 157.917 161.145 154.131 161.145 149.461C161.145 144.79 154.384 141.004 146.045 141.004C137.706 141.004 130.945 144.79 130.945 149.461C130.945 154.131 137.706 157.917 146.045 157.917Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M146.045 157.488C153.96 157.488 160.377 153.895 160.377 149.462C160.377 145.029 153.96 141.436 146.045 141.436C138.13 141.436 131.714 145.029 131.714 149.462C131.714 153.895 138.13 157.488 146.045 157.488Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M146.045 157.058C153.535 157.058 159.608 153.657 159.608 149.461C159.608 145.266 153.535 141.865 146.045 141.865C138.554 141.865 132.481 145.266 132.481 149.461C132.481 153.657 138.554 157.058 146.045 157.058Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M146.045 156.627C153.111 156.627 158.84 153.418 158.84 149.461C158.84 145.503 153.111 142.295 146.045 142.295C138.978 142.295 133.25 145.503 133.25 149.461C133.25 153.418 138.978 156.627 146.045 156.627Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M146.044 156.196C152.686 156.196 158.071 153.18 158.071 149.46C158.071 145.74 152.686 142.725 146.044 142.725C139.402 142.725 134.018 145.74 134.018 149.46C134.018 153.18 139.402 156.196 146.044 156.196Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.044 155.765C152.262 155.765 157.303 152.942 157.303 149.46C157.303 145.977 152.262 143.154 146.044 143.154C139.827 143.154 134.786 145.977 134.786 149.46C134.786 152.942 139.827 155.765 146.044 155.765Z",
    fill: "#190C00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M157.303 131.24C173.28 131.24 186.232 123.986 186.232 115.038C186.232 106.09 173.28 98.8359 157.303 98.8359C141.326 98.8359 128.374 106.09 128.374 115.038C128.374 123.986 141.326 131.24 157.303 131.24Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M157.303 130.811C172.856 130.811 185.464 123.749 185.464 115.039C185.464 106.329 172.856 99.2676 157.303 99.2676C141.751 99.2676 129.143 106.329 129.143 115.039C129.143 123.749 141.751 130.811 157.303 130.811Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M157.302 130.38C172.431 130.38 184.695 123.511 184.695 115.038C184.695 106.566 172.431 99.6973 157.302 99.6973C142.174 99.6973 129.91 106.566 129.91 115.038C129.91 123.511 142.174 130.38 157.302 130.38Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M157.303 129.951C172.007 129.951 183.927 123.275 183.927 115.04C183.927 106.805 172.007 100.129 157.303 100.129C142.599 100.129 130.679 106.805 130.679 115.04C130.679 123.275 142.599 129.951 157.303 129.951Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M157.303 129.52C171.583 129.52 183.159 123.037 183.159 115.039C183.159 107.042 171.583 100.559 157.303 100.559C143.023 100.559 131.447 107.042 131.447 115.039C131.447 123.037 143.023 129.52 157.303 129.52Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M157.303 129.089C171.159 129.089 182.391 122.798 182.391 115.039C182.391 107.279 171.159 100.988 157.303 100.988C143.448 100.988 132.216 107.279 132.216 115.039C132.216 122.798 143.448 129.089 157.303 129.089Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M157.303 128.658C170.734 128.658 181.622 122.56 181.622 115.038C181.622 107.516 170.734 101.418 157.303 101.418C143.871 101.418 132.983 107.516 132.983 115.038C132.983 122.56 143.871 128.658 157.303 128.658Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M157.303 128.227C170.31 128.227 180.854 122.322 180.854 115.037C180.854 107.753 170.31 101.848 157.303 101.848C144.296 101.848 133.752 107.753 133.752 115.037C133.752 122.322 144.296 128.227 157.303 128.227Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M157.302 127.796C169.885 127.796 180.085 122.084 180.085 115.037C180.085 107.99 169.885 102.277 157.302 102.277C144.72 102.277 134.52 107.99 134.52 115.037C134.52 122.084 144.72 127.796 157.302 127.796Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M157.303 127.367C169.462 127.367 179.318 121.847 179.318 115.038C179.318 108.229 169.462 102.709 157.303 102.709C145.145 102.709 135.289 108.229 135.289 115.038C135.289 121.847 145.145 127.367 157.303 127.367Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M157.303 126.937C169.036 126.937 178.549 121.609 178.549 115.038C178.549 108.466 169.036 103.139 157.303 103.139C145.569 103.139 136.057 108.466 136.057 115.038C136.057 121.609 145.569 126.937 157.303 126.937Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M157.302 126.508C168.611 126.508 177.78 121.373 177.78 115.039C177.78 108.705 168.611 103.57 157.302 103.57C145.992 103.57 136.824 108.705 136.824 115.039C136.824 121.373 145.992 126.508 157.302 126.508Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M157.302 126.077C168.187 126.077 177.012 121.135 177.012 115.038C177.012 108.942 168.187 104 157.302 104C146.417 104 137.593 108.942 137.593 115.038C137.593 121.135 146.417 126.077 157.302 126.077Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M157.302 125.646C167.763 125.646 176.244 120.896 176.244 115.038C176.244 109.179 167.763 104.43 157.302 104.43C146.842 104.43 138.361 109.179 138.361 115.038C138.361 120.896 146.842 125.646 157.302 125.646Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M157.303 125.215C167.339 125.215 175.476 120.658 175.476 115.037C175.476 109.416 167.339 104.859 157.303 104.859C147.266 104.859 139.13 109.416 139.13 115.037C139.13 120.658 147.266 125.215 157.303 125.215Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M157.303 124.784C166.915 124.784 174.708 120.42 174.708 115.037C174.708 109.653 166.915 105.289 157.303 105.289C147.691 105.289 139.898 109.653 139.898 115.037C139.898 120.42 147.691 124.784 157.303 124.784Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M157.302 124.355C166.49 124.355 173.939 120.184 173.939 115.038C173.939 109.892 166.49 105.721 157.302 105.721C148.114 105.721 140.666 109.892 140.666 115.038C140.666 120.184 148.114 124.355 157.302 124.355Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M157.303 123.924C166.066 123.924 173.171 119.946 173.171 115.037C173.171 110.129 166.066 106.15 157.303 106.15C148.539 106.15 141.435 110.129 141.435 115.037C141.435 119.946 148.539 123.924 157.303 123.924Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M157.303 123.495C165.642 123.495 172.403 119.709 172.403 115.039C172.403 110.368 165.642 106.582 157.303 106.582C148.964 106.582 142.203 110.368 142.203 115.039C142.203 119.709 148.964 123.495 157.303 123.495Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M157.303 123.066C165.218 123.066 171.635 119.473 171.635 115.04C171.635 110.607 165.218 107.014 157.303 107.014C149.388 107.014 142.972 110.607 142.972 115.04C142.972 119.473 149.388 123.066 157.303 123.066Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M157.302 122.636C164.793 122.636 170.866 119.235 170.866 115.039C170.866 110.844 164.793 107.443 157.302 107.443C149.812 107.443 143.739 110.844 143.739 115.039C143.739 119.235 149.812 122.636 157.302 122.636Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M157.303 122.205C164.369 122.205 170.098 118.997 170.098 115.039C170.098 111.081 164.369 107.873 157.303 107.873C150.236 107.873 144.508 111.081 144.508 115.039C144.508 118.997 150.236 122.205 157.303 122.205Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M157.302 121.774C163.944 121.774 169.329 118.758 169.329 115.038C169.329 111.318 163.944 108.303 157.302 108.303C150.66 108.303 145.275 111.318 145.275 115.038C145.275 118.758 150.66 121.774 157.302 121.774Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.303 121.343C163.521 121.343 168.562 118.52 168.562 115.038C168.562 111.555 163.521 108.732 157.303 108.732C151.085 108.732 146.045 111.555 146.045 115.038C146.045 118.52 151.085 121.343 157.303 121.343Z",
    fill: "#190C00"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M113.519 94.9856C129.496 94.9856 142.448 87.7318 142.448 78.7838C142.448 69.8358 129.496 62.582 113.519 62.582C97.5417 62.582 84.5898 69.8358 84.5898 78.7838C84.5898 87.7318 97.5417 94.9856 113.519 94.9856Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M113.518 94.5567C129.071 94.5567 141.679 87.4956 141.679 78.7852C141.679 70.0748 129.071 63.0137 113.518 63.0137C97.9653 63.0137 85.3574 70.0748 85.3574 78.7852C85.3574 87.4956 97.9653 94.5567 113.518 94.5567Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M113.518 94.1258C128.647 94.1258 140.911 87.2573 140.911 78.7846C140.911 70.3118 128.647 63.4434 113.518 63.4434C98.3899 63.4434 86.126 70.3118 86.126 78.7846C86.126 87.2573 98.3899 94.1258 113.518 94.1258Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M113.519 93.6969C128.223 93.6969 140.143 87.021 140.143 78.7859C140.143 70.5509 128.223 63.875 113.519 63.875C98.8145 63.875 86.8945 70.5509 86.8945 78.7859C86.8945 87.021 98.8145 93.6969 113.519 93.6969Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M113.519 93.266C127.799 93.266 139.375 86.7828 139.375 78.7854C139.375 70.7879 127.799 64.3047 113.519 64.3047C99.2391 64.3047 87.6631 70.7879 87.6631 78.7854C87.6631 86.7828 99.2391 93.266 113.519 93.266Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M113.518 92.8352C127.373 92.8352 138.606 86.5446 138.606 78.7848C138.606 71.025 127.373 64.7344 113.518 64.7344C99.6627 64.7344 88.4307 71.025 88.4307 78.7848C88.4307 86.5446 99.6627 92.8352 113.518 92.8352Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M113.518 92.4042C126.949 92.4042 137.838 86.3063 137.838 78.7841C137.838 71.262 126.949 65.1641 113.518 65.1641C100.087 65.1641 89.1992 71.262 89.1992 78.7841C89.1992 86.3063 100.087 92.4042 113.518 92.4042Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M113.519 91.9734C126.525 91.9734 137.069 86.0681 137.069 78.7836C137.069 71.499 126.525 65.5938 113.519 65.5938C100.512 65.5938 89.9678 71.499 89.9678 78.7836C89.9678 86.0681 100.512 91.9734 113.519 91.9734Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M113.518 91.5426C126.1 91.5426 136.3 85.8299 136.3 78.783C136.3 71.7361 126.1 66.0234 113.518 66.0234C100.935 66.0234 90.7354 71.7361 90.7354 78.783C90.7354 85.8299 100.935 91.5426 113.518 91.5426Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M113.519 91.1135C125.677 91.1135 135.533 85.5935 135.533 78.7843C135.533 71.9751 125.677 66.4551 113.519 66.4551C101.361 66.4551 91.5049 71.9751 91.5049 78.7843C91.5049 85.5935 101.361 91.1135 113.519 91.1135Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M113.517 90.6846C125.251 90.6846 134.763 85.3573 134.763 78.7857C134.763 72.2141 125.251 66.8867 113.517 66.8867C101.784 66.8867 92.2715 72.2141 92.2715 78.7857C92.2715 85.3573 101.784 90.6846 113.517 90.6846Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M113.518 90.2538C124.827 90.2538 133.995 85.1191 133.995 78.7851C133.995 72.4511 124.827 67.3164 113.518 67.3164C102.208 67.3164 93.04 72.4511 93.04 78.7851C93.04 85.1191 102.208 90.2538 113.518 90.2538Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M113.518 89.8228C124.403 89.8228 133.227 84.8808 133.227 78.7845C133.227 72.6881 124.403 67.7461 113.518 67.7461C102.633 67.7461 93.8086 72.6881 93.8086 78.7845C93.8086 84.8808 102.633 89.8228 113.518 89.8228Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M113.518 89.392C123.979 89.392 132.459 84.6426 132.459 78.7839C132.459 72.9252 123.979 68.1758 113.518 68.1758C103.057 68.1758 94.5771 72.9252 94.5771 78.7839C94.5771 84.6426 103.057 89.392 113.518 89.392Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M113.519 88.9612C123.555 88.9612 131.691 84.4044 131.691 78.7833C131.691 73.1622 123.555 68.6055 113.519 68.6055C103.482 68.6055 95.3457 73.1622 95.3457 78.7833C95.3457 84.4044 103.482 88.9612 113.519 88.9612Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M113.518 88.5303C123.13 88.5303 130.922 84.1662 130.922 78.7827C130.922 73.3993 123.13 69.0352 113.518 69.0352C103.906 69.0352 96.1133 73.3993 96.1133 78.7827C96.1133 84.1662 103.906 88.5303 113.518 88.5303Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M113.518 88.1013C122.706 88.1013 130.154 83.9298 130.154 78.784C130.154 73.6383 122.706 69.4668 113.518 69.4668C104.33 69.4668 96.8818 73.6383 96.8818 78.784C96.8818 83.9298 104.33 88.1013 113.518 88.1013Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M113.518 87.6724C122.282 87.6724 129.386 83.6936 129.386 78.7854C129.386 73.8773 122.282 69.8984 113.518 69.8984C104.755 69.8984 97.6504 73.8773 97.6504 78.7854C97.6504 83.6936 104.755 87.6724 113.518 87.6724Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M113.519 87.2416C121.858 87.2416 128.618 83.4554 128.618 78.7849C128.618 74.1143 121.858 70.3281 113.519 70.3281C105.179 70.3281 98.4189 74.1143 98.4189 78.7849C98.4189 83.4554 105.179 87.2416 113.519 87.2416Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M113.518 86.8125C121.433 86.8125 127.849 83.219 127.849 78.7862C127.849 74.3533 121.433 70.7598 113.518 70.7598C105.603 70.7598 99.1865 74.3533 99.1865 78.7862C99.1865 83.219 105.603 86.8125 113.518 86.8125Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M113.518 86.3817C121.009 86.3817 127.081 82.9808 127.081 78.7856C127.081 74.5904 121.009 71.1895 113.518 71.1895C106.028 71.1895 99.9551 74.5904 99.9551 78.7856C99.9551 82.9808 106.028 86.3817 113.518 86.3817Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M113.519 85.9509C120.585 85.9509 126.314 82.7426 126.314 78.785C126.314 74.8274 120.585 71.6191 113.519 71.6191C106.452 71.6191 100.724 74.8274 100.724 78.785C100.724 82.7426 106.452 85.9509 113.519 85.9509Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M113.518 85.5201C120.16 85.5201 125.545 82.5044 125.545 78.7844C125.545 75.0645 120.16 72.0488 113.518 72.0488C106.876 72.0488 101.491 75.0645 101.491 78.7844C101.491 82.5044 106.876 85.5201 113.518 85.5201Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.519 85.0891C119.737 85.0891 124.777 82.2661 124.777 78.7838C124.777 75.3015 119.737 72.4785 113.519 72.4785C107.301 72.4785 102.261 75.3015 102.261 78.7838C102.261 82.2661 107.301 85.0891 113.519 85.0891Z",
    fill: "#190C00"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M96.8507 159.005C112.828 159.005 125.78 151.751 125.78 142.803C125.78 133.855 112.828 126.602 96.8507 126.602C80.8738 126.602 67.9219 133.855 67.9219 142.803C67.9219 151.751 80.8738 159.005 96.8507 159.005Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M96.851 158.574C112.404 158.574 125.012 151.513 125.012 142.803C125.012 134.092 112.404 127.031 96.851 127.031C81.2983 127.031 68.6904 134.092 68.6904 142.803C68.6904 151.513 81.2983 158.574 96.851 158.574Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M96.8503 158.145C111.979 158.145 124.243 151.277 124.243 142.804C124.243 134.331 111.979 127.463 96.8503 127.463C81.7219 127.463 69.458 134.331 69.458 142.804C69.458 151.277 81.7219 158.145 96.8503 158.145Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M96.8506 157.716C111.555 157.716 123.475 151.041 123.475 142.805C123.475 134.57 111.555 127.895 96.8506 127.895C82.1465 127.895 70.2266 134.57 70.2266 142.805C70.2266 151.041 82.1465 157.716 96.8506 157.716Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M96.8508 157.286C111.131 157.286 122.707 150.802 122.707 142.805C122.707 134.807 111.131 128.324 96.8508 128.324C82.5711 128.324 70.9951 134.807 70.9951 142.805C70.9951 150.802 82.5711 157.286 96.8508 157.286Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M96.8511 156.855C110.707 156.855 121.939 150.564 121.939 142.804C121.939 135.044 110.707 128.754 96.8511 128.754C82.9957 128.754 71.7637 135.044 71.7637 142.804C71.7637 150.564 82.9957 156.855 96.8511 156.855Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M96.8504 156.424C110.281 156.424 121.17 150.326 121.17 142.804C121.17 135.282 110.281 129.184 96.8504 129.184C83.4193 129.184 72.5312 135.282 72.5312 142.804C72.5312 150.326 83.4193 156.424 96.8504 156.424Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M96.8507 155.993C109.857 155.993 120.402 150.088 120.402 142.803C120.402 135.519 109.857 129.613 96.8507 129.613C83.8439 129.613 73.2998 135.519 73.2998 142.803C73.2998 150.088 83.8439 155.993 96.8507 155.993Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M96.85 155.562C109.432 155.562 119.633 149.849 119.633 142.803C119.633 135.756 109.432 130.043 96.85 130.043C84.2675 130.043 74.0674 135.756 74.0674 142.803C74.0674 149.849 84.2675 155.562 96.85 155.562Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M96.8512 155.133C109.009 155.133 118.865 149.613 118.865 142.804C118.865 135.995 109.009 130.475 96.8512 130.475C84.693 130.475 74.8369 135.995 74.8369 142.804C74.8369 149.613 84.693 155.133 96.8512 155.133Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M96.8505 154.702C108.584 154.702 118.096 149.375 118.096 142.803C118.096 136.232 108.584 130.904 96.8505 130.904C85.1167 130.904 75.6045 136.232 75.6045 142.803C75.6045 149.375 85.1167 154.702 96.8505 154.702Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.8498 154.273C108.159 154.273 117.328 149.139 117.328 142.805C117.328 136.471 108.159 131.336 96.8498 131.336C85.5403 131.336 76.3721 136.471 76.3721 142.805C76.3721 149.139 85.5403 154.273 96.8498 154.273Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M96.85 153.842C107.735 153.842 116.559 148.9 116.559 142.804C116.559 136.708 107.735 131.766 96.85 131.766C85.9648 131.766 77.1406 136.708 77.1406 142.804C77.1406 148.9 85.9648 153.842 96.85 153.842Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M96.8503 153.412C107.311 153.412 115.791 148.662 115.791 142.803C115.791 136.945 107.311 132.195 96.8503 132.195C86.3894 132.195 77.9092 136.945 77.9092 142.803C77.9092 148.662 86.3894 153.412 96.8503 153.412Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M96.8506 152.981C106.887 152.981 115.023 148.424 115.023 142.803C115.023 137.182 106.887 132.625 96.8506 132.625C86.814 132.625 78.6777 137.182 78.6777 142.803C78.6777 148.424 86.814 152.981 96.8506 152.981Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M96.8509 152.55C106.463 152.55 114.255 148.186 114.255 142.802C114.255 137.419 106.463 133.055 96.8509 133.055C87.2386 133.055 79.4463 137.419 79.4463 142.802C79.4463 148.186 87.2386 152.55 96.8509 152.55Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M96.8502 152.121C106.038 152.121 113.486 147.949 113.486 142.804C113.486 137.658 106.038 133.486 96.8502 133.486C87.6622 133.486 80.2139 137.658 80.2139 142.804C80.2139 147.949 87.6622 152.121 96.8502 152.121Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M96.8504 151.69C105.614 151.69 112.718 147.711 112.718 142.803C112.718 137.895 105.614 133.916 96.8504 133.916C88.0868 133.916 80.9824 137.895 80.9824 142.803C80.9824 147.711 88.0868 151.69 96.8504 151.69Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M96.8507 151.261C105.19 151.261 111.95 147.475 111.95 142.804C111.95 138.134 105.19 134.348 96.8507 134.348C88.5113 134.348 81.751 138.134 81.751 142.804C81.751 147.475 88.5113 151.261 96.8507 151.261Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M96.851 150.832C104.766 150.832 111.182 147.239 111.182 142.806C111.182 138.373 104.766 134.779 96.851 134.779C88.9359 134.779 82.5195 138.373 82.5195 142.806C82.5195 147.239 88.9359 150.832 96.851 150.832Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M96.8512 150.401C104.342 150.401 110.414 147 110.414 142.805C110.414 138.61 104.342 135.209 96.8512 135.209C89.3605 135.209 83.2881 138.61 83.2881 142.805C83.2881 147 89.3605 150.401 96.8512 150.401Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M96.8506 149.97C103.917 149.97 109.646 146.762 109.646 142.805C109.646 138.847 103.917 135.639 96.8506 135.639C89.7842 135.639 84.0557 138.847 84.0557 142.805C84.0557 146.762 89.7842 149.97 96.8506 149.97Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M96.8499 149.54C103.492 149.54 108.877 146.524 108.877 142.804C108.877 139.084 103.492 136.068 96.8499 136.068C90.2078 136.068 84.8232 139.084 84.8232 142.804C84.8232 146.524 90.2078 149.54 96.8499 149.54Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8511 149.109C103.069 149.109 108.11 146.286 108.11 142.803C108.11 139.321 103.069 136.498 96.8511 136.498C90.6333 136.498 85.5928 139.321 85.5928 142.803C85.5928 146.286 90.6333 149.109 96.8511 149.109Z",
    fill: "#190C00"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M136.683 122.199C152.768 122.199 165.808 114.895 165.808 105.886C165.808 96.8774 152.768 89.5742 136.683 89.5742C120.597 89.5742 107.557 96.8774 107.557 105.886C107.557 114.895 120.597 122.199 136.683 122.199Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M136.683 121.877C152.453 121.877 165.237 114.717 165.237 105.885C165.237 97.0526 152.453 89.8926 136.683 89.8926C120.912 89.8926 108.128 97.0526 108.128 105.885C108.128 114.717 120.912 121.877 136.683 121.877Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M136.683 121.558C152.138 121.558 164.666 114.541 164.666 105.885C164.666 97.2296 152.138 90.2129 136.683 90.2129C121.228 90.2129 108.699 97.2296 108.699 105.885C108.699 114.541 121.228 121.558 136.683 121.558Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M136.682 121.238C151.821 121.238 164.094 114.364 164.094 105.886C164.094 97.4067 151.821 90.5332 136.682 90.5332C121.542 90.5332 109.27 97.4067 109.27 105.886C109.27 114.364 121.542 121.238 136.682 121.238Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M136.682 120.918C151.506 120.918 163.523 114.188 163.523 105.886C163.523 97.5838 151.506 90.8535 136.682 90.8535C121.858 90.8535 109.841 97.5838 109.841 105.886C109.841 114.188 121.858 120.918 136.682 120.918Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M136.682 120.599C151.19 120.599 162.952 114.012 162.952 105.886C162.952 97.7609 151.19 91.1738 136.682 91.1738C122.174 91.1738 110.412 97.7609 110.412 105.886C110.412 114.012 122.174 120.599 136.682 120.599Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M136.682 120.278C150.875 120.278 162.381 113.834 162.381 105.885C162.381 97.936 150.875 91.4922 136.682 91.4922C122.489 91.4922 110.983 97.936 110.983 105.885C110.983 113.834 122.489 120.278 136.682 120.278Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M136.682 119.958C150.56 119.958 161.809 113.657 161.809 105.885C161.809 98.1131 150.56 91.8125 136.682 91.8125C122.805 91.8125 111.555 98.1131 111.555 105.885C111.555 113.657 122.805 119.958 136.682 119.958Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M136.683 119.638C150.245 119.638 161.239 113.481 161.239 105.886C161.239 98.2902 150.245 92.1328 136.683 92.1328C123.121 92.1328 112.127 98.2902 112.127 105.886C112.127 113.481 123.121 119.638 136.683 119.638Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M136.683 119.319C149.93 119.319 160.668 113.305 160.668 105.886C160.668 98.4672 149.93 92.4531 136.683 92.4531C123.437 92.4531 112.698 98.4672 112.698 105.886C112.698 113.305 123.437 119.319 136.683 119.319Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M136.683 118.999C149.614 118.999 160.097 113.129 160.097 105.886C160.097 98.6443 149.614 92.7734 136.683 92.7734C123.752 92.7734 113.27 98.6443 113.27 105.886C113.27 113.129 123.752 118.999 136.683 118.999Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M136.682 118.68C149.298 118.68 159.525 112.952 159.525 105.887C159.525 98.8214 149.298 93.0938 136.682 93.0938C124.067 93.0938 113.84 98.8214 113.84 105.887C113.84 112.952 124.067 118.68 136.682 118.68Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M136.682 118.36C148.982 118.36 158.953 112.776 158.953 105.887C158.953 98.9985 148.982 93.4141 136.682 93.4141C124.382 93.4141 114.411 98.9985 114.411 105.887C114.411 112.776 124.382 118.36 136.682 118.36Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M136.682 118.039C148.667 118.039 158.382 112.598 158.382 105.886C158.382 99.1736 148.667 93.7324 136.682 93.7324C124.698 93.7324 114.982 99.1736 114.982 105.886C114.982 112.598 124.698 118.039 136.682 118.039Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M136.682 117.719C148.352 117.719 157.811 112.421 157.811 105.886C157.811 99.3507 148.352 94.0527 136.682 94.0527C125.013 94.0527 115.554 99.3507 115.554 105.886C115.554 112.421 125.013 117.719 136.682 117.719Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M136.683 117.4C148.036 117.4 157.24 112.245 157.24 105.886C157.24 99.5277 148.036 94.373 136.683 94.373C125.329 94.373 116.125 99.5277 116.125 105.886C116.125 112.245 125.329 117.4 136.683 117.4Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M136.683 117.08C147.721 117.08 156.669 112.069 156.669 105.887C156.669 99.7048 147.721 94.6934 136.683 94.6934C125.644 94.6934 116.696 99.7048 116.696 105.887C116.696 112.069 125.644 117.08 136.683 117.08Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M136.683 116.759C147.405 116.759 156.098 111.891 156.098 105.885C156.098 99.88 147.405 95.0117 136.683 95.0117C125.96 95.0117 117.268 99.88 117.268 105.885C117.268 111.891 125.96 116.759 136.683 116.759Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M136.683 116.439C147.09 116.439 155.527 111.714 155.527 105.886C155.527 100.057 147.09 95.332 136.683 95.332C126.276 95.332 117.839 100.057 117.839 105.886C117.839 111.714 126.276 116.439 136.683 116.439Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M136.682 116.12C146.774 116.12 154.954 111.538 154.954 105.886C154.954 100.234 146.774 95.6523 136.682 95.6523C126.59 95.6523 118.409 100.234 118.409 105.886C118.409 111.538 126.59 116.12 136.682 116.12Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M136.683 115.8C146.459 115.8 154.384 111.362 154.384 105.886C154.384 100.411 146.459 95.9727 136.683 95.9727C126.907 95.9727 118.981 100.411 118.981 105.886C118.981 111.362 126.907 115.8 136.683 115.8Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M136.682 115.479C146.143 115.479 153.812 111.183 153.812 105.885C153.812 100.586 146.143 96.291 136.682 96.291C127.221 96.291 119.552 100.586 119.552 105.885C119.552 111.183 127.221 115.479 136.682 115.479Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M136.682 115.159C145.827 115.159 153.241 111.007 153.241 105.885C153.241 100.763 145.827 96.6113 136.682 96.6113C127.537 96.6113 120.123 100.763 120.123 105.885C120.123 111.007 127.537 115.159 136.682 115.159Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.682 114.84C145.512 114.84 152.67 110.831 152.67 105.886C152.67 100.94 145.512 96.9316 136.682 96.9316C127.852 96.9316 120.694 100.94 120.694 105.886C120.694 110.831 127.852 114.84 136.682 114.84Z",
    fill: "#190C00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.906 80.3894L173.357 110.378V48.0862L122.906 18.0977V80.3894Z",
    fill: "url(#paint0_linear_3449_10546)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.735 82.2352L169.186 112.224V49.9319L118.735 19.9434V82.2352Z",
    fill: "#EEF0F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.357 48.0862L169.186 49.9316L118.735 19.943L122.906 18.0977L173.357 48.0862Z",
    fill: "url(#paint1_linear_3449_10546)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169.187 112.223L173.357 110.378V48.0859L169.187 49.9313V112.223Z",
    fill: "url(#paint2_linear_3449_10546)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.735 19.9434L169.186 49.9319V62.4436L118.735 32.455V19.9434Z",
    fill: "url(#paint3_linear_3449_10546)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.187 49.9313L173.357 48.0859V60.5976L169.187 62.443V49.9313Z",
    fill: "#DD8F05"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.955 44.0957L162.779 66.5784",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.955 50.3145L162.779 72.7972",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.955 56.5352L162.779 79.0179",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.955 62.7539L162.779 85.2366",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.955 68.9746L162.779 91.4573",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.955 75.1934L162.779 97.6761",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.588 48.6348V80.216",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.543 84.4051L163.994 114.394V52.1019L113.543 22.1133V84.4051Z",
    fill: "url(#paint4_linear_3449_10546)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.372 86.2507L159.823 116.239V53.9475L109.372 23.959V86.2507Z",
    fill: "url(#paint5_linear_3449_10546)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.994 52.1019L159.823 53.9473L109.372 23.9587L113.543 22.1133L163.994 52.1019Z",
    fill: "url(#paint6_linear_3449_10546)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.823 116.239L163.994 114.393V52.1016L159.823 53.9469V116.239Z",
    fill: "url(#paint7_linear_3449_10546)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.372 23.959L159.823 53.9475V66.4591L109.372 36.4706V23.959Z",
    fill: "url(#paint8_linear_3449_10546)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.823 53.9469L163.994 52.1016V64.6132L159.823 66.4585V53.9469Z",
    fill: "#385DA5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M115.591 48.1113L153.414 70.594",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.591 54.3301L153.414 76.8129",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M115.591 60.5508L153.414 83.0335",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M115.591 66.7695L153.414 89.2523",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M115.591 72.9902L153.414 95.473",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M115.591 79.209L153.414 101.692",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M123.224 52.6504V84.2317",
    stroke: "#92969E",
    strokeWidth: 4.7408,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M124.539 56.9667C124.528 56.8254 124.511 56.6829 124.497 56.5408C124.477 56.341 124.464 56.1424 124.438 55.9411C124.427 55.853 124.405 55.7635 124.392 55.6753C124.347 55.3559 124.289 55.0353 124.227 54.7135C124.199 54.5655 124.183 54.4193 124.151 54.271C124.136 54.1997 124.115 54.128 124.099 54.0567C124.053 53.8518 124 53.647 123.948 53.4418C123.902 53.2574 123.864 53.0735 123.813 52.889C123.784 52.7865 123.748 52.6838 123.718 52.5813C123.67 52.416 123.619 52.2512 123.567 52.086C123.523 51.9446 123.485 51.803 123.438 51.6616C123.377 51.4813 123.308 51.302 123.244 51.122C123.196 50.9892 123.151 50.8566 123.101 50.7241C123.076 50.6578 123.055 50.5912 123.03 50.5249C122.89 50.1631 122.743 49.8028 122.588 49.4444C122.581 49.4303 122.575 49.4166 122.568 49.4024C122.546 49.3521 122.522 49.3025 122.5 49.2522C122.373 48.9668 122.245 48.6818 122.109 48.3992C122.058 48.2932 122.002 48.1893 121.949 48.0839C121.889 47.9632 121.828 47.8433 121.766 47.7235C121.707 47.6077 121.651 47.4902 121.59 47.3752C121.459 47.1278 121.319 46.8841 121.18 46.6403C121.141 46.5703 121.103 46.4993 121.063 46.4297C121.05 46.407 121.038 46.3835 121.025 46.3608C120.824 46.0169 120.616 45.6772 120.402 45.3424C120.371 45.293 120.337 45.246 120.305 45.197C120.229 45.0793 120.149 44.9647 120.071 44.8482C119.949 44.6659 119.831 44.4807 119.705 44.3015C119.63 44.1953 119.551 44.0946 119.475 43.9895C119.364 43.8365 119.252 43.6852 119.139 43.5347C119.06 43.429 118.984 43.3192 118.903 43.2148C118.804 43.0869 118.698 42.9676 118.597 42.8419C118.442 42.6495 118.287 42.4585 118.128 42.2715C118.06 42.1906 117.995 42.1047 117.926 42.0248C117.843 41.9296 117.753 41.8452 117.669 41.7515C117.406 41.4586 117.139 41.1741 116.867 40.8972C116.779 40.8084 116.698 40.7101 116.61 40.6231C116.526 40.541 116.439 40.4665 116.355 40.3859C116.22 40.2569 116.084 40.131 115.947 40.0059C115.723 39.8018 115.497 39.6047 115.268 39.4124C115.13 39.2971 114.994 39.1816 114.855 39.0706C114.605 38.8717 114.352 38.6842 114.097 38.5003C113.975 38.4127 113.856 38.3206 113.733 38.2365C113.355 37.9768 112.972 37.7306 112.585 37.5065C112.328 37.3583 112.073 37.2238 111.82 37.0961C111.748 37.0596 111.676 37.0253 111.604 36.9904C111.411 36.8967 111.219 36.8091 111.028 36.7272C110.985 36.7088 110.94 36.6856 110.898 36.6676C110.874 36.6579 110.851 36.6507 110.828 36.6411C110.648 36.5678 110.47 36.5008 110.293 36.4379C110.25 36.4225 110.206 36.4044 110.163 36.3896C109.944 36.3145 109.727 36.2482 109.513 36.1891C109.502 36.1861 109.49 36.1818 109.479 36.1788C109.46 36.1736 109.441 36.1717 109.422 36.1665C109.083 36.0767 108.75 36.0039 108.424 35.9534C108.424 35.9534 108.421 35.9528 108.419 35.9526L108.418 35.9523C108.144 35.9103 107.877 35.8865 107.612 35.8717C107.582 35.87 107.551 35.8638 107.521 35.8625C107.498 35.8614 107.476 35.864 107.453 35.8629C107.216 35.8545 106.983 35.8552 106.755 35.8686C106.745 35.8692 106.734 35.8683 106.724 35.8689C106.694 35.8708 106.666 35.8768 106.636 35.879C106.452 35.8931 106.271 35.9146 106.093 35.9426C106.061 35.9477 106.027 35.9485 105.996 35.9539C105.972 35.9581 105.95 35.9656 105.926 35.97C105.721 36.008 105.52 36.0523 105.324 36.1088L105.319 36.1098C105.312 36.112 105.305 36.1154 105.298 36.1176C105.112 36.1723 104.932 36.2376 104.755 36.3091C104.731 36.3185 104.707 36.3245 104.683 36.3342C104.655 36.346 104.629 36.3623 104.601 36.3745C104.449 36.4406 104.301 36.513 104.157 36.5917C104.131 36.6054 104.103 36.6155 104.079 36.6296C104.057 36.642 104.034 36.6548 104.012 36.6674L99.0449 39.5532C99.092 39.526 99.1409 39.5035 99.1886 39.4777C99.3334 39.3989 99.4818 39.3266 99.6332 39.2603C99.6843 39.2379 99.7353 39.2158 99.787 39.1948C99.9643 39.1233 100.145 39.058 100.33 39.0033C100.339 39.0006 100.347 38.9971 100.357 38.9946C100.552 38.9381 100.754 38.8938 100.958 38.856C101.013 38.8458 101.069 38.8374 101.125 38.8284C101.303 38.8002 101.484 38.7789 101.669 38.765C101.708 38.762 101.747 38.7568 101.788 38.7545C102.016 38.7412 102.249 38.7404 102.485 38.749C102.538 38.7508 102.592 38.7545 102.645 38.7575C102.909 38.7723 103.177 38.7962 103.45 38.8383L103.456 38.8393C103.782 38.8897 104.115 38.9627 104.454 39.0524C104.485 39.0605 104.515 39.0667 104.545 39.0753C104.76 39.1342 104.976 39.2005 105.195 39.2753C105.239 39.2904 105.283 39.3087 105.327 39.3243C105.504 39.3871 105.681 39.4538 105.86 39.5271C105.927 39.5543 105.994 39.5847 106.061 39.6132C106.251 39.6949 106.443 39.7827 106.637 39.8764C106.709 39.9111 106.781 39.9455 106.853 39.9819C107.106 40.1099 107.36 40.2443 107.617 40.3925C108.005 40.6164 108.388 40.8628 108.766 41.1224C108.888 41.2065 109.008 41.2988 109.129 41.3863C109.384 41.5701 109.637 41.7579 109.887 41.9568C110.026 42.0674 110.163 42.1832 110.3 42.2983C110.529 42.4905 110.756 42.6879 110.98 42.892C111.117 43.0168 111.253 43.1429 111.388 43.272C111.561 43.4377 111.73 43.6108 111.9 43.7834C112.172 44.0601 112.44 44.345 112.702 44.6377C112.856 44.8094 113.01 44.9801 113.161 45.157C113.32 45.3444 113.475 45.536 113.63 45.7287C113.813 45.9565 113.995 46.1857 114.172 46.4206C114.285 46.5709 114.397 46.7227 114.507 46.8757C114.711 47.1577 114.91 47.4441 115.104 47.7345C115.182 47.8509 115.261 47.9656 115.338 48.0833C115.599 48.4879 115.853 48.8984 116.096 49.3158C116.136 49.3854 116.173 49.4568 116.213 49.5268C116.416 49.8838 116.612 50.2448 116.799 50.6094C116.861 50.7292 116.922 50.8494 116.982 50.9701C117.174 51.3563 117.358 51.7457 117.532 52.138C117.554 52.1885 117.579 52.2382 117.601 52.2885C117.792 52.7264 117.968 53.168 118.134 53.6108C118.183 53.7427 118.229 53.8751 118.276 54.0074C118.391 54.3281 118.498 54.6492 118.599 54.9707C118.652 55.1366 118.703 55.3024 118.751 55.4682C118.835 55.7544 118.908 56.0404 118.98 56.3264C119.032 56.5319 119.086 56.7375 119.131 56.9426C119.18 57.1625 119.218 57.3808 119.26 57.5999C119.321 57.9211 119.379 58.2421 119.425 58.561C119.466 58.8509 119.501 59.1396 119.53 59.4268C119.543 59.5688 119.561 59.7115 119.571 59.8525C119.605 60.3007 119.626 60.7459 119.625 61.184C119.614 64.981 118.273 67.6524 116.11 68.9086L121.078 66.0228C123.241 64.7665 124.582 62.0952 124.592 58.2982C124.594 57.8597 124.572 57.4147 124.539 56.9667Z",
    fill: "url(#paint9_linear_3449_10546)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.617 40.3942C100.964 36.554 95.553 39.6367 95.5313 47.2796C95.5097 54.9225 100.886 64.231 107.539 68.0711C114.192 71.9113 119.603 68.8287 119.625 61.1858C119.647 53.5428 114.271 44.2343 107.617 40.3942Z",
    fill: "url(#paint10_linear_3449_10546)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M105.029 59.1047C104.432 59.1047 103.839 58.9543 103.309 58.6588C102.449 58.1788 101.825 57.3543 101.597 56.3956L99.858 49.082C99.6821 48.3428 100.139 47.6016 100.878 47.4264C101.616 47.2505 102.358 47.7064 102.534 48.4456L104.273 55.7598C104.342 56.0485 104.538 56.1956 104.649 56.2573C104.761 56.3191 104.986 56.4098 105.27 56.3164L113.381 53.6315C114.105 53.3932 114.881 53.784 115.12 54.5044C115.359 55.2254 114.968 56.0036 114.246 56.2419L106.135 58.9268C105.776 59.0463 105.402 59.1047 105.029 59.1047Z",
    fill: "#FBFBFB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M115.463 33.9846C115.463 34.8532 114.981 35.2733 114.385 34.923C113.789 34.5728 113.307 33.5848 113.307 32.7163C113.307 31.8477 113.789 31.4276 114.385 31.7778C114.981 32.128 115.463 33.1161 115.463 33.9846Z",
    fill: "#FBFBFB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M118.688 37.1994C119.189 37.0241 119.334 36.1362 119.012 35.2162C118.689 34.2963 118.022 33.6927 117.521 33.868C117.02 34.0434 116.875 34.9313 117.198 35.8512C117.52 36.7712 118.187 37.3748 118.688 37.1994Z",
    fill: "#FBFBFB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M122.409 39.3869C122.91 39.2116 123.055 38.3237 122.732 37.4037C122.41 36.4838 121.743 35.8802 121.242 36.0555C120.741 36.2309 120.596 37.1188 120.918 38.0387C121.241 38.9587 121.908 39.5623 122.409 39.3869Z",
    fill: "#FBFBFB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M110.179 159.488V161.58C110.935 161.647 111.708 161.482 112.382 161.076L140.651 144.028C141.511 143.508 141.891 140.672 141.248 139.998C141.158 140.093 140.774 141.857 140.651 141.932L112.382 158.984C111.708 159.389 110.935 159.559 110.179 159.488Z",
    fill: "url(#paint11_linear_3449_10546)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1201 135.789L108.689 161.107C109.154 161.378 109.663 161.532 110.179 161.579V159.487C110.936 159.558 111.708 159.389 112.382 158.983L140.652 141.931C140.774 141.856 140.881 141.769 140.971 141.675C140.873 141.573 140.758 141.482 140.628 141.407L116.158 127.188L96.6373 115.845C95.6481 115.27 94.4224 115.278 93.441 115.872L66.1533 131.603C65.9878 131.706 64.1032 131.517 64.4471 132.237C63.8246 132.985 64.2097 135.261 65.1201 135.789Z",
    fill: "url(#paint12_linear_3449_10546)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2598 74.4785V109.471C96.2598 110.492 96.8036 111.434 97.6864 111.946L143.656 138.58C143.81 138.666 143.51 139.64 143.667 139.667C144.593 139.864 145.997 138.253 145.997 137.232V102.598C145.997 101.963 145.855 101.349 145.587 100.801L143.656 101.987C143.301 101.305 142.753 100.726 142.06 100.324L97.0794 74.2618C96.8351 74.1199 96.5751 74.0412 96.3188 74.0254C96.2795 74.1672 96.2598 74.3209 96.2598 74.4785Z",
    fill: "url(#paint13_linear_3449_10546)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4033 75.8023V110.799C94.4033 111.82 94.9471 112.761 95.83 113.274L141.8 139.904C142.777 140.471 143.991 139.837 144.125 138.753C144.133 138.69 144.137 138.623 144.137 138.556V103.926C144.137 103.24 143.967 102.574 143.656 101.987C143.301 101.305 142.753 100.726 142.06 100.325L97.0793 74.262C96.835 74.12 96.5749 74.0413 96.3187 74.0255C96.0389 74.0019 95.7669 74.0492 95.5148 74.1515L95.5029 74.1556C95.2309 74.2697 94.9867 74.4471 94.8014 74.6794L94.7975 74.6835C94.553 74.9827 94.4033 75.365 94.4033 75.8023Z",
    fill: "#525575"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M142.461 103.926C142.461 103.523 142.362 103.124 142.175 102.772C141.957 102.353 141.628 102.011 141.219 101.774L96.2388 75.7119L96.2199 75.7107L96.1784 75.6953L96.1157 75.7207L96.088 75.7538C96.0829 75.7626 96.0791 75.776 96.0791 75.8026V110.8C96.0791 111.221 96.3058 111.613 96.671 111.825L142.462 138.351L142.461 103.926Z",
    fill: "url(#paint14_linear_3449_10546)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5146 74.1513C95.7668 74.0489 96.0387 74.0016 96.3186 74.0253C96.5748 74.0411 96.8349 74.1197 97.0792 74.2617L142.06 100.324C142.753 100.726 143.301 101.305 143.656 101.987L145.587 100.801C145.232 100.056 144.657 99.422 143.92 98.9964L141.157 97.3968L98.9355 72.9339C98.23 72.5242 97.4142 72.6621 96.8743 73.1347L96.8625 73.1426L95.5146 74.1513Z",
    fill: "url(#paint15_linear_3449_10546)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6831 133.327C64.7975 133.469 64.9472 133.595 65.1206 133.697L108.69 159.011C109.155 159.279 109.663 159.441 110.18 159.488C110.936 159.559 111.709 159.39 112.383 158.984L140.653 141.932C140.775 141.857 140.881 141.77 140.972 141.676C141.622 140.994 141.508 139.824 140.629 139.316L119.761 127.189L96.6379 113.754C95.6487 113.178 94.423 113.186 93.4416 113.777L65.0969 130.873C64.2023 131.412 64.0645 132.59 64.6831 133.327Z",
    fill: "url(#paint16_linear_3449_10546)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M80.132 127.475L115.959 148.364C116.558 148.712 117.299 148.706 117.893 148.348L132.708 139.414C133.227 139.101 133.221 138.346 132.696 138.041L96.649 117.023C96.1298 116.722 95.4874 116.727 94.9732 117.037L80.1199 125.995C79.5602 126.332 79.5668 127.146 80.132 127.475Z",
    fill: "#525575"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M124.043 136.369L125.253 135.637C125.295 135.611 125.347 135.611 125.389 135.635L126.695 136.39C126.738 136.415 126.738 136.476 126.696 136.501L125.489 137.232C125.44 137.261 125.38 137.262 125.331 137.234L124.044 136.489C123.998 136.462 123.997 136.397 124.043 136.369Z",
    fill: "#3D415B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M123.39 136.003C123.342 136.032 123.281 136.033 123.233 136.005L121.945 135.26C121.899 135.234 121.898 135.168 121.944 135.14L123.154 134.408C123.196 134.383 123.248 134.382 123.291 134.406L124.596 135.162C124.639 135.186 124.64 135.247 124.597 135.273L123.39 136.003Z",
    fill: "#3D415B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M121.292 134.776C121.243 134.806 121.183 134.807 121.134 134.779L119.846 134.034C119.8 134.007 119.8 133.941 119.845 133.914L121.056 133.182C121.097 133.156 121.15 133.156 121.192 133.18L122.498 133.935C122.54 133.959 122.541 134.021 122.498 134.046L121.292 134.776Z",
    fill: "#3D415B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M119.194 133.55C119.146 133.579 119.085 133.58 119.036 133.552L117.749 132.807C117.703 132.781 117.702 132.715 117.748 132.687L118.958 131.955C119 131.93 119.052 131.929 119.094 131.953L120.4 132.708C120.443 132.733 120.443 132.794 120.401 132.82L119.194 133.55Z",
    fill: "#3D415B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.095 132.323C117.047 132.353 116.986 132.353 116.938 132.325L115.65 131.581C115.604 131.554 115.604 131.488 115.649 131.46L116.859 130.728C116.901 130.703 116.954 130.703 116.996 130.727L118.301 131.482C118.344 131.506 118.345 131.567 118.302 131.593L117.095 132.323Z",
    fill: "#3D415B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.997 131.097C114.948 131.126 114.888 131.127 114.839 131.099L113.551 130.354C113.505 130.328 113.505 130.262 113.551 130.234L114.761 129.502C114.803 129.477 114.855 129.476 114.897 129.5L116.203 130.255C116.246 130.28 116.246 130.341 116.204 130.367L114.997 131.097Z",
    fill: "#3D415B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M112.898 129.87C112.85 129.899 112.789 129.9 112.74 129.872L111.453 129.127C111.407 129.101 111.406 129.035 111.452 129.007L112.662 128.275C112.704 128.25 112.756 128.249 112.799 128.274L114.104 129.029C114.147 129.053 114.147 129.114 114.105 129.14L112.898 129.87Z",
    fill: "#3D415B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M110.799 128.642C110.751 128.671 110.691 128.672 110.642 128.644L109.354 127.899C109.308 127.872 109.308 127.807 109.353 127.779L110.563 127.047C110.605 127.022 110.658 127.021 110.7 127.045L112.005 127.8C112.048 127.825 112.049 127.886 112.006 127.911L110.799 128.642Z",
    fill: "#3D415B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M108.701 127.415C108.652 127.444 108.592 127.445 108.543 127.417L107.256 126.672C107.209 126.646 107.209 126.58 107.255 126.552L108.465 125.82C108.507 125.795 108.559 125.794 108.601 125.818L109.907 126.574C109.95 126.598 109.95 126.659 109.908 126.685L108.701 127.415Z",
    fill: "#3D415B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M106.602 126.189C106.554 126.218 106.493 126.219 106.445 126.191L105.157 125.446C105.111 125.419 105.11 125.353 105.156 125.326L106.366 124.594C106.408 124.568 106.46 124.568 106.503 124.592L107.808 125.347C107.851 125.372 107.851 125.433 107.809 125.458L106.602 126.189Z",
    fill: "#3D415B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M104.503 124.962C104.455 124.991 104.395 124.992 104.346 124.964L103.058 124.219C103.012 124.193 103.012 124.127 103.057 124.099L104.268 123.367C104.309 123.342 104.362 123.341 104.404 123.365L105.71 124.121C105.752 124.145 105.753 124.206 105.711 124.232L104.503 124.962Z",
    fill: "#3D415B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M102.405 123.736C102.356 123.765 102.296 123.766 102.247 123.738L100.96 122.993C100.914 122.966 100.913 122.9 100.959 122.873L102.169 122.141C102.211 122.115 102.263 122.114 102.305 122.139L103.611 122.894C103.654 122.918 103.654 122.98 103.612 123.005L102.405 123.736Z",
    fill: "#3D415B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M100.306 122.507C100.258 122.536 100.197 122.537 100.149 122.509L98.861 121.764C98.8149 121.738 98.8145 121.672 98.8601 121.644L100.07 120.912C100.112 120.887 100.165 120.886 100.207 120.91L101.512 121.665C101.555 121.69 101.556 121.751 101.513 121.777L100.306 122.507Z",
    fill: "#3D415B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2075 121.28C98.1592 121.31 98.0988 121.31 98.05 121.282L96.7624 120.538C96.7163 120.511 96.7158 120.445 96.7615 120.418L97.9716 119.685C98.0136 119.66 98.0659 119.66 98.1081 119.684L99.4138 120.439C99.4565 120.463 99.457 120.524 99.4147 120.55L98.2075 121.28Z",
    fill: "#3D415B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M121.634 137.818L122.845 137.086C122.887 137.061 122.939 137.06 122.981 137.084L124.287 137.839C124.329 137.864 124.33 137.925 124.288 137.951L123.081 138.681C123.032 138.71 122.972 138.711 122.923 138.683L121.635 137.938C121.589 137.912 121.589 137.846 121.634 137.818Z",
    fill: "#3D415B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M120.882 135.858L122.188 136.613C122.231 136.637 122.231 136.698 122.189 136.724L120.982 137.454C120.934 137.483 120.873 137.484 120.824 137.456L119.537 136.711C119.491 136.685 119.49 136.619 119.536 136.591L120.746 135.859C120.788 135.834 120.84 135.833 120.882 135.858Z",
    fill: "#3D415B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M118.727 136.23L117.439 135.485C117.393 135.458 117.393 135.393 117.438 135.365L118.648 134.633C118.69 134.607 118.743 134.607 118.785 134.631L120.09 135.386C120.133 135.411 120.134 135.472 120.091 135.497L118.884 136.228C118.836 136.257 118.776 136.258 118.727 136.23Z",
    fill: "#3D415B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M116.686 133.404L117.992 134.16C118.035 134.184 118.035 134.245 117.993 134.271L116.786 135.001C116.737 135.03 116.677 135.031 116.628 135.003L115.341 134.258C115.294 134.232 115.294 134.166 115.34 134.138L116.55 133.406C116.592 133.381 116.644 133.38 116.686 133.404Z",
    fill: "#3D415B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M114.588 132.178L115.893 132.933C115.936 132.958 115.936 133.019 115.894 133.044L114.687 133.775C114.639 133.804 114.578 133.805 114.53 133.777L113.242 133.032C113.196 133.005 113.195 132.939 113.241 132.912L114.451 132.18C114.493 132.154 114.545 132.154 114.588 132.178Z",
    fill: "#3D415B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M112.489 130.949L113.795 131.705C113.837 131.729 113.838 131.79 113.795 131.816L112.588 132.546C112.54 132.575 112.48 132.576 112.431 132.548L111.143 131.803C111.097 131.777 111.097 131.711 111.142 131.683L112.352 130.951C112.394 130.926 112.447 130.925 112.489 130.949Z",
    fill: "#3D415B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M110.39 129.723L111.696 130.478C111.739 130.502 111.739 130.564 111.697 130.589L110.49 131.319C110.441 131.349 110.381 131.35 110.332 131.321L109.045 130.577C108.999 130.55 108.998 130.484 109.044 130.457L110.254 129.724C110.296 129.699 110.348 129.699 110.39 129.723Z",
    fill: "#3D415B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M108.292 128.496L109.597 129.251C109.64 129.276 109.64 129.337 109.598 129.363L108.391 130.093C108.343 130.122 108.282 130.123 108.234 130.095L106.946 129.35C106.9 129.324 106.899 129.258 106.945 129.23L108.155 128.498C108.197 128.473 108.249 128.472 108.292 128.496Z",
    fill: "#3D415B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M106.193 127.27L107.499 128.025C107.541 128.049 107.542 128.11 107.5 128.136L106.293 128.866C106.244 128.896 106.184 128.896 106.135 128.868L104.847 128.123C104.801 128.097 104.801 128.031 104.846 128.003L106.057 127.271C106.098 127.246 106.151 127.245 106.193 127.27Z",
    fill: "#3D415B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M104.095 126.043L105.4 126.798C105.443 126.823 105.443 126.884 105.401 126.91L104.194 127.64C104.145 127.669 104.085 127.67 104.036 127.642L102.749 126.897C102.703 126.871 102.702 126.805 102.748 126.777L103.958 126.045C104 126.02 104.052 126.019 104.095 126.043Z",
    fill: "#3D415B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M101.996 124.816L103.301 125.572C103.344 125.596 103.345 125.657 103.302 125.683L102.095 126.413C102.047 126.442 101.987 126.443 101.938 126.415L100.65 125.67C100.604 125.644 100.603 125.578 100.649 125.55L101.859 124.818C101.901 124.793 101.954 124.792 101.996 124.816Z",
    fill: "#3D415B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8973 123.588L101.203 124.343C101.245 124.368 101.246 124.429 101.204 124.454L99.9966 125.185C99.9482 125.214 99.8879 125.215 99.8391 125.187L98.5515 124.442C98.5054 124.415 98.5049 124.349 98.5505 124.322L99.7607 123.59C99.8026 123.564 99.8549 123.564 99.8973 123.588Z",
    fill: "#3D415B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4518 123.095L97.6621 122.363C97.7039 122.338 97.7563 122.337 97.7986 122.361L99.1041 123.117C99.1468 123.141 99.1474 123.202 99.105 123.228L97.898 123.958C97.8496 123.987 97.7892 123.988 97.7404 123.96L96.4528 123.215C96.4068 123.189 96.4063 123.123 96.4518 123.095Z",
    fill: "#3D415B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0064 121.999L95.7993 122.73C95.7509 122.759 95.6906 122.76 95.6418 122.732L94.3542 121.987C94.3081 121.96 94.3076 121.894 94.3532 121.867L95.5634 121.135C95.6053 121.109 95.6576 121.109 95.6999 121.133L97.0054 121.888C97.0482 121.913 97.0487 121.974 97.0064 121.999Z",
    fill: "#3D415B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M117.129 138.163C117.083 138.136 117.082 138.07 117.128 138.043L118.338 137.311C118.38 137.285 118.432 137.285 118.474 137.309L118.968 137.594C118.97 137.595 118.974 137.595 118.976 137.596L119.487 137.895L119.78 138.064C119.781 138.064 119.78 138.066 119.781 138.066L121.878 139.291C121.921 139.315 121.922 139.376 121.879 139.402L120.672 140.132C120.624 140.162 120.564 140.162 120.515 140.134L118.149 138.753L117.129 138.163Z",
    fill: "#3D415B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M116.475 137.679C116.427 137.708 116.366 137.709 116.318 137.681L115.03 136.936C114.984 136.91 114.983 136.844 115.029 136.816L116.239 136.084C116.281 136.059 116.333 136.058 116.376 136.082L117.681 136.837C117.724 136.862 117.724 136.923 117.682 136.949L116.475 137.679Z",
    fill: "#3D415B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M114.277 134.854L115.583 135.609C115.625 135.633 115.626 135.694 115.584 135.72L114.376 136.45C114.328 136.479 114.268 136.48 114.219 136.452L112.931 135.707C112.885 135.681 112.885 135.615 112.93 135.588L114.141 134.855C114.182 134.83 114.235 134.829 114.277 134.854Z",
    fill: "#3D415B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M112.178 133.627L113.484 134.382C113.527 134.407 113.527 134.468 113.485 134.493L112.278 135.224C112.23 135.253 112.169 135.254 112.12 135.226L110.833 134.481C110.787 134.454 110.786 134.388 110.832 134.361L112.042 133.629C112.084 133.604 112.136 133.603 112.178 133.627Z",
    fill: "#3D415B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M110.08 132.4L111.385 133.156C111.428 133.18 111.429 133.241 111.386 133.267L110.179 133.997C110.131 134.026 110.07 134.027 110.022 133.999L108.734 133.254C108.688 133.228 108.688 133.162 108.733 133.134L109.943 132.402C109.985 132.377 110.037 132.376 110.08 132.4Z",
    fill: "#3D415B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M107.981 131.174L109.287 131.929C109.329 131.954 109.33 132.015 109.288 132.04L108.081 132.771C108.032 132.8 107.972 132.801 107.923 132.773L106.635 132.028C106.589 132.001 106.589 131.935 106.634 131.908L107.845 131.176C107.887 131.15 107.939 131.15 107.981 131.174Z",
    fill: "#3D415B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M105.883 129.947L107.188 130.703C107.231 130.727 107.231 130.788 107.189 130.814L105.982 131.544C105.934 131.573 105.873 131.574 105.824 131.546L104.537 130.801C104.491 130.775 104.49 130.709 104.536 130.681L105.746 129.949C105.788 129.924 105.84 129.923 105.883 129.947Z",
    fill: "#3D415B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M103.784 128.719L105.089 129.474C105.132 129.499 105.133 129.56 105.09 129.585L103.883 130.316C103.835 130.345 103.775 130.346 103.726 130.318L102.438 129.573C102.392 129.546 102.392 129.48 102.437 129.453L103.647 128.721C103.689 128.695 103.742 128.695 103.784 128.719Z",
    fill: "#3D415B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M101.685 127.492L102.991 128.248C103.034 128.272 103.034 128.333 102.992 128.359L101.785 129.089C101.736 129.118 101.676 129.119 101.627 129.091L100.34 128.346C100.293 128.32 100.293 128.254 100.339 128.226L101.549 127.494C101.591 127.469 101.643 127.468 101.685 127.492Z",
    fill: "#3D415B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5285 127.865L98.2409 127.119C98.1949 127.093 98.1943 127.027 98.2399 127L99.4501 126.268C99.492 126.242 99.5443 126.242 99.5866 126.266L100.892 127.021C100.935 127.045 100.935 127.107 100.893 127.132L99.686 127.862C99.6378 127.892 99.5773 127.892 99.5285 127.865Z",
    fill: "#3D415B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3514 125.041C97.3933 125.016 97.4456 125.015 97.4879 125.039L98.7936 125.794C98.8363 125.819 98.8368 125.88 98.7944 125.906L97.5874 126.636C97.539 126.665 97.4787 126.666 97.4298 126.638L96.1423 125.893C96.0962 125.867 96.0957 125.801 96.1413 125.773L97.3514 125.041Z",
    fill: "#3D415B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3902 123.811L96.6958 124.566C96.7385 124.591 96.739 124.652 96.6967 124.678L95.4897 125.408C95.4413 125.437 95.3809 125.438 95.3321 125.41L94.8813 125.149C94.8749 125.146 94.8676 125.147 94.8614 125.144L91.946 123.438C91.9 123.412 91.8994 123.346 91.945 123.318L93.1552 122.586C93.1971 122.561 93.2494 122.56 93.2917 122.584L95.3878 123.81C95.3876 123.81 95.3894 123.811 95.3902 123.811Z",
    fill: "#3D415B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M116.817 140.72L118.027 139.988C118.069 139.963 118.121 139.962 118.164 139.986L119.469 140.742C119.512 140.766 119.513 140.827 119.47 140.853L118.263 141.583C118.215 141.612 118.155 141.613 118.106 141.585L116.818 140.84C116.772 140.814 116.771 140.748 116.817 140.72Z",
    fill: "#3D415B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M117.373 139.624L116.166 140.355C116.117 140.384 116.057 140.385 116.008 140.357L114.72 139.612C114.674 139.585 114.674 139.519 114.719 139.492L115.93 138.76C115.972 138.734 116.024 138.734 116.066 138.758L117.372 139.513C117.414 139.538 117.415 139.599 117.373 139.624Z",
    fill: "#3D415B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M115.274 138.398L114.067 139.128C114.019 139.157 113.958 139.158 113.909 139.13L112.622 138.385C112.576 138.359 112.575 138.293 112.621 138.265L113.831 137.533C113.873 137.508 113.925 137.507 113.967 137.531L115.273 138.287C115.316 138.311 115.316 138.372 115.274 138.398Z",
    fill: "#3D415B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M111.811 137.903L110.523 137.159C110.477 137.132 110.477 137.066 110.522 137.039L111.732 136.307C111.774 136.281 111.827 136.281 111.869 136.305L113.174 137.06C113.217 137.084 113.218 137.146 113.175 137.171L111.968 137.901C111.92 137.931 111.86 137.931 111.811 137.903Z",
    fill: "#3D415B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M109.712 136.677L108.424 135.932C108.378 135.906 108.378 135.84 108.424 135.812L109.634 135.08C109.676 135.055 109.728 135.054 109.77 135.078L111.076 135.833C111.119 135.858 111.119 135.919 111.077 135.945L109.87 136.675C109.821 136.704 109.761 136.705 109.712 136.677Z",
    fill: "#3D415B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M107.613 135.451L106.326 134.705C106.28 134.679 106.279 134.613 106.325 134.586L107.535 133.853C107.577 133.828 107.629 133.827 107.672 133.852L108.977 134.607C109.02 134.631 109.02 134.693 108.978 134.718L107.771 135.448C107.723 135.477 107.662 135.478 107.613 135.451Z",
    fill: "#3D415B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M105.515 134.224L104.227 133.479C104.181 133.453 104.181 133.387 104.226 133.359L105.437 132.627C105.478 132.602 105.531 132.601 105.573 132.625L106.879 133.38C106.921 133.405 106.922 133.466 106.879 133.492L105.672 134.222C105.624 134.251 105.564 134.252 105.515 134.224Z",
    fill: "#3D415B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M103.416 132.995L102.129 132.25C102.083 132.224 102.082 132.158 102.128 132.131L103.338 131.399C103.38 131.373 103.432 131.372 103.474 131.397L104.78 132.152C104.823 132.176 104.823 132.237 104.781 132.263L103.574 132.993C103.525 133.023 103.465 133.023 103.416 132.995Z",
    fill: "#3D415B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M101.318 131.769L100.03 131.024C99.9839 130.997 99.9834 130.932 100.029 130.904L101.239 130.172C101.281 130.146 101.333 130.146 101.376 130.17L102.681 130.925C102.724 130.95 102.724 131.011 102.682 131.036L101.475 131.767C101.427 131.796 101.366 131.797 101.318 131.769Z",
    fill: "#3D415B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2189 130.542L97.9313 129.797C97.8853 129.771 97.8848 129.705 97.9304 129.677L99.1406 128.945C99.1825 128.92 99.2348 128.919 99.2771 128.944L100.583 129.699C100.625 129.723 100.626 129.784 100.584 129.81L99.3765 130.54C99.3282 130.569 99.2678 130.57 99.2189 130.542Z",
    fill: "#3D415B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1204 129.314L95.8327 128.569C95.7867 128.542 95.7861 128.476 95.8317 128.449L97.042 127.717C97.0839 127.691 97.1362 127.691 97.1784 127.715L98.484 128.47C98.5267 128.495 98.5272 128.556 98.4849 128.581L97.2779 129.312C97.2296 129.341 97.1692 129.342 97.1204 129.314Z",
    fill: "#3D415B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0808 126.488L96.3863 127.244C96.4291 127.268 96.4295 127.329 96.3872 127.355L95.1802 128.085C95.1319 128.114 95.0715 128.115 95.0226 128.087L93.735 127.342C93.689 127.316 93.6885 127.25 93.7341 127.222L94.9443 126.49C94.9861 126.465 95.0385 126.464 95.0808 126.488Z",
    fill: "#3D415B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M92.924 126.861L91.6364 126.116C91.5904 126.089 91.5898 126.023 91.6354 125.996L92.8457 125.264C92.8876 125.238 92.9399 125.238 92.9821 125.262L94.2877 126.017C94.3304 126.042 94.3309 126.103 94.2886 126.128L93.0816 126.858C93.0333 126.888 92.9729 126.889 92.924 126.861Z",
    fill: "#3D415B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M92.19 124.902L90.983 125.632C90.9346 125.661 90.8742 125.662 90.8254 125.634L89.5378 124.889C89.4918 124.863 89.4912 124.797 89.5368 124.769L90.7471 124.037C90.7889 124.012 90.8413 124.011 90.8835 124.035L92.1891 124.791C92.2317 124.815 92.2322 124.876 92.19 124.902Z",
    fill: "#3D415B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M114.409 142.169L115.619 141.437C115.661 141.412 115.713 141.412 115.756 141.436L117.061 142.191C117.104 142.215 117.104 142.276 117.062 142.302L115.855 143.032C115.807 143.062 115.746 143.062 115.697 143.034L114.41 142.29C114.364 142.263 114.363 142.197 114.409 142.169Z",
    fill: "#3D415B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M113.756 141.806C113.708 141.835 113.648 141.836 113.599 141.808L112.311 141.063C112.265 141.037 112.265 140.971 112.31 140.943L113.521 140.211C113.562 140.186 113.615 140.185 113.657 140.209L114.963 140.964C115.005 140.989 115.006 141.05 114.963 141.076L113.756 141.806Z",
    fill: "#3D415B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 140.581L110.213 139.836C110.167 139.81 110.166 139.744 110.212 139.716L111.422 138.984C111.464 138.959 111.516 138.958 111.558 138.983L112.864 139.738C112.907 139.762 112.907 139.823 112.865 139.849L111.658 140.579C111.61 140.608 111.549 140.609 111.5 140.581Z",
    fill: "#3D415B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M109.402 139.355L108.114 138.61C108.068 138.583 108.067 138.517 108.113 138.49L109.323 137.758C109.365 137.732 109.417 137.732 109.46 137.756L110.765 138.511C110.808 138.536 110.808 138.597 110.766 138.622L109.559 139.352C109.511 139.382 109.45 139.383 109.402 139.355Z",
    fill: "#3D415B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M107.303 138.126L106.015 137.381C105.969 137.355 105.969 137.289 106.014 137.261L107.225 136.529C107.266 136.504 107.319 136.503 107.361 136.527L108.667 137.283C108.709 137.307 108.71 137.368 108.668 137.394L107.46 138.124C107.412 138.153 107.352 138.154 107.303 138.126Z",
    fill: "#3D415B"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M105.204 136.9L103.917 136.155C103.871 136.128 103.87 136.062 103.916 136.035L105.126 135.303C105.168 135.277 105.22 135.277 105.262 135.301L106.568 136.056C106.611 136.081 106.611 136.142 106.569 136.167L105.362 136.898C105.314 136.927 105.253 136.928 105.204 136.9Z",
    fill: "#3D415B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M103.106 135.673L101.818 134.928C101.772 134.902 101.771 134.836 101.817 134.808L103.027 134.076C103.069 134.051 103.122 134.05 103.164 134.074L104.469 134.83C104.512 134.854 104.513 134.915 104.47 134.941L103.263 135.671C103.215 135.7 103.155 135.701 103.106 135.673Z",
    fill: "#3D415B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M101.008 134.447L99.7205 133.702C99.6744 133.675 99.6738 133.609 99.7194 133.582L100.93 132.85C100.972 132.824 101.024 132.823 101.066 132.848L102.372 133.603C102.415 133.627 102.415 133.689 102.373 133.714L101.166 134.444C101.117 134.474 101.057 134.474 101.008 134.447Z",
    fill: "#3D415B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9094 133.22L97.6218 132.475C97.5757 132.449 97.5752 132.383 97.6208 132.355L98.8311 131.623C98.8729 131.598 98.9252 131.597 98.9676 131.621L100.273 132.376C100.316 132.401 100.316 132.462 100.274 132.488L99.067 133.218C99.0187 133.247 98.9582 133.248 98.9094 133.22Z",
    fill: "#3D415B"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8108 131.991L95.5232 131.247C95.4771 131.22 95.4765 131.154 95.5222 131.127L96.7324 130.394C96.7743 130.369 96.8266 130.369 96.8689 130.393L98.1745 131.148C98.2172 131.172 98.2177 131.233 98.1754 131.259L96.9683 131.989C96.9201 132.019 96.8596 132.019 96.8108 131.991Z",
    fill: "#3D415B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7121 130.765L93.4245 130.02C93.3784 129.994 93.378 129.928 93.4235 129.9L94.6338 129.168C94.6756 129.143 94.7279 129.142 94.7703 129.166L96.0758 129.921C96.1186 129.946 96.119 130.007 96.0767 130.033L94.8696 130.763C94.8213 130.792 94.7609 130.793 94.7121 130.765Z",
    fill: "#3D415B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6135 129.538L91.3259 128.793C91.2798 128.767 91.2793 128.701 91.3249 128.673L92.5351 127.941C92.577 127.916 92.6293 127.915 92.6716 127.94L93.9772 128.695C94.0199 128.719 94.0204 128.78 93.9781 128.806L92.771 129.536C92.7227 129.565 92.6623 129.566 92.6135 129.538Z",
    fill: "#3D415B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5148 128.312L89.2273 127.567C89.1812 127.54 89.1807 127.474 89.2263 127.447L90.4365 126.715C90.4784 126.69 90.5307 126.689 90.573 126.713L91.8786 127.468C91.9213 127.493 91.9218 127.554 91.8794 127.579L90.6724 128.31C90.624 128.339 90.5636 128.34 90.5148 128.312Z",
    fill: "#3D415B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7808 126.351L88.5737 127.081C88.5254 127.11 88.465 127.111 88.4162 127.083L87.1286 126.338C87.0825 126.312 87.0821 126.246 87.1277 126.218L88.3378 125.486C88.3798 125.461 88.4321 125.46 88.4744 125.484L89.7799 126.24C89.8227 126.264 89.8231 126.325 89.7808 126.351Z",
    fill: "#3D415B"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M113.211 142.889C113.253 142.863 113.305 142.863 113.347 142.887L114.653 143.642C114.696 143.667 114.696 143.728 114.654 143.753L113.447 144.483C113.398 144.513 113.338 144.513 113.289 144.485L112.002 143.741C111.956 143.714 111.955 143.648 112.001 143.621L113.211 142.889Z",
    fill: "#3D415B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M111.112 141.662C111.154 141.637 111.207 141.636 111.249 141.66L112.554 142.416C112.597 142.44 112.598 142.501 112.555 142.527L111.348 143.257C111.3 143.286 111.239 143.287 111.191 143.259L109.903 142.514C109.857 142.488 109.856 142.422 109.902 142.394L111.112 141.662Z",
    fill: "#3D415B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M109.014 140.435C109.056 140.41 109.108 140.409 109.15 140.434L110.456 141.189C110.498 141.213 110.499 141.275 110.457 141.3L109.25 142.03C109.201 142.059 109.141 142.06 109.092 142.032L107.804 141.287C107.758 141.261 107.758 141.195 107.803 141.168L109.014 140.435Z",
    fill: "#3D415B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M106.915 139.207C106.957 139.182 107.009 139.181 107.052 139.205L108.357 139.96C108.4 139.985 108.4 140.046 108.358 140.072L107.151 140.802C107.103 140.831 107.042 140.832 106.993 140.804L105.706 140.059C105.66 140.033 105.659 139.967 105.705 139.939L106.915 139.207Z",
    fill: "#3D415B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4227 133.072C96.4646 133.047 96.517 133.046 96.5592 133.07L97.1963 133.439C97.2241 133.436 97.2522 133.439 97.2772 133.453L106.259 138.734C106.302 138.758 106.302 138.819 106.26 138.845L105.053 139.575C105.004 139.604 104.944 139.605 104.895 139.577L102.817 138.355C102.811 138.353 102.803 138.354 102.797 138.35L101.509 137.605C101.498 137.599 101.498 137.586 101.492 137.576L100.74 137.134C100.726 137.131 100.711 137.131 100.698 137.123L99.4106 136.378C99.3954 136.37 99.3929 136.354 99.3876 136.339L98.6619 135.912C98.6404 135.91 98.6189 135.907 98.5997 135.896L97.3121 135.152C97.2928 135.14 97.2862 135.121 97.2829 135.102L96.5817 134.689C96.5539 134.69 96.5261 134.684 96.5011 134.669L95.2135 133.925C95.1675 133.898 95.167 133.832 95.2126 133.804L96.4227 133.072Z",
    fill: "#3D415B"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3241 131.846C94.3661 131.82 94.4184 131.82 94.4607 131.844L95.7662 132.599C95.8089 132.624 95.8094 132.685 95.7672 132.71L94.56 133.44C94.5117 133.47 94.4513 133.47 94.4025 133.442L93.1149 132.698C93.0689 132.671 93.0683 132.605 93.114 132.578L94.3241 131.846Z",
    fill: "#3D415B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2255 130.619C92.2674 130.594 92.3198 130.593 92.362 130.617L93.6676 131.373C93.7103 131.397 93.7108 131.458 93.6685 131.484L92.4615 132.214C92.4131 132.243 92.3527 132.244 92.3039 132.216L91.0163 131.471C90.9703 131.445 90.9697 131.379 91.0153 131.351L92.2255 130.619Z",
    fill: "#3D415B"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1269 129.391C90.1688 129.365 90.2212 129.364 90.2635 129.389L91.5689 130.144C91.6117 130.168 91.6122 130.23 91.5699 130.255L90.3628 130.985C90.3144 131.014 90.254 131.015 90.2052 130.987L88.9177 130.242C88.8716 130.216 88.8711 130.15 88.9167 130.123L90.1269 129.391Z",
    fill: "#3D415B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0282 128.164C88.0702 128.139 88.1225 128.138 88.1648 128.162L89.4703 128.917C89.513 128.942 89.5135 129.003 89.4713 129.029L88.2642 129.759C88.2158 129.788 88.1555 129.789 88.1066 129.761L86.819 129.016C86.773 128.99 86.7724 128.924 86.8181 128.896L88.0282 128.164Z",
    fill: "#3D415B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7194 127.67L85.9296 126.938C85.9715 126.912 86.0239 126.911 86.0662 126.936L87.3718 127.691C87.4145 127.715 87.415 127.777 87.3727 127.802L86.1657 128.532C86.1172 128.562 86.0569 128.562 86.0081 128.534L84.7205 127.789C84.6744 127.763 84.6738 127.697 84.7194 127.67Z",
    fill: "#3D415B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M124.045 136.237L125.332 136.982C125.381 137.01 125.441 137.009 125.49 136.98L126.697 136.249C126.739 136.224 126.739 136.163 126.696 136.138L125.39 135.383C125.348 135.359 125.296 135.359 125.254 135.385L124.044 136.117C123.998 136.144 123.999 136.21 124.045 136.237Z",
    fill: "url(#paint17_linear_3449_10546)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M121.946 135.008L123.234 135.753C123.282 135.781 123.343 135.78 123.391 135.751L124.598 135.021C124.641 134.995 124.64 134.934 124.597 134.91L123.292 134.154C123.249 134.13 123.197 134.131 123.155 134.156L121.945 134.888C121.899 134.916 121.9 134.982 121.946 135.008Z",
    fill: "url(#paint18_linear_3449_10546)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M119.847 133.782L121.135 134.527C121.184 134.555 121.244 134.554 121.292 134.525L122.5 133.794C122.542 133.769 122.541 133.708 122.499 133.683L121.193 132.928C121.151 132.904 121.098 132.904 121.057 132.93L119.846 133.662C119.801 133.689 119.801 133.755 119.847 133.782Z",
    fill: "url(#paint19_linear_3449_10546)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M117.749 132.555L119.036 133.3C119.085 133.328 119.146 133.327 119.194 133.298L120.401 132.568C120.443 132.542 120.443 132.481 120.4 132.457L119.094 131.701C119.052 131.677 119 131.678 118.958 131.703L117.748 132.435C117.702 132.463 117.703 132.529 117.749 132.555Z",
    fill: "url(#paint20_linear_3449_10546)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M115.65 131.329L116.938 132.074C116.987 132.101 117.047 132.101 117.095 132.071L118.302 131.341C118.345 131.316 118.344 131.255 118.301 131.23L116.996 130.475C116.954 130.451 116.901 130.451 116.859 130.477L115.649 131.209C115.603 131.236 115.604 131.302 115.65 131.329Z",
    fill: "url(#paint21_linear_3449_10546)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M113.551 130.102L114.839 130.847C114.888 130.875 114.948 130.874 114.997 130.845L116.204 130.115C116.246 130.089 116.245 130.028 116.203 130.003L114.897 129.248C114.855 129.224 114.803 129.225 114.761 129.25L113.55 129.982C113.505 130.01 113.505 130.076 113.551 130.102Z",
    fill: "url(#paint22_linear_3449_10546)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M111.453 128.875L112.74 129.62C112.789 129.648 112.85 129.647 112.898 129.618L114.105 128.888C114.147 128.862 114.147 128.801 114.104 128.777L112.799 128.022C112.756 127.997 112.704 127.998 112.662 128.023L111.452 128.756C111.406 128.783 111.407 128.849 111.453 128.875Z",
    fill: "url(#paint23_linear_3449_10546)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M109.354 127.647L110.642 128.392C110.691 128.42 110.751 128.419 110.799 128.39L112.006 127.66C112.049 127.634 112.048 127.573 112.005 127.548L110.7 126.793C110.658 126.769 110.605 126.77 110.563 126.795L109.353 127.527C109.308 127.555 109.308 127.621 109.354 127.647Z",
    fill: "url(#paint24_linear_3449_10546)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M107.257 126.42L108.544 127.165C108.593 127.193 108.653 127.192 108.702 127.163L109.909 126.433C109.951 126.407 109.95 126.346 109.908 126.322L108.602 125.566C108.56 125.542 108.508 125.543 108.466 125.568L107.256 126.3C107.21 126.328 107.21 126.394 107.257 126.42Z",
    fill: "url(#paint25_linear_3449_10546)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M105.158 125.194L106.446 125.939C106.494 125.967 106.555 125.966 106.603 125.937L107.81 125.206C107.852 125.181 107.852 125.12 107.809 125.095L106.504 124.34C106.461 124.316 106.409 124.316 106.367 124.342L105.157 125.074C105.111 125.101 105.112 125.167 105.158 125.194Z",
    fill: "url(#paint26_linear_3449_10546)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M103.059 123.967L104.347 124.712C104.396 124.74 104.456 124.739 104.504 124.71L105.711 123.98C105.754 123.954 105.753 123.893 105.711 123.869L104.405 123.113C104.363 123.089 104.31 123.09 104.269 123.115L103.058 123.847C103.013 123.875 103.013 123.941 103.059 123.967Z",
    fill: "url(#paint27_linear_3449_10546)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M100.961 122.741L102.248 123.486C102.297 123.514 102.357 123.513 102.406 123.484L103.613 122.753C103.655 122.728 103.655 122.667 103.612 122.642L102.306 121.887C102.264 121.863 102.212 121.863 102.17 121.889L100.96 122.621C100.914 122.648 100.915 122.714 100.961 122.741Z",
    fill: "url(#paint28_linear_3449_10546)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M98.862 121.512L100.15 122.257C100.198 122.285 100.259 122.284 100.307 122.255L101.514 121.525C101.557 121.499 101.556 121.438 101.513 121.414L100.208 120.658C100.165 120.634 100.113 120.635 100.071 120.66L98.861 121.392C98.8154 121.42 98.816 121.486 98.862 121.512Z",
    fill: "url(#paint29_linear_3449_10546)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7634 120.286L98.0509 121.03C98.0997 121.058 98.1601 121.058 98.2085 121.028L99.4155 120.298C99.4579 120.273 99.4573 120.212 99.4147 120.187L98.1091 119.432C98.0668 119.408 98.0144 119.408 97.9726 119.434L96.7624 120.166C96.7168 120.193 96.7173 120.259 96.7634 120.286Z",
    fill: "url(#paint30_linear_3449_10546)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M121.637 137.688L122.925 138.433C122.974 138.461 123.034 138.46 123.082 138.431L124.29 137.701C124.332 137.675 124.331 137.614 124.289 137.589L122.983 136.834C122.941 136.81 122.888 136.811 122.847 136.836L121.636 137.568C121.591 137.596 121.591 137.662 121.637 137.688Z",
    fill: "url(#paint31_linear_3449_10546)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M119.539 136.459L120.826 137.204C120.875 137.232 120.936 137.231 120.984 137.202L122.191 136.472C122.233 136.447 122.233 136.385 122.19 136.361L120.884 135.606C120.842 135.581 120.79 135.582 120.748 135.607L119.538 136.339C119.492 136.367 119.493 136.433 119.539 136.459Z",
    fill: "url(#paint32_linear_3449_10546)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M117.44 135.233L118.728 135.978C118.777 136.006 118.837 136.005 118.885 135.976L120.092 135.245C120.135 135.22 120.134 135.159 120.091 135.134L118.786 134.379C118.744 134.355 118.691 134.356 118.649 134.381L117.439 135.113C117.394 135.141 117.394 135.206 117.44 135.233Z",
    fill: "url(#paint33_linear_3449_10546)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M115.342 134.006L116.629 134.751C116.678 134.779 116.738 134.778 116.787 134.749L117.994 134.019C118.036 133.993 118.035 133.932 117.993 133.908L116.687 133.152C116.645 133.128 116.593 133.129 116.551 133.154L115.341 133.886C115.295 133.914 115.295 133.98 115.342 134.006Z",
    fill: "url(#paint34_linear_3449_10546)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M113.244 132.78L114.531 133.525C114.58 133.553 114.641 133.552 114.689 133.523L115.896 132.792C115.938 132.767 115.938 132.706 115.895 132.681L114.59 131.926C114.547 131.902 114.495 131.902 114.453 131.928L113.243 132.66C113.197 132.687 113.198 132.753 113.244 132.78Z",
    fill: "url(#paint35_linear_3449_10546)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M111.145 131.553L112.433 132.298C112.482 132.326 112.542 132.325 112.59 132.296L113.797 131.566C113.84 131.54 113.839 131.479 113.797 131.455L112.491 130.699C112.449 130.675 112.396 130.676 112.354 130.701L111.144 131.433C111.099 131.461 111.099 131.527 111.145 131.553Z",
    fill: "url(#paint36_linear_3449_10546)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M109.047 130.325L110.334 131.07C110.383 131.098 110.443 131.097 110.492 131.067L111.699 130.337C111.741 130.312 111.741 130.251 111.698 130.226L110.392 129.471C110.35 129.447 110.298 129.447 110.256 129.473L109.046 130.205C109 130.232 109.001 130.298 109.047 130.325Z",
    fill: "url(#paint37_linear_3449_10546)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M106.948 129.098L108.236 129.843C108.284 129.871 108.345 129.87 108.393 129.841L109.6 129.111C109.642 129.085 109.642 129.024 109.599 128.999L108.294 128.244C108.251 128.22 108.199 128.221 108.157 128.246L106.947 128.978C106.901 129.006 106.902 129.072 106.948 129.098Z",
    fill: "url(#paint38_linear_3449_10546)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M104.849 127.871L106.137 128.616C106.186 128.644 106.246 128.644 106.294 128.614L107.501 127.884C107.544 127.859 107.543 127.797 107.501 127.773L106.195 127.018C106.153 126.993 106.1 126.994 106.059 127.019L104.848 127.752C104.803 127.779 104.803 127.845 104.849 127.871Z",
    fill: "url(#paint39_linear_3449_10546)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M102.751 126.645L104.038 127.39C104.087 127.418 104.147 127.417 104.196 127.388L105.403 126.658C105.445 126.632 105.445 126.571 105.402 126.546L104.096 125.791C104.054 125.767 104.002 125.768 103.96 125.793L102.75 126.525C102.704 126.553 102.705 126.618 102.751 126.645Z",
    fill: "url(#paint40_linear_3449_10546)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M100.652 125.418L101.94 126.163C101.988 126.191 102.049 126.19 102.097 126.161L103.304 125.431C103.347 125.405 103.346 125.344 103.303 125.32L101.998 124.565C101.955 124.54 101.903 124.541 101.861 124.566L100.651 125.298C100.605 125.326 100.606 125.392 100.652 125.418Z",
    fill: "url(#paint41_linear_3449_10546)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5535 124.192L99.841 124.937C99.8898 124.965 99.9502 124.964 99.9986 124.935L101.206 124.205C101.248 124.179 101.247 124.118 101.205 124.093L99.8992 123.338C99.8569 123.314 99.8045 123.314 99.7627 123.34L98.5525 124.072C98.5068 124.099 98.5074 124.165 98.5535 124.192Z",
    fill: "url(#paint42_linear_3449_10546)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4548 122.963L97.7423 123.708C97.7912 123.736 97.8515 123.735 97.8999 123.706L99.1069 122.976C99.1493 122.95 99.1487 122.889 99.1061 122.865L97.8005 122.109C97.7582 122.085 97.7058 122.086 97.664 122.111L96.4538 122.843C96.4082 122.871 96.4087 122.937 96.4548 122.963Z",
    fill: "url(#paint43_linear_3449_10546)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3561 121.737L95.6437 122.482C95.6925 122.51 95.7529 122.509 95.8012 122.48L97.0083 121.749C97.0506 121.724 97.0501 121.663 97.0074 121.638L95.7019 120.883C95.6595 120.859 95.6072 120.859 95.5654 120.885L94.3552 121.617C94.3096 121.644 94.3101 121.71 94.3561 121.737Z",
    fill: "url(#paint44_linear_3449_10546)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M117.632 138.198L120.516 139.882C120.564 139.91 120.625 139.909 120.673 139.88L121.88 139.15C121.923 139.124 121.922 139.063 121.879 139.038L118.977 137.344C118.935 137.32 118.883 137.32 118.841 137.346L117.631 138.078C117.585 138.105 117.586 138.171 117.632 138.198Z",
    fill: "url(#paint45_linear_3449_10546)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M117.13 137.911L118.417 138.656C118.466 138.683 118.526 138.683 118.575 138.653L119.782 137.923C119.824 137.898 119.824 137.837 119.781 137.812L118.475 137.057C118.433 137.033 118.381 137.033 118.339 137.059L117.129 137.791C117.083 137.818 117.084 137.884 117.13 137.911Z",
    fill: "url(#paint46_linear_3449_10546)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M115.031 136.684L116.319 137.429C116.367 137.457 116.428 137.456 116.476 137.427L117.683 136.697C117.725 136.671 117.725 136.61 117.682 136.585L116.377 135.83C116.334 135.806 116.282 135.807 116.24 135.832L115.03 136.564C114.984 136.592 114.985 136.658 115.031 136.684Z",
    fill: "url(#paint47_linear_3449_10546)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M112.932 135.457L114.22 136.202C114.269 136.23 114.329 136.23 114.377 136.2L115.584 135.47C115.627 135.445 115.626 135.383 115.584 135.359L114.278 134.604C114.236 134.579 114.183 134.58 114.142 134.605L112.931 135.338C112.886 135.365 112.886 135.431 112.932 135.457Z",
    fill: "url(#paint48_linear_3449_10546)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M110.835 134.231L112.122 134.976C112.171 135.004 112.231 135.003 112.28 134.974L113.487 134.244C113.529 134.218 113.529 134.157 113.486 134.132L112.18 133.377C112.138 133.353 112.086 133.354 112.044 133.379L110.834 134.111C110.788 134.139 110.789 134.204 110.835 134.231Z",
    fill: "url(#paint49_linear_3449_10546)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M108.736 133.004L110.024 133.749C110.072 133.777 110.133 133.776 110.181 133.747L111.388 133.017C111.431 132.991 111.43 132.93 111.387 132.906L110.082 132.15C110.039 132.126 109.987 132.127 109.945 132.152L108.735 132.884C108.689 132.912 108.69 132.978 108.736 133.004Z",
    fill: "url(#paint50_linear_3449_10546)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M106.637 131.776L107.925 132.521C107.974 132.549 108.034 132.548 108.083 132.519L109.29 131.788C109.332 131.763 109.331 131.702 109.289 131.677L107.983 130.922C107.941 130.898 107.888 130.898 107.847 130.924L106.636 131.656C106.591 131.683 106.591 131.749 106.637 131.776Z",
    fill: "url(#paint51_linear_3449_10546)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M104.539 130.549L105.826 131.294C105.875 131.322 105.936 131.321 105.984 131.292L107.191 130.562C107.233 130.536 107.233 130.475 107.19 130.451L105.884 129.695C105.842 129.671 105.79 129.672 105.748 129.697L104.538 130.429C104.492 130.457 104.493 130.523 104.539 130.549Z",
    fill: "url(#paint52_linear_3449_10546)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M102.44 129.323L103.728 130.068C103.777 130.096 103.837 130.095 103.885 130.066L105.092 129.335C105.135 129.31 105.134 129.249 105.091 129.224L103.786 128.469C103.744 128.445 103.691 128.445 103.649 128.471L102.439 129.203C102.394 129.23 102.394 129.296 102.44 129.323Z",
    fill: "url(#paint53_linear_3449_10546)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M100.341 128.096L101.629 128.841C101.678 128.869 101.738 128.868 101.787 128.839L102.994 128.109C103.036 128.083 103.035 128.022 102.993 127.998L101.687 127.242C101.645 127.218 101.593 127.219 101.551 127.244L100.341 127.976C100.295 128.004 100.295 128.07 100.341 128.096Z",
    fill: "url(#paint54_linear_3449_10546)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2428 126.87L99.5304 127.614C99.5792 127.642 99.6396 127.642 99.688 127.612L100.895 126.882C100.937 126.857 100.937 126.795 100.894 126.771L99.5886 126.016C99.5463 125.992 99.4939 125.992 99.4521 126.018L98.2419 126.75C98.1963 126.777 98.1968 126.843 98.2428 126.87Z",
    fill: "url(#paint55_linear_3449_10546)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1442 125.643L97.4318 126.388C97.4806 126.416 97.541 126.415 97.5893 126.386L98.7964 125.656C98.8387 125.63 98.8382 125.569 98.7955 125.544L97.49 124.789C97.4476 124.765 97.3953 124.766 97.3534 124.791L96.1433 125.523C96.0976 125.551 96.0982 125.617 96.1442 125.643Z",
    fill: "url(#paint56_linear_3449_10546)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0456 124.414L95.3332 125.159C95.382 125.187 95.4424 125.187 95.4908 125.157L96.6978 124.427C96.7402 124.402 96.7396 124.34 96.6969 124.316L95.3914 123.561C95.3491 123.536 95.2967 123.537 95.2549 123.562L94.0447 124.295C93.999 124.322 93.9995 124.388 94.0456 124.414Z",
    fill: "url(#paint57_linear_3449_10546)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M91.947 123.188L94.8625 124.894C94.9113 124.922 94.9717 124.921 95.02 124.892L96.2271 124.162C96.2694 124.136 96.2688 124.075 96.2262 124.05L93.2927 122.334C93.2504 122.31 93.1981 122.311 93.1562 122.336L91.9461 123.068C91.9004 123.096 91.9009 123.161 91.947 123.188Z",
    fill: "url(#paint58_linear_3449_10546)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M116.82 140.588L118.108 141.333C118.156 141.361 118.217 141.36 118.265 141.331L119.472 140.601C119.515 140.575 119.514 140.514 119.471 140.49L118.166 139.734C118.123 139.71 118.071 139.711 118.029 139.736L116.819 140.468C116.773 140.496 116.774 140.562 116.82 140.588Z",
    fill: "url(#paint59_linear_3449_10546)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M114.721 139.36L116.009 140.105C116.058 140.133 116.118 140.132 116.167 140.103L117.374 139.372C117.416 139.347 117.415 139.286 117.373 139.261L116.067 138.506C116.025 138.482 115.972 138.482 115.931 138.508L114.72 139.24C114.675 139.268 114.675 139.333 114.721 139.36Z",
    fill: "url(#paint60_linear_3449_10546)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M112.623 138.133L113.91 138.878C113.959 138.906 114.02 138.905 114.068 138.876L115.275 138.146C115.317 138.12 115.317 138.059 115.274 138.035L113.969 137.279C113.926 137.255 113.874 137.256 113.832 137.281L112.622 138.013C112.576 138.041 112.577 138.107 112.623 138.133Z",
    fill: "url(#paint61_linear_3449_10546)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M110.524 136.907L111.812 137.652C111.861 137.68 111.921 137.679 111.969 137.65L113.176 136.919C113.219 136.894 113.218 136.833 113.175 136.808L111.87 136.053C111.828 136.029 111.775 136.029 111.733 136.055L110.523 136.787C110.478 136.814 110.478 136.88 110.524 136.907Z",
    fill: "url(#paint62_linear_3449_10546)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M108.426 135.68L109.714 136.425C109.763 136.453 109.823 136.452 109.872 136.423L111.079 135.693C111.121 135.667 111.12 135.606 111.078 135.582L109.772 134.826C109.73 134.802 109.678 134.803 109.636 134.828L108.425 135.56C108.38 135.588 108.38 135.654 108.426 135.68Z",
    fill: "url(#paint63_linear_3449_10546)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M106.328 134.454L107.615 135.198C107.664 135.226 107.725 135.226 107.773 135.196L108.98 134.466C109.022 134.441 109.022 134.379 108.979 134.355L107.674 133.6C107.631 133.575 107.579 133.576 107.537 133.602L106.327 134.334C106.281 134.361 106.282 134.427 106.328 134.454Z",
    fill: "url(#paint64_linear_3449_10546)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M104.229 133.225L105.517 133.97C105.566 133.998 105.626 133.997 105.674 133.968L106.881 133.238C106.924 133.212 106.923 133.151 106.88 133.126L105.575 132.371C105.533 132.347 105.48 132.348 105.438 132.373L104.228 133.105C104.183 133.133 104.183 133.199 104.229 133.225Z",
    fill: "url(#paint65_linear_3449_10546)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M102.131 131.998L103.418 132.743C103.467 132.771 103.527 132.771 103.576 132.741L104.783 132.011C104.825 131.985 104.825 131.924 104.782 131.9L103.476 131.145C103.434 131.12 103.382 131.121 103.34 131.146L102.13 131.879C102.084 131.906 102.084 131.972 102.131 131.998Z",
    fill: "url(#paint66_linear_3449_10546)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M100.032 130.772L101.32 131.517C101.368 131.545 101.429 131.544 101.477 131.515L102.684 130.785C102.726 130.759 102.726 130.698 102.683 130.673L101.378 129.918C101.335 129.894 101.283 129.895 101.241 129.92L100.031 130.652C99.9853 130.68 99.9859 130.746 100.032 130.772Z",
    fill: "url(#paint67_linear_3449_10546)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9333 129.545L99.2209 130.29C99.2697 130.318 99.3301 130.317 99.3785 130.288L100.586 129.558C100.628 129.532 100.627 129.471 100.585 129.447L99.2791 128.691C99.2367 128.667 99.1844 128.668 99.1426 128.693L97.9324 129.425C97.8867 129.453 97.8872 129.519 97.9333 129.545Z",
    fill: "url(#paint68_linear_3449_10546)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8346 128.319L97.1222 129.064C97.171 129.092 97.2314 129.091 97.2798 129.062L98.4868 128.331C98.5292 128.306 98.5286 128.245 98.4859 128.22L97.1804 127.465C97.1381 127.441 97.0857 127.441 97.0439 127.467L95.8337 128.199C95.7881 128.227 95.7886 128.292 95.8346 128.319Z",
    fill: "url(#paint69_linear_3449_10546)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M93.736 127.092L95.0236 127.837C95.0724 127.865 95.1328 127.864 95.1811 127.835L96.3882 127.105C96.4305 127.079 96.43 127.018 96.3873 126.994L95.0818 126.238C95.0394 126.214 94.9871 126.215 94.9452 126.24L93.7351 126.972C93.6894 127 93.69 127.066 93.736 127.092Z",
    fill: "url(#paint70_linear_3449_10546)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6374 125.864L92.925 126.609C92.9738 126.637 93.0342 126.636 93.0825 126.607L94.2896 125.876C94.3319 125.851 94.3313 125.79 94.2887 125.765L92.9831 125.01C92.9408 124.986 92.8885 124.986 92.8466 125.012L91.6364 125.744C91.5908 125.771 91.5914 125.837 91.6374 125.864Z",
    fill: "url(#paint71_linear_3449_10546)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5388 124.637L90.8264 125.382C90.8752 125.41 90.9356 125.409 90.9839 125.38L92.191 124.65C92.2333 124.624 92.2327 124.563 92.1901 124.539L90.8845 123.783C90.8422 123.759 90.7899 123.76 90.748 123.785L89.5378 124.517C89.4922 124.545 89.4927 124.611 89.5388 124.637Z",
    fill: "url(#paint72_linear_3449_10546)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M114.411 142.039L115.698 142.784C115.747 142.812 115.808 142.812 115.856 142.782L117.063 142.052C117.105 142.027 117.105 141.965 117.062 141.941L115.757 141.186C115.714 141.161 115.662 141.162 115.62 141.187L114.41 141.92C114.364 141.947 114.365 142.013 114.411 142.039Z",
    fill: "url(#paint73_linear_3449_10546)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M112.312 140.811L113.6 141.556C113.649 141.584 113.709 141.583 113.757 141.554L114.964 140.824C115.007 140.798 115.006 140.737 114.963 140.712L113.658 139.957C113.616 139.933 113.563 139.934 113.521 139.959L112.311 140.691C112.266 140.719 112.266 140.784 112.312 140.811Z",
    fill: "url(#paint74_linear_3449_10546)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M110.214 139.584L111.501 140.329C111.55 140.357 111.61 140.356 111.659 140.327L112.866 139.597C112.908 139.571 112.908 139.51 112.865 139.486L111.559 138.731C111.517 138.706 111.465 138.707 111.423 138.732L110.213 139.465C110.167 139.492 110.168 139.558 110.214 139.584Z",
    fill: "url(#paint75_linear_3449_10546)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M108.115 138.358L109.403 139.103C109.451 139.131 109.512 139.13 109.56 139.101L110.767 138.37C110.809 138.345 110.809 138.284 110.766 138.259L109.461 137.504C109.418 137.48 109.366 137.481 109.324 137.506L108.114 138.238C108.068 138.265 108.069 138.331 108.115 138.358Z",
    fill: "url(#paint76_linear_3449_10546)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M106.017 137.131L107.305 137.876C107.354 137.904 107.414 137.903 107.462 137.874L108.669 137.144C108.712 137.118 108.711 137.057 108.669 137.033L107.363 136.277C107.321 136.253 107.268 136.254 107.227 136.279L106.016 137.011C105.971 137.039 105.971 137.105 106.017 137.131Z",
    fill: "url(#paint77_linear_3449_10546)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M103.919 135.905L105.206 136.65C105.255 136.678 105.315 136.677 105.364 136.648L106.571 135.917C106.613 135.892 106.613 135.831 106.57 135.806L105.264 135.051C105.222 135.027 105.17 135.027 105.128 135.053L103.918 135.785C103.872 135.812 103.873 135.878 103.919 135.905Z",
    fill: "url(#paint78_linear_3449_10546)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M101.82 134.678L103.108 135.423C103.156 135.451 103.217 135.45 103.265 135.421L104.472 134.691C104.515 134.665 104.514 134.604 104.471 134.58L103.166 133.824C103.123 133.8 103.071 133.801 103.029 133.826L101.819 134.558C101.773 134.586 101.774 134.652 101.82 134.678Z",
    fill: "url(#paint79_linear_3449_10546)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7214 133.45L101.009 134.195C101.058 134.223 101.118 134.222 101.166 134.192L102.374 133.462C102.416 133.437 102.415 133.375 102.373 133.351L101.067 132.596C101.025 132.572 100.972 132.572 100.931 132.598L99.7204 133.33C99.6748 133.357 99.6754 133.423 99.7214 133.45Z",
    fill: "url(#paint80_linear_3449_10546)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6228 132.223L98.9103 132.968C98.9592 132.996 99.0195 132.995 99.0679 132.966L100.275 132.236C100.317 132.21 100.317 132.149 100.274 132.124L98.9685 131.369C98.9262 131.345 98.8738 131.346 98.832 131.371L97.6218 132.103C97.5762 132.131 97.5767 132.197 97.6228 132.223Z",
    fill: "url(#paint81_linear_3449_10546)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5241 130.996L96.8117 131.741C96.8605 131.769 96.9209 131.769 96.9692 131.739L98.1763 131.009C98.2186 130.984 98.2181 130.922 98.1754 130.898L96.8698 130.143C96.8275 130.118 96.7751 130.119 96.7333 130.144L95.5231 130.877C95.4776 130.904 95.478 130.97 95.5241 130.996Z",
    fill: "url(#paint82_linear_3449_10546)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4255 129.77L94.7131 130.515C94.7619 130.543 94.8223 130.542 94.8706 130.513L96.0777 129.783C96.12 129.757 96.1195 129.696 96.0768 129.671L94.7713 128.916C94.729 128.892 94.6766 128.893 94.6348 128.918L93.4246 129.65C93.3789 129.678 93.3794 129.744 93.4255 129.77Z",
    fill: "url(#paint83_linear_3449_10546)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3268 128.543L92.6144 129.288C92.6632 129.316 92.7236 129.315 92.7719 129.286L93.979 128.556C94.0213 128.53 94.0208 128.469 93.9781 128.445L92.6726 127.69C92.6302 127.665 92.5779 127.666 92.536 127.691L91.3259 128.423C91.2803 128.451 91.2808 128.517 91.3268 128.543Z",
    fill: "url(#paint84_linear_3449_10546)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2282 127.315L90.5158 128.06C90.5646 128.088 90.625 128.087 90.6733 128.058L91.8804 127.328C91.9227 127.302 91.9222 127.241 91.8795 127.216L90.5739 126.461C90.5316 126.437 90.4793 126.437 90.4374 126.463L89.2272 127.195C89.1816 127.223 89.1822 127.289 89.2282 127.315Z",
    fill: "url(#paint85_linear_3449_10546)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1296 126.088L88.4172 126.833C88.466 126.861 88.5263 126.86 88.5747 126.831L89.7817 126.101C89.8241 126.075 89.8235 126.014 89.7809 125.99L88.4753 125.234C88.433 125.21 88.3806 125.211 88.3388 125.236L87.1286 125.968C87.083 125.996 87.0836 126.062 87.1296 126.088Z",
    fill: "url(#paint86_linear_3449_10546)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M112.002 143.489L113.289 144.234C113.338 144.262 113.398 144.261 113.447 144.232L114.654 143.501C114.696 143.476 114.696 143.415 114.653 143.39L113.347 142.635C113.305 142.611 113.253 142.611 113.211 142.637L112.001 143.369C111.955 143.396 111.956 143.462 112.002 143.489Z",
    fill: "url(#paint87_linear_3449_10546)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M109.903 142.26L111.191 143.005C111.239 143.033 111.3 143.032 111.348 143.003L112.555 142.273C112.598 142.247 112.597 142.186 112.554 142.162L111.249 141.406C111.206 141.382 111.154 141.383 111.112 141.408L109.902 142.14C109.856 142.168 109.857 142.234 109.903 142.26Z",
    fill: "url(#paint88_linear_3449_10546)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M107.804 141.034L109.092 141.779C109.141 141.806 109.201 141.806 109.249 141.776L110.457 141.046C110.499 141.021 110.498 140.96 110.456 140.935L109.15 140.18C109.108 140.156 109.055 140.156 109.014 140.182L107.803 140.914C107.758 140.941 107.758 141.007 107.804 141.034Z",
    fill: "url(#paint89_linear_3449_10546)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M105.706 139.807L106.993 140.552C107.042 140.58 107.103 140.579 107.151 140.55L108.358 139.82C108.4 139.794 108.4 139.733 108.357 139.708L107.051 138.953C107.009 138.929 106.957 138.93 106.915 138.955L105.705 139.687C105.659 139.715 105.66 139.781 105.706 139.807Z",
    fill: "url(#paint90_linear_3449_10546)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9313 134.055L104.895 139.325C104.944 139.353 105.004 139.352 105.053 139.323L106.26 138.593C106.302 138.567 106.302 138.506 106.259 138.482L97.277 133.201C97.2347 133.177 97.1823 133.178 97.1405 133.203L95.9303 133.935C95.8848 133.963 95.8853 134.029 95.9313 134.055Z",
    fill: "url(#paint91_linear_3449_10546)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M101.51 137.354L102.797 138.099C102.846 138.127 102.906 138.126 102.955 138.097L104.162 137.367C104.204 137.341 104.203 137.28 104.161 137.255L102.855 136.5C102.813 136.476 102.761 136.477 102.719 136.502L101.509 137.234C101.463 137.262 101.463 137.328 101.51 137.354Z",
    fill: "url(#paint92_linear_3449_10546)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4108 136.127L100.698 136.872C100.747 136.9 100.808 136.899 100.856 136.87L102.063 136.14C102.105 136.114 102.105 136.053 102.062 136.029L100.757 135.274C100.714 135.249 100.662 135.25 100.62 135.275L99.4099 136.007C99.3642 136.035 99.3648 136.101 99.4108 136.127Z",
    fill: "url(#paint93_linear_3449_10546)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3122 134.899L98.5998 135.644C98.6486 135.672 98.709 135.671 98.7573 135.642L99.9644 134.912C100.007 134.886 100.006 134.825 99.9635 134.8L98.6579 134.045C98.6156 134.021 98.5633 134.022 98.5214 134.047L97.3112 134.779C97.2656 134.807 97.2662 134.872 97.3122 134.899Z",
    fill: "url(#paint94_linear_3449_10546)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2135 133.672L96.5011 134.417C96.5499 134.445 96.6103 134.444 96.6587 134.415L97.8657 133.685C97.9081 133.659 97.9075 133.598 97.8648 133.574L96.5593 132.818C96.517 132.794 96.4646 132.795 96.4228 132.82L95.2126 133.552C95.167 133.58 95.1675 133.646 95.2135 133.672Z",
    fill: "url(#paint95_linear_3449_10546)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1149 132.446L94.4025 133.191C94.4513 133.219 94.5117 133.218 94.56 133.189L95.7671 132.458C95.8094 132.433 95.8089 132.372 95.7662 132.347L94.4607 131.592C94.4183 131.568 94.366 131.568 94.3241 131.594L93.114 132.326C93.0683 132.353 93.0689 132.419 93.1149 132.446Z",
    fill: "url(#paint96_linear_3449_10546)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0163 131.219L92.3039 131.964C92.3527 131.992 92.4131 131.991 92.4614 131.962L93.6685 131.232C93.7108 131.206 93.7103 131.145 93.6676 131.121L92.3621 130.365C92.3197 130.341 92.2674 130.342 92.2255 130.367L91.0154 131.099C90.9697 131.127 90.9702 131.193 91.0163 131.219Z",
    fill: "url(#paint97_linear_3449_10546)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9177 129.993L90.2053 130.738C90.2541 130.766 90.3145 130.765 90.3629 130.735L91.5699 130.005C91.6123 129.98 91.6117 129.919 91.569 129.894L90.2635 129.139C90.2212 129.115 90.1688 129.115 90.127 129.141L88.9168 129.873C88.8711 129.9 88.8716 129.966 88.9177 129.993Z",
    fill: "url(#paint98_linear_3449_10546)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8191 128.764L88.1067 129.509C88.1555 129.537 88.2159 129.536 88.2642 129.507L89.4713 128.777C89.5136 128.751 89.513 128.69 89.4704 128.666L88.1648 127.91C88.1225 127.886 88.0702 127.887 88.0283 127.912L86.8181 128.644C86.7724 128.672 86.773 128.738 86.8191 128.764Z",
    fill: "url(#paint99_linear_3449_10546)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7204 127.537L86.008 128.282C86.0568 128.31 86.1172 128.31 86.1655 128.28L87.3726 127.55C87.4149 127.525 87.4143 127.463 87.3717 127.439L86.0661 126.684C86.0238 126.659 85.9715 126.66 85.9296 126.686L84.7194 127.418C84.6738 127.445 84.6744 127.511 84.7204 127.537Z",
    fill: "url(#paint100_linear_3449_10546)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M121.93 98.0939L103.141 87.1664C102.626 86.867 102.205 86.2007 102.205 85.6859C102.205 85.1711 102.626 84.995 103.141 85.2945L121.93 96.2219C122.445 96.5214 122.866 97.1877 122.866 97.7024C122.866 98.2172 122.445 98.3934 121.93 98.0939Z",
    fill: "#CCD3DD"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M121.93 112.983L103.141 102.055C102.626 101.756 102.205 101.089 102.205 100.575C102.205 100.06 102.626 99.8836 103.141 100.183L121.93 111.111C122.445 111.41 122.866 112.076 122.866 112.591C122.866 113.106 122.445 113.282 121.93 112.983Z",
    fill: "#CCD3DD"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M136.529 110.297V112.26C136.529 113.044 135.886 113.312 135.102 112.855L103.044 94.2106C102.26 93.7545 101.618 92.7401 101.618 91.956V89.9923C101.618 89.2082 102.26 88.9402 103.044 89.3963L135.102 108.041C135.886 108.497 136.529 109.512 136.529 110.297Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M136.529 110.298V112.262C136.529 113.046 135.886 113.313 135.102 112.857L128.963 109.287V104.473L135.102 108.043C135.886 108.499 136.529 109.514 136.529 110.298Z",
    fill: "url(#paint101_linear_3449_10546)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M136.529 125.095V127.059C136.529 127.843 135.886 128.11 135.102 127.654L103.044 109.009C102.26 108.553 101.618 107.539 101.618 106.755V104.791C101.618 104.007 102.26 103.739 103.044 104.195L135.102 122.84C135.886 123.296 136.529 124.311 136.529 125.095Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M136.529 125.095V127.059C136.529 127.843 135.886 128.11 135.102 127.654L128.963 124.084V119.27L135.102 122.84C135.886 123.296 136.529 124.311 136.529 125.095Z",
    fill: "url(#paint102_linear_3449_10546)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M105.789 93.4346C105.789 93.8326 105.466 93.9675 105.068 93.736C104.67 93.5045 104.348 92.9942 104.348 92.5962C104.348 92.1982 104.67 92.0633 105.068 92.2948C105.466 92.5263 105.789 93.0366 105.789 93.4346Z",
    fill: "#525575"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M108.553 95.042C108.553 95.44 108.23 95.5749 107.832 95.3434C107.434 95.1119 107.111 94.6016 107.111 94.2036C107.111 93.8056 107.434 93.6708 107.832 93.9023C108.23 94.1338 108.553 94.6441 108.553 95.042Z",
    fill: "#525575"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M111.315 96.6475C111.315 97.0455 110.992 97.1804 110.594 96.9489C110.196 96.7174 109.873 96.207 109.873 95.8091C109.873 95.4112 110.196 95.2762 110.594 95.5077C110.992 95.7392 111.315 96.2495 111.315 96.6475Z",
    fill: "#525575"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M114.078 98.2549C114.078 98.6529 113.756 98.7878 113.357 98.5563C112.959 98.3248 112.637 97.8144 112.637 97.4165C112.637 97.0186 112.959 96.8836 113.357 97.1151C113.756 97.3466 114.078 97.857 114.078 98.2549Z",
    fill: "#525575"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M116.7 100.211C116.939 100.032 116.875 99.5425 116.556 99.1185C116.238 98.6944 115.786 98.496 115.547 98.6753C115.308 98.8546 115.372 99.3438 115.691 99.7678C116.009 100.192 116.461 100.39 116.7 100.211Z",
    fill: "#525575"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M119.464 101.818C119.703 101.639 119.638 101.15 119.32 100.726C119.001 100.302 118.55 100.103 118.311 100.283C118.072 100.462 118.136 100.951 118.454 101.375C118.773 101.799 119.225 101.998 119.464 101.818Z",
    fill: "#525575"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M105.789 108.2C105.789 108.598 105.466 108.733 105.068 108.502C104.67 108.27 104.348 107.76 104.348 107.362C104.348 106.964 104.67 106.829 105.068 107.06C105.466 107.292 105.789 107.802 105.789 108.2Z",
    fill: "#525575"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M108.553 109.808C108.553 110.206 108.23 110.341 107.832 110.109C107.434 109.878 107.111 109.367 107.111 108.969C107.111 108.571 107.434 108.436 107.832 108.668C108.23 108.899 108.553 109.41 108.553 109.808Z",
    fill: "#525575"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M111.315 111.413C111.315 111.811 110.992 111.946 110.594 111.714C110.196 111.483 109.873 110.973 109.873 110.575C109.873 110.177 110.196 110.042 110.594 110.273C110.992 110.505 111.315 111.015 111.315 111.413Z",
    fill: "#525575"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M114.078 113.021C114.078 113.418 113.756 113.553 113.357 113.322C112.959 113.09 112.637 112.58 112.637 112.182C112.637 111.784 112.959 111.649 113.357 111.881C113.756 112.112 114.078 112.623 114.078 113.021Z",
    fill: "#525575"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M116.842 114.628C116.842 115.026 116.519 115.161 116.121 114.929C115.723 114.698 115.4 114.187 115.4 113.79C115.4 113.392 115.723 113.257 116.121 113.488C116.519 113.72 116.842 114.23 116.842 114.628Z",
    fill: "#525575"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M119.464 116.582C119.703 116.403 119.638 115.914 119.32 115.49C119.001 115.066 118.55 114.867 118.311 115.046C118.072 115.226 118.136 115.715 118.454 116.139C118.773 116.563 119.225 116.761 119.464 116.582Z",
    fill: "#525575"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M38.1212 137.89C54.0982 137.89 67.0501 130.636 67.0501 121.688C67.0501 112.74 54.0982 105.486 38.1212 105.486C22.1443 105.486 9.19238 112.74 9.19238 121.688C9.19238 130.636 22.1443 137.89 38.1212 137.89Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M38.1215 137.459C53.6742 137.459 66.2821 130.398 66.2821 121.688C66.2821 112.977 53.6742 105.916 38.1215 105.916C22.5689 105.916 9.96094 112.977 9.96094 121.688C9.96094 130.398 22.5689 137.459 38.1215 137.459Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M38.1208 137.03C53.2491 137.03 65.5131 130.162 65.5131 121.689C65.5131 113.216 53.2491 106.348 38.1208 106.348C22.9925 106.348 10.7285 113.216 10.7285 121.689C10.7285 130.162 22.9925 137.03 38.1208 137.03Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M38.1211 136.601C52.8251 136.601 64.7451 129.925 64.7451 121.69C64.7451 113.455 52.8251 106.779 38.1211 106.779C23.417 106.779 11.4971 113.455 11.4971 121.69C11.4971 129.925 23.417 136.601 38.1211 136.601Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M38.1213 136.17C52.4011 136.17 63.9771 129.687 63.9771 121.69C63.9771 113.692 52.4011 107.209 38.1213 107.209C23.8416 107.209 12.2656 113.692 12.2656 121.69C12.2656 129.687 23.8416 136.17 38.1213 136.17Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M38.1216 135.74C51.977 135.74 63.209 129.449 63.209 121.689C63.209 113.929 51.977 107.639 38.1216 107.639C24.2662 107.639 13.0342 113.929 13.0342 121.689C13.0342 129.449 24.2662 135.74 38.1216 135.74Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M38.1209 135.309C51.552 135.309 62.44 129.211 62.44 121.688C62.44 114.166 51.552 108.068 38.1209 108.068C24.6898 108.068 13.8018 114.166 13.8018 121.688C13.8018 129.211 24.6898 135.309 38.1209 135.309Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M38.1212 134.878C51.128 134.878 61.672 128.972 61.672 121.688C61.672 114.403 51.128 108.498 38.1212 108.498C25.1144 108.498 14.5703 114.403 14.5703 121.688C14.5703 128.972 25.1144 134.878 38.1212 134.878Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M38.1205 134.447C50.7029 134.447 60.903 128.734 60.903 121.687C60.903 114.64 50.7029 108.928 38.1205 108.928C25.538 108.928 15.3379 114.64 15.3379 121.687C15.3379 128.734 25.538 134.447 38.1205 134.447Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M38.1217 134.018C50.2799 134.018 60.136 128.498 60.136 121.689C60.136 114.879 50.2799 109.359 38.1217 109.359C25.9636 109.359 16.1074 114.879 16.1074 121.689C16.1074 128.498 25.9636 134.018 38.1217 134.018Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M38.121 133.587C49.8548 133.587 59.367 128.26 59.367 121.688C59.367 115.116 49.8548 109.789 38.121 109.789C26.3872 109.789 16.875 115.116 16.875 121.688C16.875 128.26 26.3872 133.587 38.121 133.587Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.1203 133.158C49.4298 133.158 58.598 128.023 58.598 121.689C58.598 115.355 49.4298 110.221 38.1203 110.221C26.8108 110.221 17.6426 115.355 17.6426 121.689C17.6426 128.023 26.8108 133.158 38.1203 133.158Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M38.1206 132.727C49.0058 132.727 57.83 127.785 57.83 121.689C57.83 115.592 49.0058 110.65 38.1206 110.65C27.2353 110.65 18.4111 115.592 18.4111 121.689C18.4111 127.785 27.2353 132.727 38.1206 132.727Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M38.1208 132.296C48.5817 132.296 57.062 127.547 57.062 121.688C57.062 115.829 48.5817 111.08 38.1208 111.08C27.6599 111.08 19.1797 115.829 19.1797 121.688C19.1797 127.547 27.6599 132.296 38.1208 132.296Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M38.1211 131.865C48.1577 131.865 56.294 127.309 56.294 121.688C56.294 116.067 48.1577 111.51 38.1211 111.51C28.0845 111.51 19.9482 116.067 19.9482 121.688C19.9482 127.309 28.0845 131.865 38.1211 131.865Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M38.1214 131.435C47.7336 131.435 55.5259 127.07 55.5259 121.687C55.5259 116.304 47.7336 111.939 38.1214 111.939C28.5091 111.939 20.7168 116.304 20.7168 121.687C20.7168 127.07 28.5091 131.435 38.1214 131.435Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M38.1207 131.006C47.3086 131.006 54.7569 126.834 54.7569 121.688C54.7569 116.543 47.3086 112.371 38.1207 112.371C28.9327 112.371 21.4844 116.543 21.4844 121.688C21.4844 126.834 28.9327 131.006 38.1207 131.006Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M38.1209 130.575C46.8846 130.575 53.9889 126.596 53.9889 121.688C53.9889 116.78 46.8846 112.801 38.1209 112.801C29.3573 112.801 22.2529 116.78 22.2529 121.688C22.2529 126.596 29.3573 130.575 38.1209 130.575Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M38.1213 130.146C46.4607 130.146 53.2211 126.36 53.2211 121.689C53.2211 117.019 46.4607 113.232 38.1213 113.232C29.7819 113.232 23.0215 117.019 23.0215 121.689C23.0215 126.36 29.7819 130.146 38.1213 130.146Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M38.1215 129.717C46.0366 129.717 52.4531 126.123 52.4531 121.69C52.4531 117.258 46.0366 113.664 38.1215 113.664C30.2065 113.664 23.79 117.258 23.79 121.69C23.79 126.123 30.2065 129.717 38.1215 129.717Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M38.1217 129.286C45.6125 129.286 51.6849 125.885 51.6849 121.69C51.6849 117.495 45.6125 114.094 38.1217 114.094C30.631 114.094 24.5586 117.495 24.5586 121.69C24.5586 125.885 30.631 129.286 38.1217 129.286Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M38.121 128.855C45.1874 128.855 50.9159 125.647 50.9159 121.689C50.9159 117.732 45.1874 114.523 38.121 114.523C31.0546 114.523 25.3262 117.732 25.3262 121.689C25.3262 125.647 31.0546 128.855 38.121 128.855Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M38.1204 128.424C44.7625 128.424 50.1471 125.409 50.1471 121.689C50.1471 117.969 44.7625 114.953 38.1204 114.953C31.4783 114.953 26.0938 117.969 26.0938 121.689C26.0938 125.409 31.4783 128.424 38.1204 128.424Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1216 127.993C44.3395 127.993 49.38 125.17 49.38 121.688C49.38 118.206 44.3395 115.383 38.1216 115.383C31.9038 115.383 26.8633 118.206 26.8633 121.688C26.8633 125.17 31.9038 127.993 38.1216 127.993Z",
    fill: "#190C00"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0417,
    d: "M69.4171 118.775C85.3941 118.775 98.346 111.521 98.346 102.573C98.346 93.6249 85.3941 86.3711 69.4171 86.3711C53.4402 86.3711 40.4883 93.6249 40.4883 102.573C40.4883 111.521 53.4402 118.775 69.4171 118.775Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0833,
    d: "M69.4174 118.344C84.9701 118.344 97.578 111.283 97.578 102.572C97.578 93.8619 84.9701 86.8008 69.4174 86.8008C53.8648 86.8008 41.2568 93.8619 41.2568 102.572C41.2568 111.283 53.8648 118.344 69.4174 118.344Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "M69.4167 117.915C84.5451 117.915 96.809 111.046 96.809 102.574C96.809 94.1009 84.5451 87.2324 69.4167 87.2324C54.2884 87.2324 42.0244 94.1009 42.0244 102.574C42.0244 111.046 54.2884 117.915 69.4167 117.915Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1667,
    d: "M69.417 117.486C84.121 117.486 96.041 110.81 96.041 102.575C96.041 94.3399 84.121 87.6641 69.417 87.6641C54.7129 87.6641 42.793 94.3399 42.793 102.575C42.793 110.81 54.7129 117.486 69.417 117.486Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2083,
    d: "M69.4172 117.055C83.697 117.055 95.273 110.572 95.273 102.574C95.273 94.577 83.697 88.0938 69.4172 88.0938C55.1375 88.0938 43.5615 94.577 43.5615 102.574C43.5615 110.572 55.1375 117.055 69.4172 117.055Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M69.4175 116.624C83.2729 116.624 94.5049 110.334 94.5049 102.574C94.5049 94.814 83.2729 88.5234 69.4175 88.5234C55.5621 88.5234 44.3301 94.814 44.3301 102.574C44.3301 110.334 55.5621 116.624 69.4175 116.624Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2917,
    d: "M69.4168 116.193C82.8479 116.193 93.7359 110.095 93.7359 102.573C93.7359 95.051 82.8479 88.9531 69.4168 88.9531C55.9857 88.9531 45.0977 95.051 45.0977 102.573C45.0977 110.095 55.9857 116.193 69.4168 116.193Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3333,
    d: "M69.4171 115.762C82.4239 115.762 92.9679 109.857 92.9679 102.573C92.9679 95.2881 82.4239 89.3828 69.4171 89.3828C56.4103 89.3828 45.8662 95.2881 45.8662 102.573C45.8662 109.857 56.4103 115.762 69.4171 115.762Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M69.4164 115.332C81.9988 115.332 92.1989 109.619 92.1989 102.572C92.1989 95.5251 81.9988 89.8125 69.4164 89.8125C56.8339 89.8125 46.6338 95.5251 46.6338 102.572C46.6338 109.619 56.8339 115.332 69.4164 115.332Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4167,
    d: "M69.4176 114.903C81.5758 114.903 91.4319 109.383 91.4319 102.573C91.4319 95.7641 81.5758 90.2441 69.4176 90.2441C57.2595 90.2441 47.4033 95.7641 47.4033 102.573C47.4033 109.383 57.2595 114.903 69.4176 114.903Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4583,
    d: "M69.4169 114.472C81.1507 114.472 90.6629 109.144 90.6629 102.573C90.6629 96.0012 81.1507 90.6738 69.4169 90.6738C57.6831 90.6738 48.1709 96.0012 48.1709 102.573C48.1709 109.144 57.6831 114.472 69.4169 114.472Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.4162 114.043C80.7257 114.043 89.8939 108.908 89.8939 102.574C89.8939 96.2402 80.7257 91.1055 69.4162 91.1055C58.1067 91.1055 48.9385 96.2402 48.9385 102.574C48.9385 108.908 58.1067 114.043 69.4162 114.043Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5417,
    d: "M69.4165 113.612C80.3017 113.612 89.1259 108.67 89.1259 102.574C89.1259 96.4772 80.3017 91.5352 69.4165 91.5352C58.5312 91.5352 49.707 96.4772 49.707 102.574C49.707 108.67 58.5312 113.612 69.4165 113.612Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5833,
    d: "M69.4167 113.181C79.8776 113.181 88.3579 108.432 88.3579 102.573C88.3579 96.7143 79.8776 91.9648 69.4167 91.9648C58.9558 91.9648 50.4756 96.7143 50.4756 102.573C50.4756 108.432 58.9558 113.181 69.4167 113.181Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "M69.417 112.75C79.4536 112.75 87.5899 108.193 87.5899 102.572C87.5899 96.9513 79.4536 92.3945 69.417 92.3945C59.3804 92.3945 51.2441 96.9513 51.2441 102.572C51.2441 108.193 59.3804 112.75 69.417 112.75Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6667,
    d: "M69.4173 112.319C79.0295 112.319 86.8218 107.955 86.8218 102.572C86.8218 97.1884 79.0295 92.8242 69.4173 92.8242C59.805 92.8242 52.0127 97.1884 52.0127 102.572C52.0127 107.955 59.805 112.319 69.4173 112.319Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7083,
    d: "M69.4166 111.89C78.6045 111.89 86.0528 107.719 86.0528 102.573C86.0528 97.4273 78.6045 93.2559 69.4166 93.2559C60.2286 93.2559 52.7803 97.4273 52.7803 102.573C52.7803 107.719 60.2286 111.89 69.4166 111.89Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M69.4168 111.46C78.1805 111.46 85.2848 107.481 85.2848 102.573C85.2848 97.6644 78.1805 93.6855 69.4168 93.6855C60.6532 93.6855 53.5488 97.6644 53.5488 102.573C53.5488 107.481 60.6532 111.46 69.4168 111.46Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7917,
    d: "M69.4171 111.031C77.7564 111.031 84.5168 107.244 84.5168 102.574C84.5168 97.9034 77.7564 94.1172 69.4171 94.1172C61.0778 94.1172 54.3174 97.9034 54.3174 102.574C54.3174 107.244 61.0778 111.031 69.4171 111.031Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8333,
    d: "M69.4174 110.602C77.3324 110.602 83.7488 107.008 83.7488 102.575C83.7488 98.1424 77.3324 94.5488 69.4174 94.5488C61.5023 94.5488 55.0859 98.1424 55.0859 102.575C55.0859 107.008 61.5023 110.602 69.4174 110.602Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "M69.4176 110.171C76.9084 110.171 82.9808 106.77 82.9808 102.575C82.9808 98.3794 76.9084 94.9785 69.4176 94.9785C61.9269 94.9785 55.8545 98.3794 55.8545 102.575C55.8545 106.77 61.9269 110.171 69.4176 110.171Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9167,
    d: "M69.417 109.74C76.4835 109.74 82.2119 106.532 82.2119 102.574C82.2119 98.6165 76.4835 95.4082 69.417 95.4082C62.3506 95.4082 56.6221 98.6165 56.6221 102.574C56.6221 106.532 62.3506 109.74 69.417 109.74Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9583,
    d: "M69.4163 109.309C76.0584 109.309 81.443 106.293 81.443 102.574C81.443 98.8535 76.0584 95.8379 69.4163 95.8379C62.7742 95.8379 57.3896 98.8535 57.3896 102.574C57.3896 106.293 62.7742 109.309 69.4163 109.309Z",
    fill: "#190C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4175 108.878C75.6354 108.878 80.6759 106.055 80.6759 102.573C80.6759 99.0905 75.6354 96.2676 69.4175 96.2676C63.1997 96.2676 58.1592 99.0905 58.1592 102.573C58.1592 106.055 63.1997 108.878 69.4175 108.878Z",
    fill: "#190C00"
  }))), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2247 109.363L36.1611 94.6718V13.6738L62.2247 28.3651V109.363Z",
    fill: "url(#paint103_linear_3449_10546)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7038 0L36.1611 13.6743L62.2247 28.3656L86.7673 14.6913L60.7038 0Z",
    fill: "url(#paint104_linear_3449_10546)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7672 95.6893L62.2246 109.364V28.3657L86.7672 14.6914V95.6893Z",
    fill: "url(#paint105_linear_3449_10546)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 38.7286L62.2356 40.1255L85.2817 27.2852V38.0783L62.2467 50.9128V50.9249L62.2357 50.9187L62.2247 50.9249V50.9128L59.7285 49.5218V38.7286Z",
    fill: "url(#paint106_linear_3449_10546)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 49.5232L82.4532 36.8965L85.2817 38.0797L62.2467 50.9142L59.7285 49.5232Z",
    fill: "#304882"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4531 36.8951V28.8611L85.2817 27.2852V38.0783L82.4531 36.8951Z",
    fill: "url(#paint107_linear_3449_10546)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2314 31.8145V41.4098L75.5957 40.5266V32.681L77.2314 31.8145Z",
    fill: "url(#paint108_linear_3449_10546)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2314 41.3153L79.0392 40.2711V30.7637L77.2314 31.8158V41.3153Z",
    fill: "#3F5BAA"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2705 36.8543L74.2816 36.2607V35.0527L73.2705 35.6463V36.8543Z",
    fill: "url(#paint109_linear_3449_10546)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6494 37.8075L72.6605 37.2139V36.0059L71.6494 36.5994V37.8075Z",
    fill: "url(#paint110_linear_3449_10546)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 38.7566L71.0385 38.163V36.9551L70.0273 37.5486V38.7566Z",
    fill: "url(#paint111_linear_3449_10546)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 39.7097L69.4174 39.1162V37.9082L68.4062 38.5018V39.7097Z",
    fill: "url(#paint112_linear_3449_10546)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.7842 40.6629L67.7952 40.0694V38.8613L66.7842 39.4549V40.6629Z",
    fill: "url(#paint113_linear_3449_10546)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1631 41.614L66.1742 41.0205V39.8125L65.1631 40.406V41.614Z",
    fill: "url(#paint114_linear_3449_10546)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2705 38.5515L74.2816 37.958V36.75L73.2705 37.3436V38.5515Z",
    fill: "url(#paint115_linear_3449_10546)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.6494 39.5047L72.6605 38.9112V37.7031L71.6494 38.2967V39.5047Z",
    fill: "url(#paint116_linear_3449_10546)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 40.4558L71.0385 39.8623V38.6543L70.0273 39.2479V40.4558Z",
    fill: "url(#paint117_linear_3449_10546)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 41.407L69.4174 40.8134V39.6055L68.4062 40.199V41.407Z",
    fill: "url(#paint118_linear_3449_10546)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7852 42.3602L67.7962 41.7666V40.5586L66.7852 41.1522V42.3602Z",
    fill: "url(#paint119_linear_3449_10546)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1631 43.3113L66.1742 42.7177V41.5098L65.1631 42.1032V43.3113Z",
    fill: "url(#paint120_linear_3449_10546)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.2705 40.2468L74.2816 39.6533V38.4453L73.2705 39.0389V40.2468Z",
    fill: "url(#paint121_linear_3449_10546)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.6494 41.2L72.6605 40.6065V39.3984L71.6494 39.992V41.2Z",
    fill: "url(#paint122_linear_3449_10546)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 42.1493L71.0385 41.5557V40.3477L70.0273 40.9413V42.1493Z",
    fill: "url(#paint123_linear_3449_10546)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 43.1023L69.4174 42.5087V41.3008L68.4062 41.8943V43.1023Z",
    fill: "url(#paint124_linear_3449_10546)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7842 44.0555L67.7952 43.462V42.2539L66.7842 42.8475V44.0555Z",
    fill: "url(#paint125_linear_3449_10546)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1631 45.0066L66.1742 44.413V43.2051L65.1631 43.7986V45.0066Z",
    fill: "url(#paint126_linear_3449_10546)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M84.3354 27.8125V37.6823L61.3291 50.7162V39.5927L62.2358 40.1255L84.3354 27.8125Z",
    fill: "url(#paint127_linear_3449_10546)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 38.7285L61.3289 39.5926V50.7161L59.7285 49.7226V38.7285Z",
    fill: "url(#paint128_linear_3449_10546)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2638 43.1016L76.4135 43.6369L74.0489 45.0054L73.7764 44.4875L76.2638 43.1016Z",
    fill: "#304882"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 54.0743L62.2356 55.4712L85.2817 42.6309V53.4241L62.2467 66.2585V66.2706L62.2357 66.2645L62.2247 66.2706V66.2585L59.7285 64.8675V54.0743Z",
    fill: "url(#paint129_linear_3449_10546)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 64.8689L82.4532 52.2422L85.2817 53.4255L62.2467 66.2599L59.7285 64.8689Z",
    fill: "#304882"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4531 52.2408V44.2068L85.2817 42.6309V53.4241L82.4531 52.2408Z",
    fill: "url(#paint130_linear_3449_10546)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2314 47.1602V56.7556L75.5957 55.8723V48.0267L77.2314 47.1602Z",
    fill: "url(#paint131_linear_3449_10546)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2314 56.661L79.0392 55.6168V46.1094L77.2314 47.1615V56.661Z",
    fill: "#3F5BAA"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2705 52.2019L74.2816 51.6084V50.4004L73.2705 50.994V52.2019Z",
    fill: "url(#paint132_linear_3449_10546)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6494 53.1551L72.6605 52.5616V51.3535L71.6494 51.9471V53.1551Z",
    fill: "url(#paint133_linear_3449_10546)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 54.1043L71.0385 53.5108V52.3027L70.0273 52.8963V54.1043Z",
    fill: "url(#paint134_linear_3449_10546)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 55.0574L69.4174 54.4638V53.2559L68.4062 53.8494V55.0574Z",
    fill: "url(#paint135_linear_3449_10546)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.7852 56.0106L67.7962 55.417V54.209L66.7852 54.8025V56.0106Z",
    fill: "url(#paint136_linear_3449_10546)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1631 56.9618L66.1742 56.3682V55.1602L65.1631 55.7538V56.9618Z",
    fill: "url(#paint137_linear_3449_10546)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2705 53.8992L74.2816 53.3056V52.0977L73.2705 52.6912V53.8992Z",
    fill: "url(#paint138_linear_3449_10546)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.6494 54.8524L72.6605 54.2588V53.0508L71.6494 53.6443V54.8524Z",
    fill: "url(#paint139_linear_3449_10546)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 55.8015L71.0385 55.208V54L70.0273 54.5936V55.8015Z",
    fill: "url(#paint140_linear_3449_10546)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 56.7547L69.4174 56.1611V54.9531L68.4062 55.5467V56.7547Z",
    fill: "url(#paint141_linear_3449_10546)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7842 57.7079L67.7952 57.1143V55.9062L66.7842 56.4998V57.7079Z",
    fill: "url(#paint142_linear_3449_10546)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1631 58.659L66.1742 58.0654V56.8574L65.1631 57.451V58.659Z",
    fill: "url(#paint143_linear_3449_10546)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.2705 55.5925L74.2816 54.999V53.791L73.2705 54.3846V55.5925Z",
    fill: "url(#paint144_linear_3449_10546)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.6494 56.5458L72.6605 55.9522V54.7441L71.6494 55.3377V56.5458Z",
    fill: "url(#paint145_linear_3449_10546)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 57.4949L71.0385 56.9013V55.6934L70.0273 56.2869V57.4949Z",
    fill: "url(#paint146_linear_3449_10546)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 58.448L69.4174 57.8545V56.6465L68.4062 57.24V58.448Z",
    fill: "url(#paint147_linear_3449_10546)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7842 59.4012L67.7952 58.8077V57.5996L66.7842 58.1932V59.4012Z",
    fill: "url(#paint148_linear_3449_10546)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1631 60.3523L66.1742 59.7587V58.5508L65.1631 59.1443V60.3523Z",
    fill: "url(#paint149_linear_3449_10546)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M84.3354 43.1582V53.028L61.3291 66.0619V54.9384L62.2358 55.4712L84.3354 43.1582Z",
    fill: "url(#paint150_linear_3449_10546)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 54.0742L61.3289 54.9383V66.0618L59.7285 65.0683V54.0742Z",
    fill: "url(#paint151_linear_3449_10546)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2648 58.4473L76.4145 58.9826L74.0499 60.3511L73.7773 59.8332L76.2648 58.4473Z",
    fill: "#304882"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 69.42L62.2356 70.8169L85.2817 57.9766V68.7698L62.2467 81.6042V81.6163L62.2357 81.6102L62.2247 81.6163V81.6042L59.7285 80.2132V69.42Z",
    fill: "url(#paint152_linear_3449_10546)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 80.2146L82.4532 67.5879L85.2817 68.7712L62.2467 81.6056L59.7285 80.2146Z",
    fill: "#304882"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4531 67.5865V59.5525L85.2817 57.9766V68.7698L82.4531 67.5865Z",
    fill: "url(#paint153_linear_3449_10546)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2314 62.5059V72.1012L75.5957 71.218V63.3724L77.2314 62.5059Z",
    fill: "url(#paint154_linear_3449_10546)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2314 72.0068L79.0392 70.9625V61.4551L77.2314 62.5072V72.0068Z",
    fill: "#3F5BAA"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2705 67.5476L74.2816 66.9541V65.7461L73.2705 66.3397V67.5476Z",
    fill: "url(#paint155_linear_3449_10546)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6494 68.5008L72.6605 67.9073V66.6992L71.6494 67.2928V68.5008Z",
    fill: "url(#paint156_linear_3449_10546)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 69.45L71.0385 68.8564V67.6484L70.0273 68.242V69.45Z",
    fill: "url(#paint157_linear_3449_10546)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 70.4031L69.4174 69.8095V68.6016L68.4062 69.1951V70.4031Z",
    fill: "url(#paint158_linear_3449_10546)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.7842 71.3563L67.7952 70.7627V69.5547L66.7842 70.1482V71.3563Z",
    fill: "url(#paint159_linear_3449_10546)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1631 72.3075L66.1742 71.7139V70.5059L65.1631 71.0994V72.3075Z",
    fill: "url(#paint160_linear_3449_10546)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2705 69.2429L74.2816 68.6494V67.4414L73.2705 68.035V69.2429Z",
    fill: "url(#paint161_linear_3449_10546)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.6494 70.1961L72.6605 69.6026V68.3945L71.6494 68.9881V70.1961Z",
    fill: "url(#paint162_linear_3449_10546)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 71.1454L71.0385 70.5518V69.3438L70.0273 69.9373V71.1454Z",
    fill: "url(#paint163_linear_3449_10546)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 72.0984L69.4174 71.5048V70.2969L68.4062 70.8904V72.0984Z",
    fill: "url(#paint164_linear_3449_10546)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7842 73.0516L67.7952 72.4581V71.25L66.7842 71.8436V73.0516Z",
    fill: "url(#paint165_linear_3449_10546)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1631 74.0028L66.1742 73.4092V72.2012L65.1631 72.7948V74.0028Z",
    fill: "url(#paint166_linear_3449_10546)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.2705 70.9382L74.2816 70.3447V69.1367L73.2705 69.7303V70.9382Z",
    fill: "url(#paint167_linear_3449_10546)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.6494 71.8915L72.6605 71.2979V70.0898L71.6494 70.6834V71.8915Z",
    fill: "url(#paint168_linear_3449_10546)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 72.8406L71.0385 72.247V71.0391L70.0273 71.6326V72.8406Z",
    fill: "url(#paint169_linear_3449_10546)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 73.7937L69.4174 73.2002V71.9922L68.4062 72.5857V73.7937Z",
    fill: "url(#paint170_linear_3449_10546)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7852 74.7469L67.7962 74.1534V72.9453L66.7852 73.5389V74.7469Z",
    fill: "url(#paint171_linear_3449_10546)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1631 75.698L66.1742 75.1045V73.8965L65.1631 74.49V75.698Z",
    fill: "url(#paint172_linear_3449_10546)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M84.3354 58.5039V68.3738L61.3291 81.4076V70.2841L62.2358 70.8169L84.3354 58.5039Z",
    fill: "url(#paint173_linear_3449_10546)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 69.4199L61.3289 70.284V81.4075L59.7285 80.414V69.4199Z",
    fill: "url(#paint174_linear_3449_10546)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2648 73.793L76.4145 74.3283L74.0499 75.6968L73.7773 75.1789L76.2648 73.793Z",
    fill: "#304882"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 84.7677L62.2356 86.1646L85.2817 73.3242V84.1174L62.2467 96.9518V96.964L62.2357 96.9578L62.2247 96.964V96.9518L59.7285 95.5608V84.7677Z",
    fill: "url(#paint175_linear_3449_10546)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 95.5622L82.4532 82.9355L85.2817 84.1188L62.2467 96.9532L59.7285 95.5622Z",
    fill: "#304882"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4531 82.9341V74.9002L85.2817 73.3242V84.1174L82.4531 82.9341Z",
    fill: "url(#paint176_linear_3449_10546)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2314 77.8535V87.449L75.5957 86.5656V78.72L77.2314 77.8535Z",
    fill: "url(#paint177_linear_3449_10546)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2314 87.3545L79.0392 86.3102V76.8027L77.2314 77.8548V87.3545Z",
    fill: "#3F5BAA"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2705 82.8934L74.2816 82.2998V81.0918L73.2705 81.6854V82.8934Z",
    fill: "url(#paint178_linear_3449_10546)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6494 83.8465L72.6605 83.253V82.0449L71.6494 82.6385V83.8465Z",
    fill: "url(#paint179_linear_3449_10546)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 84.7957L71.0385 84.2021V82.9941L70.0273 83.5877V84.7957Z",
    fill: "url(#paint180_linear_3449_10546)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 85.7489L69.4174 85.1553V83.9473L68.4062 84.5408V85.7489Z",
    fill: "url(#paint181_linear_3449_10546)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.7842 86.702L67.7952 86.1084V84.9004L66.7842 85.494V86.702Z",
    fill: "url(#paint182_linear_3449_10546)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1631 87.6531L66.1742 87.0595V85.8516L65.1631 86.4451V87.6531Z",
    fill: "url(#paint183_linear_3449_10546)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2705 84.5906L74.2816 83.997V82.7891L73.2705 83.3826V84.5906Z",
    fill: "url(#paint184_linear_3449_10546)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.6494 85.5438L72.6605 84.9502V83.7422L71.6494 84.3357V85.5438Z",
    fill: "url(#paint185_linear_3449_10546)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 86.4929L71.0385 85.8994V84.6914L70.0273 85.285V86.4929Z",
    fill: "url(#paint186_linear_3449_10546)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 87.4461L69.4174 86.8525V85.6445L68.4062 86.2381V87.4461Z",
    fill: "url(#paint187_linear_3449_10546)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7852 88.3993L67.7962 87.8057V86.5977L66.7852 87.1912V88.3993Z",
    fill: "url(#paint188_linear_3449_10546)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1631 89.3504L66.1742 88.7568V87.5488L65.1631 88.1424V89.3504Z",
    fill: "url(#paint189_linear_3449_10546)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.2705 86.2859L74.2816 85.6923V84.4844L73.2705 85.0779V86.2859Z",
    fill: "url(#paint190_linear_3449_10546)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.6494 87.2391L72.6605 86.6456V85.4375L71.6494 86.0311V87.2391Z",
    fill: "url(#paint191_linear_3449_10546)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0273 88.1883L71.0385 87.5947V86.3867L70.0273 86.9803V88.1883Z",
    fill: "url(#paint192_linear_3449_10546)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 89.1415L69.4174 88.5478V87.3398L68.4062 87.9334V89.1415Z",
    fill: "url(#paint193_linear_3449_10546)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7842 90.0946L67.7952 89.501V88.293L66.7842 88.8865V90.0946Z",
    fill: "url(#paint194_linear_3449_10546)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1631 91.0457L66.1742 90.4521V89.2441L65.1631 89.8377V91.0457Z",
    fill: "url(#paint195_linear_3449_10546)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M84.3354 73.8516V83.7214L61.3291 96.7553V85.6318L62.2358 86.1646L84.3354 73.8516Z",
    fill: "url(#paint196_linear_3449_10546)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7285 84.7676L61.3289 85.6317V96.7552L59.7285 95.7616V84.7676Z",
    fill: "url(#paint197_linear_3449_10546)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2648 89.1406L76.4145 89.6759L74.0499 91.0444L73.7773 90.5265L76.2648 89.1406Z",
    fill: "#304882"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8404 98.9917L80.2866 98.1099C80.1071 97.8241 79.7353 97.7286 79.4402 97.8926L71.3722 102.378C71.1666 102.492 71.0391 102.709 71.0391 102.944V104.453L80.8404 98.9917Z",
    fill: "#304882"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 43.8326L46.667 40.793V41.7211L52.1878 44.7607V43.8326Z",
    fill: "url(#paint198_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 46.4068L46.667 43.3672V44.2953L52.1878 47.3349V46.4068Z",
    fill: "url(#paint199_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 48.9849L46.667 45.9453V46.8735L52.1877 49.9131L52.1878 48.9849Z",
    fill: "url(#paint200_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 51.5591L46.667 48.5195V49.4477L52.1878 52.4874V51.5591Z",
    fill: "url(#paint201_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 54.1353L46.667 51.0957V52.0239L52.1878 55.0635V54.1353Z",
    fill: "url(#paint202_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 56.7095L46.667 53.6699V54.5981L52.1878 57.6378V56.7095Z",
    fill: "url(#paint203_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 59.2857L46.667 56.2461V57.1742L52.1878 60.2139V59.2857Z",
    fill: "url(#paint204_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 61.8619L46.667 58.8223V59.7504L52.1878 62.7901V61.8619Z",
    fill: "url(#paint205_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 64.4361L46.667 61.3965V62.3246L52.1878 65.3643V64.4361Z",
    fill: "url(#paint206_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 67.0123L46.667 63.9727V64.9008L52.1878 67.9405V67.0123Z",
    fill: "url(#paint207_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 69.5884L46.667 66.5488V67.4771L52.1878 70.5167V69.5884Z",
    fill: "url(#paint208_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 72.1627L46.667 69.123V70.0512L52.1878 73.0909V72.1627Z",
    fill: "url(#paint209_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 74.7369L46.667 71.6973V72.6255L52.1878 75.6651V74.7369Z",
    fill: "url(#paint210_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 77.3151L46.667 74.2754V75.2036L52.1878 78.2432V77.3151Z",
    fill: "url(#paint211_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1878 79.8893L46.667 76.8496V77.7778L52.1878 80.8174V79.8893Z",
    fill: "url(#paint212_linear_3449_10546)"
  }))), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0635 127.086L0 112.394V31.3965L26.0635 46.0877V127.086Z",
    fill: "url(#paint213_linear_3449_10546)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5427 17.7227L0 31.397L26.0635 46.0882L50.6061 32.4139L24.5427 17.7227Z",
    fill: "url(#paint214_linear_3449_10546)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6061 113.412L26.0635 127.086V46.0884L50.6061 32.4141V113.412Z",
    fill: "url(#paint215_linear_3449_10546)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 56.4513L26.0745 57.8482L49.1205 45.0078V55.8009L26.0855 68.6354V68.6476L26.0746 68.6413L26.0636 68.6476V68.6354L23.5674 67.2444V56.4513Z",
    fill: "url(#paint216_linear_3449_10546)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 67.2458L46.292 54.6191L49.1205 55.8023L26.0855 68.6368L23.5674 67.2458Z",
    fill: "#304882"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M46.292 54.6177V46.5837L49.1205 45.0078V55.8009L46.292 54.6177Z",
    fill: "url(#paint217_linear_3449_10546)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0702 49.5371V59.1326L39.4346 58.2493V50.4037L41.0702 49.5371Z",
    fill: "url(#paint218_linear_3449_10546)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0703 59.038L42.8782 57.9938V48.4863L41.0703 49.5383V59.038Z",
    fill: "#3F5BAA"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1084 54.5809L38.1195 53.9873V52.7793L37.1084 53.3729V54.5809Z",
    fill: "url(#paint219_linear_3449_10546)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4873 55.534L36.4983 54.9404V53.7324L35.4873 54.326V55.534Z",
    fill: "url(#paint220_linear_3449_10546)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 56.4832L34.8764 55.8897V54.6816L33.8652 55.2752V56.4832Z",
    fill: "url(#paint221_linear_3449_10546)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 57.4363L33.2553 56.8427V55.6348L32.2441 56.2283V57.4363Z",
    fill: "url(#paint222_linear_3449_10546)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.6221 58.3894L31.6331 57.7959V56.5879L30.6221 57.1815V58.3894Z",
    fill: "url(#paint223_linear_3449_10546)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.001 59.3407L30.0121 58.7471V57.5391L29.001 58.1326V59.3407Z",
    fill: "url(#paint224_linear_3449_10546)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1084 56.2742L38.1195 55.6806V54.4727L37.1084 55.0661V56.2742Z",
    fill: "url(#paint225_linear_3449_10546)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.4873 57.2273L36.4983 56.6337V55.4258L35.4873 56.0193V57.2273Z",
    fill: "url(#paint226_linear_3449_10546)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 58.1766L34.8764 57.583V56.375L33.8652 56.9686V58.1766Z",
    fill: "url(#paint227_linear_3449_10546)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 59.1297L33.2553 58.5362V57.3281L32.2441 57.9217V59.1297Z",
    fill: "url(#paint228_linear_3449_10546)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6221 60.0828L31.6331 59.4892V58.2812L30.6221 58.8748V60.0828Z",
    fill: "url(#paint229_linear_3449_10546)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.001 61.034L30.0121 60.4405V59.2324L29.001 59.826V61.034Z",
    fill: "url(#paint230_linear_3449_10546)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.1084 57.9715L38.1195 57.3779V56.1699L37.1084 56.7634V57.9715Z",
    fill: "url(#paint231_linear_3449_10546)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.4873 58.9246L36.4983 58.331V57.123L35.4873 57.7166V58.9246Z",
    fill: "url(#paint232_linear_3449_10546)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 59.8739L34.8764 59.2803V58.0723L33.8652 58.6658V59.8739Z",
    fill: "url(#paint233_linear_3449_10546)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 60.827L33.2553 60.2334V59.0254L32.2441 59.619V60.827Z",
    fill: "url(#paint234_linear_3449_10546)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6221 61.78L31.6331 61.1865V59.9785L30.6221 60.5721V61.78Z",
    fill: "url(#paint235_linear_3449_10546)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M29.001 62.7313L30.0121 62.1377V60.9297L29.001 61.5232V62.7313Z",
    fill: "url(#paint236_linear_3449_10546)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.1743 45.5352V55.4051L25.168 68.4389V57.3154L26.0747 57.8482L48.1743 45.5352Z",
    fill: "url(#paint237_linear_3449_10546)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 56.4512L25.1678 57.3152V68.4387L23.5674 67.4452V56.4512Z",
    fill: "url(#paint238_linear_3449_10546)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1027 60.8242L40.2523 61.3595L37.8878 62.728L37.6152 62.2102L40.1027 60.8242Z",
    fill: "#304882"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 71.797L26.0745 73.1939L49.1205 60.3535V71.1466L26.0855 83.9811V83.9933L26.0746 83.987L26.0636 83.9933V83.9811L23.5674 82.5901V71.797Z",
    fill: "url(#paint239_linear_3449_10546)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 82.5915L46.292 69.9648L49.1205 71.1481L26.0855 83.9825L23.5674 82.5915Z",
    fill: "#304882"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M46.292 69.9634V61.9295L49.1205 60.3535V71.1466L46.292 69.9634Z",
    fill: "url(#paint240_linear_3449_10546)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0702 64.8828V74.4783L39.4346 73.595V65.7493L41.0702 64.8828Z",
    fill: "url(#paint241_linear_3449_10546)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0703 74.3837L42.8782 73.3395V63.832L41.0703 64.884V74.3837Z",
    fill: "#3F5BAA"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1084 69.9226L38.1195 69.3291V68.1211L37.1084 68.7147V69.9226Z",
    fill: "url(#paint242_linear_3449_10546)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4873 70.8758L36.4983 70.2822V69.0742L35.4873 69.6678V70.8758Z",
    fill: "url(#paint243_linear_3449_10546)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 71.8251L34.8764 71.2315V70.0234L33.8652 70.617V71.8251Z",
    fill: "url(#paint244_linear_3449_10546)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 72.7781L33.2553 72.1845V70.9766L32.2441 71.5701V72.7781Z",
    fill: "url(#paint245_linear_3449_10546)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.6221 73.7312L31.6331 73.1377V71.9297L30.6221 72.5232V73.7312Z",
    fill: "url(#paint246_linear_3449_10546)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.001 74.6825L30.0121 74.0889V72.8809L29.001 73.4744V74.6825Z",
    fill: "url(#paint247_linear_3449_10546)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1084 71.6179L38.1195 71.0244V69.8164L37.1084 70.41V71.6179Z",
    fill: "url(#paint248_linear_3449_10546)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.4873 72.5711L36.4983 71.9775V70.7695L35.4873 71.3631V72.5711Z",
    fill: "url(#paint249_linear_3449_10546)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 73.5204L34.8764 72.9268V71.7188L33.8652 72.3123V73.5204Z",
    fill: "url(#paint250_linear_3449_10546)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 74.4734L33.2553 73.8798V72.6719L32.2441 73.2654V74.4734Z",
    fill: "url(#paint251_linear_3449_10546)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6221 75.4265L31.6331 74.833V73.625L30.6221 74.2186V75.4265Z",
    fill: "url(#paint252_linear_3449_10546)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.001 76.3778L30.0121 75.7842V74.5762L29.001 75.1697V76.3778Z",
    fill: "url(#paint253_linear_3449_10546)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.1084 73.3152L38.1195 72.7216V71.5137L37.1084 72.1072V73.3152Z",
    fill: "url(#paint254_linear_3449_10546)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.4873 74.2683L36.4983 73.6748V72.4668L35.4873 73.0604V74.2683Z",
    fill: "url(#paint255_linear_3449_10546)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 75.2176L34.8764 74.6241V73.416L33.8652 74.0096V75.2176Z",
    fill: "url(#paint256_linear_3449_10546)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 76.1707L33.2553 75.5771V74.3691L32.2441 74.9627V76.1707Z",
    fill: "url(#paint257_linear_3449_10546)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6221 77.1238L31.6331 76.5302V75.3223L30.6221 75.9158V77.1238Z",
    fill: "url(#paint258_linear_3449_10546)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M29.001 78.0751L30.0121 77.4815V76.2734L29.001 76.867V78.0751Z",
    fill: "url(#paint259_linear_3449_10546)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.1753 60.8809V70.7508L25.1689 83.7846V72.6611L26.0757 73.194L48.1753 60.8809Z",
    fill: "url(#paint260_linear_3449_10546)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 71.7969L25.1678 72.6609V83.7844L23.5674 82.7909V71.7969Z",
    fill: "url(#paint261_linear_3449_10546)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1027 76.1699L40.2523 76.7052L37.8878 78.0738L37.6152 77.5559L40.1027 76.1699Z",
    fill: "#304882"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 87.1446L26.0745 88.5415L49.1205 75.7012V86.4943L26.0855 99.3288V99.3409L26.0746 99.3348L26.0636 99.3409V99.3288L23.5674 97.9378V87.1446Z",
    fill: "url(#paint262_linear_3449_10546)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 97.9392L46.292 85.3125L49.1205 86.4957L26.0855 99.3302L23.5674 97.9392Z",
    fill: "#304882"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M46.292 85.3111V77.2771L49.1205 75.7012V86.4943L46.292 85.3111Z",
    fill: "url(#paint263_linear_3449_10546)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0702 80.2305V89.8259L39.4346 88.9427V81.0971L41.0702 80.2305Z",
    fill: "url(#paint264_linear_3449_10546)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0703 89.7313L42.8782 88.6872V79.1797L41.0703 80.2317V89.7313Z",
    fill: "#3F5BAA"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1084 85.2722L38.1195 84.6787V83.4707L37.1084 84.0643V85.2722Z",
    fill: "url(#paint265_linear_3449_10546)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4873 86.2254L36.4983 85.6318V84.4238L35.4873 85.0174V86.2254Z",
    fill: "url(#paint266_linear_3449_10546)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 87.1747L34.8764 86.5811V85.373L33.8652 85.9666V87.1747Z",
    fill: "url(#paint267_linear_3449_10546)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 88.1277L33.2553 87.5341V86.3262L32.2441 86.9197V88.1277Z",
    fill: "url(#paint268_linear_3449_10546)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.6221 89.0808L31.6331 88.4873V87.2793L30.6221 87.8729V89.0808Z",
    fill: "url(#paint269_linear_3449_10546)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.001 90.0321L30.0121 89.4385V88.2305L29.001 88.824V90.0321Z",
    fill: "url(#paint270_linear_3449_10546)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1084 86.9675L38.1195 86.374V85.166L37.1084 85.7596V86.9675Z",
    fill: "url(#paint271_linear_3449_10546)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.4873 87.9207L36.4983 87.3271V86.1191L35.4873 86.7127V87.9207Z",
    fill: "url(#paint272_linear_3449_10546)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 88.87L34.8764 88.2764V87.0684L33.8652 87.6619V88.87Z",
    fill: "url(#paint273_linear_3449_10546)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 89.823L33.2553 89.2294V88.0215L32.2441 88.615V89.823Z",
    fill: "url(#paint274_linear_3449_10546)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6221 90.7761L31.6331 90.1826V88.9746L30.6221 89.5682V90.7761Z",
    fill: "url(#paint275_linear_3449_10546)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.001 91.7274L30.0121 91.1338V89.9258L29.001 90.5193V91.7274Z",
    fill: "url(#paint276_linear_3449_10546)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.1084 88.6629L38.1195 88.0693V86.8613L37.1084 87.4549V88.6629Z",
    fill: "url(#paint277_linear_3449_10546)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.4873 89.616L36.4983 89.0225V87.8145L35.4873 88.408V89.616Z",
    fill: "url(#paint278_linear_3449_10546)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 90.5653L34.8764 89.9717V88.7637L33.8652 89.3572V90.5653Z",
    fill: "url(#paint279_linear_3449_10546)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 91.5183L33.2553 90.9248V89.7168L32.2441 90.3104V91.5183Z",
    fill: "url(#paint280_linear_3449_10546)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6221 92.4714L31.6331 91.8779V90.6699L30.6221 91.2635V92.4714Z",
    fill: "url(#paint281_linear_3449_10546)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M29.001 93.4227L30.0121 92.8291V91.6211L29.001 92.2147V93.4227Z",
    fill: "url(#paint282_linear_3449_10546)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.1743 76.2285V86.0984L25.168 99.1322V88.0087L26.0747 88.5416L48.1743 76.2285Z",
    fill: "url(#paint283_linear_3449_10546)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 87.1445L25.1678 88.0086V99.1321L23.5674 98.1386V87.1445Z",
    fill: "url(#paint284_linear_3449_10546)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1027 91.5176L40.2523 92.0528L37.8878 93.4214L37.6152 92.9035L40.1027 91.5176Z",
    fill: "#304882"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 102.488L26.0745 103.885L49.1205 91.0449V101.838L26.0855 114.673V114.685L26.0746 114.678L26.0636 114.685V114.673L23.5674 113.282V102.488Z",
    fill: "url(#paint285_linear_3449_10546)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 113.283L46.292 100.656L49.1205 101.839L26.0855 114.674L23.5674 113.283Z",
    fill: "#304882"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M46.292 100.655V92.6209L49.1205 91.0449V101.838L46.292 100.655Z",
    fill: "url(#paint286_linear_3449_10546)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0702 95.5742V105.17L39.4346 104.286V96.4407L41.0702 95.5742Z",
    fill: "url(#paint287_linear_3449_10546)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0703 105.075L42.8782 104.031V94.5234L41.0703 95.5755V105.075Z",
    fill: "#3F5BAA"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1084 100.616L38.1195 100.023V98.8145L37.1084 99.4081V100.616Z",
    fill: "url(#paint288_linear_3449_10546)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4873 101.569L36.4983 100.976V99.7676L35.4873 100.361V101.569Z",
    fill: "url(#paint289_linear_3449_10546)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 102.518L34.8764 101.925V100.717L33.8652 101.31V102.518Z",
    fill: "url(#paint290_linear_3449_10546)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 103.471L33.2553 102.878V101.67L32.2441 102.263V103.471Z",
    fill: "url(#paint291_linear_3449_10546)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.6221 104.425L31.6331 103.831V102.623L30.6221 103.217V104.425Z",
    fill: "url(#paint292_linear_3449_10546)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.001 105.376L30.0121 104.782V103.574L29.001 104.168V105.376Z",
    fill: "url(#paint293_linear_3449_10546)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1084 102.309L38.1195 101.716V100.508L37.1084 101.101V102.309Z",
    fill: "url(#paint294_linear_3449_10546)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.4873 103.262L36.4983 102.669V101.461L35.4873 102.054V103.262Z",
    fill: "url(#paint295_linear_3449_10546)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 104.212L34.8764 103.618V102.41L33.8652 103.004V104.212Z",
    fill: "url(#paint296_linear_3449_10546)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 105.165L33.2553 104.571V103.363L32.2441 103.957V105.165Z",
    fill: "url(#paint297_linear_3449_10546)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6221 106.118L31.6331 105.524V104.316L30.6221 104.91V106.118Z",
    fill: "url(#paint298_linear_3449_10546)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.001 107.069L30.0121 106.476V105.268L29.001 105.861V107.069Z",
    fill: "url(#paint299_linear_3449_10546)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.1084 104.007L38.1195 103.413V102.205L37.1084 102.799V104.007Z",
    fill: "url(#paint300_linear_3449_10546)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.4873 104.96L36.4983 104.366V103.158L35.4873 103.752V104.96Z",
    fill: "url(#paint301_linear_3449_10546)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8652 105.909L34.8764 105.315V104.107L33.8652 104.701V105.909Z",
    fill: "url(#paint302_linear_3449_10546)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2441 106.862L33.2553 106.269V105.061L32.2441 105.654V106.862Z",
    fill: "url(#paint303_linear_3449_10546)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6221 107.815L31.6331 107.222V106.014L30.6221 106.607V107.815Z",
    fill: "url(#paint304_linear_3449_10546)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M29.001 108.766L30.0121 108.173V106.965L29.001 107.558V108.766Z",
    fill: "url(#paint305_linear_3449_10546)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M48.1743 91.5723V101.442L25.168 114.476V103.352L26.0747 103.885L48.1743 91.5723Z",
    fill: "url(#paint306_linear_3449_10546)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5674 102.488L25.1678 103.352V114.476L23.5674 113.482V102.488Z",
    fill: "url(#paint307_linear_3449_10546)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1027 106.861L40.2523 107.397L37.8878 108.765L37.6152 108.247L40.1027 106.861Z",
    fill: "#304882"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6794 116.714L44.1256 115.833C43.9461 115.547 43.5742 115.451 43.2792 115.615L35.211 120.101C35.0054 120.215 34.8779 120.432 34.8779 120.667V122.175L44.6794 116.714Z",
    fill: "#304882"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 61.5553L10.5059 58.5156V59.4439L16.0267 62.4835V61.5553Z",
    fill: "url(#paint308_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 64.1295L10.5059 61.0898V62.0181L16.0267 65.0577V64.1295Z",
    fill: "url(#paint309_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 66.7076L10.5059 63.668V64.5962L16.0267 67.6358V66.7076Z",
    fill: "url(#paint310_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 69.2819L10.5059 66.2422V67.1704L16.0267 70.21V69.2819Z",
    fill: "url(#paint311_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 71.858L10.5059 68.8184V69.7466L16.0267 72.7862V71.858Z",
    fill: "url(#paint312_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 74.4323L10.5059 71.3926V72.3208L16.0267 75.3604V74.4323Z",
    fill: "url(#paint313_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 77.0084L10.5059 73.9688V74.8969L16.0267 77.9365V77.0084Z",
    fill: "url(#paint314_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 79.5845L10.5059 76.5449V77.4731L16.0267 80.5127V79.5845Z",
    fill: "url(#paint315_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 82.1588L10.5059 79.1191V80.0473L16.0267 83.0869V82.1588Z",
    fill: "url(#paint316_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 84.7349L10.5059 81.6953V82.6235L16.0267 85.6631V84.7349Z",
    fill: "url(#paint317_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 87.3111L10.5059 84.2715V85.1996L16.0267 88.2392V87.3111Z",
    fill: "url(#paint318_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 89.8853L10.5059 86.8457V87.7739L16.0267 90.8135V89.8853Z",
    fill: "url(#paint319_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 92.4595L10.5059 89.4199V90.3481L16.0267 93.3878V92.4595Z",
    fill: "url(#paint320_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 95.0377L10.5059 91.998V92.9262L16.0267 95.9659V95.0377Z",
    fill: "url(#paint321_linear_3449_10546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0267 97.6119L10.5059 94.5723V95.5004L16.0267 98.5401V97.6119Z",
    fill: "url(#paint322_linear_3449_10546)"
  }))), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M64.889 48.6287C64.73 48.5642 64.5775 48.499 64.4323 48.4331C64.4093 48.4227 64.3872 48.4122 64.3645 48.4017C64.2185 48.3343 64.0784 48.2666 63.9463 48.1986C63.9318 48.1911 63.9182 48.1837 63.9039 48.1762C63.7666 48.1048 63.6352 48.0331 63.5124 47.9617L59.5137 45.6387C59.6364 45.71 59.7677 45.7815 59.9048 45.8529C59.9193 45.8605 59.933 45.868 59.9477 45.8756C60.0795 45.9434 60.2192 46.011 60.3646 46.0782C60.3879 46.0889 60.4108 46.0997 60.4344 46.1104C60.5792 46.1761 60.7314 46.2412 60.89 46.3055C60.9173 46.3166 60.9449 46.3276 60.9728 46.3386C61.1344 46.4028 61.3028 46.4661 61.479 46.5281C61.5105 46.5393 61.5432 46.5502 61.5752 46.5612C61.708 46.6069 61.8448 46.6519 61.986 46.696C62.0121 46.7041 62.0371 46.7125 62.0635 46.7205C62.2245 46.7699 62.3918 46.8178 62.5637 46.8646C62.6042 46.8756 62.6454 46.8864 62.6863 46.8972C62.8467 46.9396 63.0111 46.981 63.1809 47.0209C63.2032 47.0262 63.2246 47.0317 63.2471 47.0369C63.4342 47.0801 63.6286 47.1213 63.8274 47.1612C63.881 47.1719 63.9353 47.1824 63.9897 47.1929C64.1149 47.2169 64.2428 47.2402 64.3728 47.2628C64.4295 47.2727 64.4855 47.2828 64.543 47.2923C64.7285 47.3231 64.9173 47.3528 65.1124 47.3805C65.3879 47.4195 65.6574 47.4533 65.924 47.4848C65.9836 47.4918 66.0431 47.4988 66.1022 47.5055C66.3606 47.5347 66.6156 47.5611 66.8651 47.5835C66.9094 47.5875 66.9527 47.5907 66.9968 47.5946C67.1782 47.6101 67.3571 47.6242 67.5335 47.6366C67.5976 47.641 67.6615 47.6453 67.7249 47.6495C67.906 47.6612 68.0846 47.6712 68.2605 47.6797C68.2942 47.6813 68.329 47.6834 68.3626 47.685C68.5694 47.6941 68.7717 47.701 68.9707 47.7061C69.0229 47.7075 69.074 47.7083 69.1256 47.7093C69.278 47.7125 69.4283 47.7146 69.576 47.7155C69.6316 47.7159 69.6875 47.7164 69.7425 47.7164C69.8871 47.7166 70.0293 47.7156 70.1694 47.7138C70.2013 47.7134 70.2342 47.7134 70.2658 47.7129C70.4361 47.7102 70.6026 47.7059 70.7657 47.7004C70.8101 47.699 70.853 47.697 70.8968 47.6953C71.0164 47.6909 71.1343 47.6858 71.2497 47.6801C71.302 47.6774 71.3536 47.6747 71.405 47.6719C71.514 47.6658 71.6208 47.6592 71.7258 47.6522C71.7717 47.6492 71.8182 47.6462 71.8633 47.643C71.9783 47.6347 72.0905 47.6259 72.2006 47.6165C72.2248 47.6144 72.2501 47.6127 72.274 47.6106C72.407 47.599 72.5361 47.5867 72.6618 47.5737C72.6991 47.5699 72.7349 47.5658 72.7716 47.5618C72.8596 47.5524 72.9468 47.5428 73.031 47.5329C73.0743 47.5278 73.1164 47.5226 73.1587 47.5174C73.2339 47.5082 73.3079 47.4987 73.38 47.4892C73.4213 47.4837 73.4626 47.4783 73.5029 47.4727C73.572 47.4631 73.6391 47.4535 73.705 47.4438C73.7405 47.4385 73.7769 47.4333 73.8116 47.4281C73.889 47.4162 73.9636 47.4044 74.0364 47.3925C74.0554 47.3894 74.0758 47.3863 74.0945 47.3832C74.1855 47.3681 74.2725 47.353 74.3558 47.338C74.3789 47.3338 74.4001 47.3298 74.4227 47.3256C74.4814 47.3148 74.5391 47.3041 74.5937 47.2936C74.6223 47.2881 74.6492 47.2826 74.6767 47.2772C74.7219 47.2682 74.7664 47.2593 74.8085 47.2505C74.8351 47.245 74.8609 47.2396 74.8863 47.2343C74.9268 47.2256 74.9659 47.2172 75.0033 47.209C75.0245 47.2043 75.0461 47.1996 75.0662 47.195C75.1055 47.1862 75.1422 47.1778 75.1773 47.1696C75.1919 47.1661 75.2077 47.1625 75.2215 47.1593C75.2663 47.1487 75.3076 47.1386 75.3449 47.1293C75.3828 47.1198 75.4173 47.111 75.4473 47.1032C75.5325 47.0809 75.5857 47.0657 75.6054 47.06L79.6042 49.3831C79.596 49.3855 79.5797 49.39 79.5597 49.3956C79.5433 49.4002 79.5227 49.4058 79.4985 49.4123C79.4586 49.423 79.4105 49.4356 79.3499 49.4508C79.348 49.4513 79.3453 49.4519 79.3435 49.4524C79.3064 49.4617 79.2654 49.4716 79.221 49.4822C79.2056 49.4858 79.1885 49.4898 79.1722 49.4935C79.1388 49.5013 79.1046 49.5092 79.0676 49.5176C79.0454 49.5226 79.022 49.5277 78.9984 49.5329C78.9625 49.5408 78.9256 49.5488 78.8867 49.557C78.8606 49.5626 78.8342 49.5681 78.8067 49.5738C78.7648 49.5825 78.7207 49.5913 78.6756 49.6002C78.6558 49.6041 78.6383 49.6079 78.6179 49.6119C78.6099 49.6135 78.6004 49.6151 78.5923 49.6167C78.5377 49.6272 78.4801 49.6379 78.4214 49.6487C78.3987 49.6528 78.3777 49.6569 78.3545 49.661C78.2717 49.676 78.1851 49.691 78.0946 49.706C78.0734 49.7095 78.0505 49.713 78.029 49.7165C77.958 49.7281 77.8858 49.7396 77.8103 49.7511C77.775 49.7566 77.738 49.7618 77.7015 49.7672C77.6367 49.7767 77.5711 49.7862 77.5032 49.7955C77.4836 49.7982 77.4657 49.801 77.4458 49.8037C77.4239 49.8067 77.3998 49.8095 77.3776 49.8125C77.3057 49.822 77.2323 49.8313 77.1573 49.8406C77.115 49.8458 77.073 49.851 77.0296 49.8561C76.9453 49.866 76.8583 49.8755 76.7702 49.885C76.7334 49.8889 76.6978 49.893 76.6603 49.8969C76.5346 49.9097 76.4056 49.9221 76.2726 49.9338C76.2486 49.9358 76.2232 49.9377 76.199 49.9397C76.089 49.9491 75.9769 49.9579 75.8621 49.9662C75.8463 49.9673 75.8316 49.9687 75.8158 49.9698C75.7856 49.972 75.7531 49.9735 75.7226 49.9755C75.6187 49.9825 75.5132 49.989 75.4056 49.9949C75.3529 49.9979 75.3 50.0007 75.2463 50.0034C75.1327 50.0091 75.0167 50.014 74.8992 50.0184C74.8536 50.0201 74.809 50.0222 74.7628 50.0237C74.6001 50.029 74.4341 50.0333 74.2642 50.036C74.2326 50.0365 74.1997 50.0365 74.1679 50.0369C74.0278 50.0388 73.8857 50.0397 73.7409 50.0396C73.7175 50.0396 73.6953 50.04 73.6718 50.04C73.6401 50.0399 73.6064 50.0388 73.5746 50.0386C73.4272 50.0377 73.2775 50.0356 73.1255 50.0325C73.073 50.0313 73.0212 50.0305 72.9682 50.0292C72.7698 50.0241 72.5682 50.0173 72.3622 50.0081C72.327 50.0065 72.2906 50.0043 72.2552 50.0026C72.081 49.9942 71.904 49.9842 71.7245 49.9727C71.6605 49.9686 71.5963 49.9643 71.5315 49.9597C71.3552 49.9473 71.1763 49.9334 70.9951 49.9177C70.9604 49.9147 70.9273 49.9128 70.8924 49.9096C70.883 49.9088 70.8731 49.9076 70.8636 49.9067C70.614 49.8842 70.359 49.8578 70.1006 49.8287C70.0414 49.822 69.9819 49.8149 69.9224 49.8079C69.6557 49.7764 69.3863 49.7427 69.1107 49.7036C68.9157 49.6761 68.7269 49.6463 68.5413 49.6155C68.4837 49.6059 68.4277 49.5958 68.3711 49.586C68.2412 49.5634 68.1133 49.5402 67.988 49.516C67.9564 49.51 67.9227 49.5045 67.8915 49.4984C67.8689 49.4939 67.8484 49.4888 67.8258 49.4843C67.6269 49.4445 67.4324 49.4033 67.2453 49.36C67.223 49.3548 67.2018 49.3493 67.1796 49.3441C67.0096 49.3042 66.8451 49.2627 66.6847 49.2203C66.6437 49.2095 66.6025 49.1987 66.562 49.1877C66.39 49.1408 66.2227 49.0929 66.0617 49.0435C66.0354 49.0355 66.0106 49.0272 65.9846 49.0191C65.8434 48.975 65.7067 48.9301 65.5739 48.8844C65.5533 48.8774 65.5308 48.8706 65.5105 48.8636C65.4988 48.8595 65.4887 48.8552 65.477 48.8511C65.3007 48.7891 65.1324 48.7258 64.9708 48.6616C64.9436 48.6506 64.9162 48.6397 64.889 48.6287Z",
    fill: "url(#paint323_linear_3449_10546)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5684 67.8574L43.5671 70.1805L43.5805 74.9018C43.6033 75.3403 43.6331 75.7675 43.6664 76.1888C43.6821 76.3864 43.6994 76.5814 43.7173 76.7754C43.7286 76.8977 43.7391 77.0214 43.7513 77.1423C43.7754 77.382 43.8022 77.6171 43.8298 77.851C43.8398 77.9358 43.8485 78.0227 43.8589 78.1068C43.8941 78.3907 43.9325 78.6691 43.9727 78.9446C43.9785 78.9841 43.9833 79.0254 43.9892 79.0648C44.0358 79.3777 44.0858 79.6849 44.1385 79.9871C44.1603 80.1111 44.1844 80.2307 44.2071 80.353C44.2406 80.5339 44.2734 80.7162 44.3092 80.8933C44.3354 81.0222 44.3637 81.1466 44.3909 81.2734C44.4261 81.438 44.4606 81.6039 44.4977 81.7651C44.5421 81.9581 44.5895 82.1457 44.6366 82.3338C44.6618 82.4347 44.6856 82.5383 44.7116 82.6378C44.7745 82.8789 44.8404 83.1142 44.9075 83.3473C44.9197 83.3897 44.9309 83.434 44.9432 83.4761C45.0302 83.7733 45.1212 84.0626 45.2148 84.3469C45.2443 84.4365 45.2752 84.5232 45.3054 84.6116C45.3713 84.8049 45.438 84.9964 45.5068 85.1837C45.5399 85.2739 45.5738 85.3623 45.6075 85.451C45.6986 85.6903 45.7918 85.9246 45.8873 86.1541C45.9151 86.2207 45.9421 86.2888 45.9703 86.3546C46.0911 86.6374 46.2153 86.9132 46.3429 87.1812C46.4059 87.3137 46.4702 87.4429 46.5349 87.5718C46.5689 87.6398 46.6022 87.7096 46.6366 87.7766C46.7314 87.9612 46.828 88.1417 46.9258 88.319C46.9334 88.3327 46.9406 88.3473 46.9482 88.361C47.054 88.5515 47.1616 88.7374 47.2706 88.9197C47.306 88.9788 47.3423 89.0353 47.378 89.0935C47.4528 89.2155 47.5276 89.3372 47.6036 89.4555C47.644 89.5182 47.6851 89.5787 47.7259 89.6404C47.7972 89.7483 47.8686 89.8558 47.941 89.9606C47.9867 90.0267 48.0328 90.0912 48.0789 90.156C48.148 90.2532 48.2172 90.3496 48.2872 90.444C48.3352 90.5089 48.3834 90.5728 48.4318 90.6363C48.5017 90.7281 48.572 90.8185 48.6428 90.9076C48.6914 90.9688 48.7399 91.0298 48.7888 91.0897C48.8618 91.1793 48.9355 91.267 49.0093 91.3539C49.0564 91.4093 49.1033 91.4653 49.1508 91.5196C49.2303 91.6108 49.3105 91.6996 49.3909 91.7878C49.4335 91.8345 49.4756 91.8823 49.5184 91.9281C49.6213 92.0386 49.7249 92.1461 49.8291 92.2518C49.8494 92.2725 49.8694 92.2942 49.8898 92.3147C50.0149 92.4405 50.1409 92.5627 50.2673 92.6819C50.3033 92.7157 50.3395 92.7479 50.3756 92.7812C50.4664 92.8652 50.5572 92.9484 50.6485 93.029C50.6962 93.0711 50.7441 93.1117 50.7921 93.1529C50.8724 93.2221 50.9529 93.2909 51.0336 93.3578C51.0854 93.4006 51.1372 93.4423 51.1891 93.4842C51.2667 93.5467 51.3443 93.6085 51.4222 93.6689C51.4754 93.7101 51.5284 93.7508 51.5817 93.7909C51.6596 93.8498 51.7375 93.9073 51.8156 93.964C51.868 94.0021 51.9205 94.0402 51.973 94.0774C52.0534 94.1342 52.1337 94.1895 52.2142 94.2441C52.2643 94.2781 52.3143 94.3127 52.3645 94.3459C52.4524 94.4041 52.5402 94.4602 52.628 94.5159C52.6704 94.5428 52.7127 94.5706 52.755 94.5969C52.885 94.6775 53.015 94.756 53.1447 94.8313L49.1459 92.5083C49.0162 92.4329 48.8863 92.3545 48.7563 92.2738C48.7137 92.2474 48.6712 92.2194 48.6287 92.1925C48.5411 92.137 48.4536 92.0811 48.3661 92.0231C48.3155 91.9895 48.2651 91.9547 48.2146 91.9204C48.1346 91.866 48.0547 91.8112 47.9749 91.7547C47.9219 91.7172 47.8691 91.6789 47.8162 91.6405C47.7386 91.5841 47.6611 91.5268 47.5835 91.4683C47.5299 91.4278 47.4764 91.3869 47.4229 91.3454C47.3455 91.2855 47.2684 91.2241 47.1914 91.1619C47.139 91.1197 47.0867 91.0776 47.0344 91.0344C46.9544 90.9682 46.8747 90.9 46.795 90.8314C46.7464 90.7895 46.6977 90.7483 46.6491 90.7054C46.5594 90.6262 46.4701 90.5442 46.3809 90.4618C46.3433 90.4271 46.3055 90.3936 46.268 90.3583C46.1418 90.2395 46.0164 90.1177 45.8917 89.9924C45.8694 89.9699 45.8474 89.9461 45.8252 89.9235C45.723 89.8195 45.6211 89.714 45.52 89.6055C45.4768 89.5591 45.4341 89.5108 45.3911 89.4635C45.3113 89.3758 45.2315 89.2876 45.1525 89.1969C45.1047 89.1422 45.0575 89.0859 45.01 89.03C44.9365 88.9436 44.8633 88.8563 44.7906 88.7672C44.7414 88.7069 44.6926 88.6456 44.6438 88.584C44.5732 88.4951 44.503 88.4049 44.4334 88.3133C44.3849 88.2497 44.3366 88.1858 44.2885 88.1209C44.2187 88.0264 44.1493 87.93 44.0803 87.8328C44.0342 87.768 43.988 87.7035 43.9423 87.6374C43.8701 87.5328 43.7989 87.4257 43.7277 87.3179C43.6867 87.256 43.6454 87.195 43.6049 87.132C43.5942 87.1155 43.5833 87.0999 43.5727 87.0833C43.5074 86.981 43.4433 86.8747 43.379 86.7696C43.3436 86.7116 43.3075 86.6554 43.2722 86.5966C43.1632 86.4143 43.0554 86.2283 42.9497 86.0377C42.9419 86.0239 42.9347 86.0092 42.927 85.9953C42.8292 85.8183 42.7328 85.6379 42.6381 85.4536C42.6036 85.3863 42.5702 85.3164 42.5361 85.2482C42.4791 85.1345 42.4217 85.0222 42.3658 84.9058C42.3583 84.8901 42.3515 84.8731 42.344 84.8574C42.2166 84.5895 42.0925 84.314 41.9716 84.0312C41.9434 83.9653 41.9164 83.8971 41.8886 83.8304C41.7931 83.6012 41.7 83.3671 41.6091 83.1281C41.5902 83.0784 41.5697 83.0322 41.551 82.9821C41.5361 82.9423 41.5226 82.8998 41.5079 82.8597C41.4394 82.6731 41.3728 82.4823 41.3073 82.2899C41.2768 82.2007 41.2457 82.1133 41.2159 82.0228C41.1225 81.7389 41.0315 81.45 40.9446 81.1532C40.9442 81.1518 40.9437 81.1504 40.9433 81.1489C40.9299 81.1032 40.9179 81.0551 40.9047 81.0091C40.8391 80.7808 40.7745 80.5506 40.7129 80.3146C40.6865 80.2134 40.6624 80.1082 40.6368 80.0056C40.5902 79.8192 40.5433 79.6336 40.4992 79.4424C40.4958 79.4276 40.492 79.4137 40.4886 79.3988C40.4546 79.2505 40.4236 79.0969 40.3913 78.9457C40.3644 78.8203 40.3364 78.6974 40.3107 78.57C40.2748 78.3926 40.242 78.2101 40.2084 78.0289C40.1858 77.9069 40.1616 77.7875 40.1401 77.6637C40.1386 77.6555 40.1369 77.6477 40.1355 77.6394C40.0842 77.3449 40.036 77.0452 39.9905 76.7405C39.9855 76.7063 39.9813 76.6706 39.9763 76.6363C39.9371 76.3684 39.8993 76.0981 39.8648 75.8222C39.8632 75.8095 39.862 75.7961 39.8604 75.7833C39.8499 75.6994 39.8412 75.6126 39.8312 75.5278C39.8037 75.2939 39.7768 75.0586 39.7526 74.8189C39.7404 74.698 39.73 74.5744 39.7187 74.4522C39.7048 74.3014 39.6895 74.153 39.6768 74.0001C39.6732 73.9562 39.6713 73.9095 39.6678 73.8654C39.6345 73.4441 39.6047 73.0169 39.5819 72.5785L39.5684 67.8574Z",
    fill: "url(#paint324_linear_3449_10546)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M43.677 70.0847C43.6642 70.0961 43.6517 70.1073 43.641 70.1167C43.637 70.1201 43.6345 70.1224 43.6307 70.1256C43.6008 70.152 43.5778 70.1719 43.5672 70.1812L39.5684 67.8581C39.5775 67.8501 39.5962 67.8338 39.6197 67.8132C39.6276 67.8062 39.635 67.7998 39.6444 67.7915C39.6534 67.7836 39.6648 67.7735 39.6752 67.7642C39.687 67.7537 39.6991 67.743 39.7129 67.7307C39.7255 67.7194 39.74 67.7063 39.7542 67.6936C39.7674 67.6817 39.7812 67.6694 39.7959 67.6562C39.8296 67.6258 39.8672 67.5916 39.9079 67.5544C39.9146 67.5482 39.9204 67.5431 39.9273 67.5368C39.9761 67.4921 40.03 67.4424 40.0883 67.3883C40.0996 67.3778 40.1124 67.3657 40.1241 67.3548C40.1705 67.3115 40.2198 67.2654 40.2717 67.2165C40.2939 67.1957 40.3172 67.1735 40.3402 67.1517C40.3871 67.1073 40.4364 67.0604 40.4873 67.0117C40.5137 66.9864 40.54 66.9612 40.5676 66.9348C40.6169 66.8873 40.669 66.837 40.7217 66.7857C40.7491 66.7593 40.7753 66.7339 40.8034 66.7065C40.8816 66.6304 40.9631 66.5505 41.0482 66.4664C41.0528 66.462 41.0568 66.458 41.0614 66.4535C41.1515 66.3644 41.2461 66.2702 41.3438 66.1723C41.3729 66.143 41.404 66.1115 41.434 66.0814C41.5038 66.0112 41.5748 65.9395 41.6482 65.8649C41.6886 65.8238 41.7304 65.781 41.7719 65.7385C41.8349 65.6743 41.8986 65.6089 41.964 65.5415C42.0081 65.4961 42.0529 65.4496 42.0981 65.4028C42.1638 65.3347 42.2308 65.265 42.2989 65.1938C42.3482 65.1424 42.3978 65.0904 42.4482 65.0375C42.5159 64.9663 42.5853 64.893 42.6552 64.819C42.7071 64.7641 42.759 64.7091 42.812 64.6526C42.887 64.5728 42.9639 64.4902 43.0412 64.4073C43.0931 64.3516 43.1443 64.2968 43.1972 64.2396C43.268 64.1632 43.3409 64.0837 43.4135 64.0047C43.4715 63.9416 43.5287 63.8796 43.5878 63.815C43.6652 63.7303 43.7448 63.6423 43.8242 63.5548C43.8811 63.4921 43.937 63.4308 43.9948 63.3666C44.081 63.2711 44.1698 63.1717 44.2582 63.0729C44.3124 63.0123 44.3654 62.9534 44.4204 62.8916C44.5166 62.7836 44.6156 62.6712 44.7143 62.5594C44.7649 62.5021 44.814 62.4469 44.8651 62.3886C44.9778 62.2604 45.0932 62.1277 45.209 61.9946C45.2455 61.9526 45.2808 61.9125 45.3176 61.87C45.4722 61.6916 45.6296 61.5089 45.7897 61.3218C45.8202 61.2862 45.8519 61.2485 45.8826 61.2125C46.0121 61.0606 46.1426 60.9075 46.2756 60.7498C46.3359 60.6783 46.3983 60.6034 46.4594 60.5306C46.565 60.4049 46.6703 60.28 46.7779 60.1506C46.8421 60.0735 46.9081 59.9931 46.9731 59.9148C47.0812 59.7843 47.1889 59.6545 47.2991 59.5205C47.371 59.433 47.4448 59.3422 47.5176 59.2531C47.6235 59.1236 47.729 58.9948 47.8367 58.862C47.9129 58.768 47.9909 58.6708 48.068 58.5751C48.1742 58.4433 48.2803 58.312 48.3882 58.1771C48.4687 58.0767 48.5505 57.9733 48.6318 57.8711C48.7392 57.736 48.8466 57.6012 48.9555 57.4632C49.0693 57.319 49.1846 57.172 49.3001 57.0246C49.3614 56.9463 49.422 56.8694 49.4839 56.7901C49.6647 56.5582 49.8472 56.323 50.0319 56.0829C50.2236 55.8339 50.4106 55.5887 50.593 55.3472C50.649 55.2731 50.7019 55.2015 50.757 55.1281C50.8807 54.9634 51.0049 54.7984 51.1243 54.6373C51.1735 54.5709 51.2199 54.5069 51.2684 54.4411C51.3972 54.2665 51.5253 54.0924 51.649 53.9221C51.7131 53.8339 51.7743 53.7482 51.837 53.6612C51.9411 53.5169 52.0451 53.3727 52.1455 53.2316C52.212 53.1383 52.276 53.0471 52.3408 52.9553C52.4331 52.8245 52.5251 52.6941 52.6143 52.5661C52.6799 52.472 52.7437 52.3796 52.8076 52.287C52.892 52.1648 52.9758 52.0432 53.0574 51.9236C53.1304 51.8165 53.2025 51.7105 53.2733 51.6056C53.3215 51.5341 53.37 51.4624 53.4172 51.3919C53.4968 51.2731 53.5741 51.1564 53.6508 51.0405C53.6914 50.9791 53.7329 50.9167 53.7729 50.8561C53.8642 50.7171 53.9526 50.5809 54.0398 50.4461C54.0625 50.4109 54.0863 50.3746 54.1088 50.3398C54.217 50.1718 54.3218 50.0072 54.4236 49.8456C54.453 49.799 54.4808 49.7541 54.5097 49.708C54.5813 49.5938 54.6524 49.4801 54.7209 49.3691C54.7571 49.3104 54.7919 49.2534 54.8273 49.1957C54.886 49.0998 54.9442 49.0045 55.0006 48.9112C55.0372 48.8507 55.0728 48.7912 55.1085 48.7319C55.1608 48.6446 55.2122 48.5583 55.2624 48.4734C55.2975 48.4142 55.3322 48.3553 55.3661 48.2973C55.4131 48.2172 55.4587 48.1386 55.5039 48.0607C55.5401 47.998 55.5764 47.9353 55.6115 47.8741C55.6557 47.7967 55.6985 47.7212 55.7409 47.6461C55.7732 47.589 55.8059 47.5313 55.8371 47.4755C55.8792 47.4003 55.9195 47.3273 55.9597 47.2545C55.9887 47.2019 56.0184 47.1485 56.0464 47.0973C56.0869 47.0229 56.1254 46.9514 56.1641 46.8796C56.1889 46.8333 56.2148 46.7857 56.2389 46.7405C56.2579 46.7049 56.2752 46.6715 56.2937 46.6365C56.3466 46.5364 56.3981 46.4383 56.447 46.3437C56.4698 46.2996 56.4918 46.2567 56.5137 46.2137C56.556 46.1309 56.597 46.0501 56.6362 45.9718C56.6572 45.9299 56.6783 45.8878 56.6985 45.8472C56.7277 45.7882 56.7557 45.7312 56.7831 45.6749C56.8033 45.6335 56.8236 45.5917 56.843 45.5517C56.8696 45.4964 56.8947 45.4434 56.9197 45.3908C56.9376 45.3527 56.9562 45.3139 56.9733 45.2772C56.9932 45.2346 57.0117 45.1944 57.0304 45.1538C57.048 45.1154 57.0661 45.0765 57.0827 45.0399C57.1004 45.0007 57.1169 44.9639 57.1334 44.9268C57.1491 44.8917 57.1652 44.8559 57.1799 44.8225C57.1943 44.7898 57.2075 44.759 57.2211 44.728C57.2353 44.6953 57.2496 44.6623 57.2627 44.6316C57.2755 44.6017 57.2873 44.5738 57.299 44.5456C57.311 44.5171 57.3232 44.4882 57.3342 44.4614C57.345 44.4354 57.3548 44.4112 57.3647 44.387C57.3749 44.3619 57.3852 44.3366 57.3945 44.3134C57.4037 44.2904 57.4121 44.2691 57.4204 44.248C57.4283 44.2281 57.4362 44.2081 57.4432 44.1899C57.4523 44.1664 57.4604 44.1449 57.4683 44.1243C57.4735 44.1107 57.4791 44.0962 57.4837 44.0838C57.4911 44.0639 57.4976 44.0463 57.5037 44.0296C57.5069 44.0206 57.5108 44.0105 57.5136 44.0024C57.5206 43.9832 57.5263 43.9673 57.5311 43.9534C57.5325 43.9495 57.5344 43.9442 57.5356 43.9407C57.5409 43.9254 57.545 43.9133 57.5474 43.9062L61.5461 46.2293C61.5437 46.2364 61.5397 46.2482 61.5344 46.2636C61.533 46.2676 61.531 46.273 61.5294 46.2776C61.5247 46.291 61.5196 46.3055 61.513 46.3238C61.5118 46.327 61.5112 46.3287 61.5101 46.3321C61.5074 46.3396 61.5035 46.35 61.5005 46.3582C61.4949 46.373 61.4897 46.3875 61.4833 46.4048C61.4778 46.4194 61.4716 46.4355 61.4655 46.4517C61.4583 46.4707 61.4511 46.4896 61.4428 46.5109C61.4401 46.5181 61.438 46.5237 61.435 46.5312C61.43 46.5442 61.4235 46.5601 61.4181 46.5739C61.4101 46.5942 61.4022 46.6141 61.3934 46.6362C61.3842 46.659 61.3742 46.6836 61.3643 46.7083C61.354 46.7334 61.344 46.7583 61.3327 46.7853C61.3292 46.7939 61.3262 46.8012 61.3226 46.81C61.3151 46.828 61.3062 46.8488 61.2983 46.8675C61.2863 46.896 61.2745 46.9242 61.2615 46.9546C61.2486 46.9849 61.2346 47.0172 61.2206 47.0493C61.2069 47.0809 61.1935 47.1119 61.1788 47.1452C61.1746 47.1549 61.1709 47.1634 61.1666 47.1732C61.1555 47.1984 61.1427 47.2265 61.1309 47.2527C61.115 47.2883 61.0995 47.3233 61.0824 47.3608C61.0649 47.3994 61.046 47.4403 61.0273 47.4809C61.0094 47.5198 60.9919 47.5581 60.9728 47.5988C60.9675 47.6102 60.9629 47.6205 60.9574 47.632C60.9448 47.659 60.9303 47.6889 60.9172 47.7165C60.893 47.7677 60.8686 47.8189 60.8427 47.8727C60.8227 47.9145 60.8014 47.9579 60.7803 48.0013C60.7537 48.0558 60.7269 48.1107 60.6986 48.1677C60.6888 48.1875 60.6802 48.2056 60.6702 48.2257C60.6588 48.2485 60.6455 48.2742 60.6338 48.2975C60.595 48.3749 60.5548 48.4544 60.5129 48.5361C60.491 48.579 60.4694 48.6214 60.4466 48.6654C60.3975 48.7604 60.3458 48.8589 60.2927 48.9594C60.2781 48.987 60.2653 49.0122 60.2504 49.0401C60.2462 49.0479 60.2416 49.0563 60.2375 49.064C60.2147 49.1068 60.1903 49.1517 60.1668 49.1954C60.1267 49.27 60.0867 49.3444 60.0445 49.4217C60.0177 49.4706 59.9895 49.5214 59.9619 49.5715C59.9203 49.6469 59.8787 49.7223 59.8351 49.8001C59.8052 49.8537 59.7738 49.9089 59.7429 49.9637C59.6989 50.0414 59.6547 50.1196 59.6087 50.1998C59.5753 50.2582 59.5407 50.318 59.5062 50.3777C59.4776 50.427 59.4507 50.4744 59.4215 50.5245C59.4026 50.5569 59.3821 50.5912 59.3629 50.6239C59.3304 50.6794 59.2973 50.7355 59.2639 50.792C59.2121 50.8795 59.1592 50.9684 59.1052 51.0584C59.0707 51.116 59.0362 51.1734 59.0009 51.2319C58.9437 51.3266 58.8846 51.4232 58.825 51.5205C58.79 51.5775 58.7558 51.6338 58.72 51.6917C58.6509 51.8036 58.5792 51.9181 58.507 52.0334C58.4788 52.0785 58.4517 52.1223 58.4229 52.1678C58.3207 52.3298 58.2156 52.495 58.1071 52.6636C58.086 52.6964 58.0635 52.7306 58.0421 52.7635C57.954 52.8998 57.8646 53.0375 57.7723 53.178C57.7314 53.2401 57.6889 53.3039 57.6474 53.3668C57.5717 53.4812 57.4955 53.5961 57.4171 53.7131C57.3688 53.7851 57.3194 53.8583 57.2701 53.9313C57.226 53.9967 57.1836 54.0603 57.1387 54.1264C57.1126 54.1649 57.0841 54.2054 57.0577 54.2442C56.9751 54.3652 56.8904 54.4882 56.8049 54.6119C56.7415 54.7037 56.6783 54.7954 56.6132 54.8887C56.5243 55.0163 56.4325 55.1464 56.3405 55.2767C56.2753 55.3691 56.211 55.4606 56.1443 55.5545C56.0446 55.6944 55.9415 55.8374 55.8384 55.9804C55.7746 56.069 55.7123 56.1561 55.647 56.2459C55.5225 56.4173 55.3937 56.5923 55.2641 56.768C55.2212 56.8263 55.1807 56.8825 55.1371 56.9413C55.1327 56.9471 55.1281 56.9532 55.1238 56.959C55.0079 57.1153 54.8874 57.2755 54.7676 57.4352C54.7083 57.5143 54.6512 57.5913 54.5909 57.6712C54.4087 57.9123 54.2222 58.157 54.0309 58.4056C53.8455 58.6463 53.6625 58.8823 53.4811 59.1148C53.4225 59.1899 53.3651 59.2629 53.3068 59.3372C53.2103 59.4607 53.1129 59.5855 53.0174 59.7065C52.9955 59.7342 52.9745 59.7604 52.9527 59.788C52.8464 59.9227 52.7418 60.0541 52.6369 60.1859C52.5529 60.2915 52.4684 60.3982 52.3854 60.5019C52.2808 60.6328 52.1779 60.76 52.0748 60.888C51.9944 60.9876 51.9134 61.0887 51.834 61.1866C51.7303 61.3144 51.629 61.4384 51.527 61.5632C51.4502 61.6572 51.3725 61.7528 51.2965 61.8451C51.1922 61.9721 51.0902 62.0949 50.9876 62.2188C50.9232 62.2965 50.8574 62.3768 50.7937 62.4533C50.7875 62.4607 50.7816 62.4677 50.7754 62.4751C50.6713 62.6001 50.5698 62.7207 50.4676 62.8424C50.4034 62.9188 50.3379 62.9974 50.2745 63.0726C50.1266 63.2479 49.9812 63.4187 49.8375 63.587C49.8218 63.6055 49.8055 63.6249 49.7898 63.6432C49.6294 63.8307 49.4717 64.0138 49.3168 64.1926C49.2777 64.2377 49.2402 64.2802 49.2016 64.3246C49.0881 64.4551 48.9748 64.5854 48.8643 64.7111C48.8607 64.7153 48.857 64.7197 48.8534 64.7237C48.805 64.7788 48.759 64.8304 48.7112 64.8845C48.6133 64.9955 48.5151 65.107 48.4195 65.2142C48.3647 65.2759 48.3118 65.3346 48.2576 65.3951C48.169 65.4941 48.0802 65.5936 47.9939 65.6893C47.9344 65.7551 47.8772 65.818 47.8188 65.8823C47.7414 65.9676 47.6636 66.0534 47.5882 66.1361C47.5276 66.2023 47.4691 66.2658 47.4097 66.3304C47.338 66.4084 47.2662 66.4866 47.1963 66.562C47.1821 66.5773 47.1671 66.5939 47.1529 66.609C47.1138 66.6512 47.0772 66.69 47.0386 66.7314C46.9618 66.8139 46.8854 66.8958 46.8109 66.9752C46.7584 67.031 46.7074 67.0851 46.6561 67.1394C46.5848 67.2149 46.5144 67.2893 46.4454 67.3618C46.3955 67.4142 46.3465 67.4655 46.2978 67.5164C46.2304 67.5868 46.1643 67.6556 46.0991 67.7231C46.0524 67.7715 46.006 67.8195 45.9605 67.8664C45.8966 67.9323 45.8345 67.996 45.7729 68.0589C45.7453 68.087 45.7159 68.1175 45.6889 68.1451C45.6742 68.16 45.6611 68.1731 45.6466 68.1879C45.5732 68.2624 45.5025 68.3338 45.4327 68.4041C45.4028 68.4342 45.3717 68.4657 45.3425 68.495C45.2447 68.5929 45.1502 68.687 45.0601 68.7761C45.0556 68.7807 45.0515 68.7846 45.0469 68.7891C44.9618 68.8733 44.8804 68.953 44.8021 69.0292C44.7739 69.0567 44.7478 69.0819 44.7205 69.1083C44.6676 69.1596 44.6157 69.2099 44.5663 69.2574C44.5561 69.2673 44.5443 69.2788 44.5342 69.2884C44.5172 69.3046 44.503 69.318 44.4866 69.3337C44.4348 69.3831 44.3853 69.4303 44.3378 69.4754C44.3149 69.4969 44.2923 69.5183 44.2705 69.5389C44.2187 69.5878 44.1699 69.6333 44.1236 69.6765C44.1116 69.6878 44.0984 69.7001 44.0868 69.7109C44.0283 69.7652 43.9748 69.8145 43.9258 69.8593C43.9189 69.8657 43.9134 69.8707 43.9065 69.8769C43.8655 69.9142 43.8282 69.9482 43.7943 69.9787C43.7908 69.9819 43.786 69.9862 43.7827 69.9893C43.7716 69.9993 43.7629 70.007 43.7527 70.0161C43.7383 70.029 43.7241 70.0418 43.7114 70.0532C43.699 70.0653 43.6882 70.0748 43.677 70.0847Z",
    fill: "url(#paint325_linear_3449_10546)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5452 46.2285C61.4715 46.445 60.0699 50.5587 54.03 58.4051C47.7733 66.5306 43.7767 69.9977 43.5664 70.1801L43.5798 74.9014C44.7783 97.951 60.8437 97.0332 61.6893 96.9849C62.5325 96.0585 78.5532 78.4571 79.6174 54.1016L79.6039 49.3803C79.3932 49.4408 75.3901 50.5909 69.1105 49.7011C63.0431 48.8427 61.6201 46.3592 61.5452 46.2285Z",
    fill: "url(#paint326_linear_3449_10546)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0869 71.2829L46.0959 74.8324C47.019 92.1481 56.7625 94.2985 60.5498 94.4731C63.9524 90.4916 76.1725 74.8058 77.1015 54.0499L77.0986 52.3758C76.1636 52.4793 75.0452 52.5532 73.7728 52.5532C72.1366 52.5532 70.4501 52.4319 68.7576 52.1924C65.9142 51.79 63.8874 51.0447 62.4552 50.252C61.2954 52.429 59.3159 55.6649 56.0257 59.9392C51.2235 66.1745 47.67 69.7802 46.0869 71.2829Z",
    fill: "url(#paint327_linear_3449_10546)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0869 71.2848L46.0959 74.8343C47.019 92.1499 56.7625 94.3004 60.5498 94.4749L62.4552 50.2539C61.2954 52.4309 59.3159 55.6669 56.0257 59.9411C51.2235 66.1764 47.67 69.7821 46.0869 71.2848Z",
    fill: "url(#paint328_linear_3449_10546)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4102 70.0429C57.4102 67.7326 59.2836 64.6947 61.5946 63.2576C63.9056 61.8205 65.779 62.5284 65.779 64.8387C65.779 66.6864 64.5791 68.9976 62.9171 70.5849L63.9553 77.1332L59.357 79.9928L60.2722 72.2297C58.61 72.7095 57.4102 71.8907 57.4102 70.0429Z",
    fill: "#304882"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0704 119.414L52.8803 126.355C54.1748 127.116 54.1226 129.004 52.7881 129.692L38.7911 136.911C37.3732 137.642 37.3357 139.655 38.7255 140.439L67.247 156.517C68.9682 157.487 71.0762 157.467 72.7782 156.463L86.639 148.291",
    stroke: "#92969E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5956 102.209L85.4058 107.499C86.5096 108.094 86.5149 109.675 85.4151 110.278L66.7391 120.511C65.6441 121.111 65.6762 122.694 66.7946 123.25L72.8319 126.246",
    stroke: "#92969E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3449_10546",
    x1: 122.906,
    y1: 64.2378,
    x2: 173.357,
    y2: 64.2378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3449_10546",
    x1: 171.822,
    y1: 43.4728,
    x2: 121.476,
    y2: 24.9873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#FFD38D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3449_10546",
    x1: 178.7,
    y1: 105.168,
    x2: 162.911,
    y2: 51.9677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3449_10546",
    x1: 143.961,
    y1: 18.2703,
    x2: 143.961,
    y2: 54.8404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#FFD38D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3449_10546",
    x1: 113.543,
    y1: 68.2535,
    x2: 163.994,
    y2: 68.2535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3449_10546",
    x1: 114.658,
    y1: 81.1943,
    x2: 148.09,
    y2: 62.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5DBE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3449_10546",
    x1: 162.459,
    y1: 47.4884,
    x2: 112.113,
    y2: 29.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C6FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA3D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3449_10546",
    x1: 169.337,
    y1: 109.184,
    x2: 153.548,
    y2: 55.9833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3449_10546",
    x1: 134.598,
    y1: 22.2859,
    x2: 134.598,
    y2: 58.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C6FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA3D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3449_10546",
    x1: 108.548,
    y1: 39.3856,
    x2: 120.364,
    y2: 66.0368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#FFD38D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3449_10546",
    x1: 105.36,
    y1: 69.7579,
    x2: 109.298,
    y2: 42.1821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#FFD38D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3449_10546",
    x1: 110.179,
    y1: 150.796,
    x2: 141.571,
    y2: 150.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3449_10546",
    x1: 64.1426,
    y1: 138.5,
    x2: 140.971,
    y2: 138.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3449_10546",
    x1: 96.2598,
    y1: 106.855,
    x2: 145.997,
    y2: 106.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3449_10546",
    x1: 96.0791,
    y1: 107.023,
    x2: 142.462,
    y2: 107.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C6FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA3D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3449_10546",
    x1: 95.5146,
    y1: 87.3391,
    x2: 145.587,
    y2: 87.3391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3449_10546",
    x1: 64.3037,
    y1: 136.416,
    x2: 141.387,
    y2: 136.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3449_10546",
    x1: 124.01,
    y1: 136.184,
    x2: 126.728,
    y2: 136.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3449_10546",
    x1: 121.911,
    y1: 134.955,
    x2: 124.63,
    y2: 134.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3449_10546",
    x1: 119.812,
    y1: 133.729,
    x2: 122.531,
    y2: 133.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3449_10546",
    x1: 117.714,
    y1: 132.502,
    x2: 120.432,
    y2: 132.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3449_10546",
    x1: 115.615,
    y1: 131.275,
    x2: 118.334,
    y2: 131.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3449_10546",
    x1: 113.517,
    y1: 130.049,
    x2: 116.235,
    y2: 130.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3449_10546",
    x1: 111.418,
    y1: 128.822,
    x2: 114.136,
    y2: 128.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3449_10546",
    x1: 109.319,
    y1: 127.594,
    x2: 112.038,
    y2: 127.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3449_10546",
    x1: 107.222,
    y1: 126.367,
    x2: 109.94,
    y2: 126.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3449_10546",
    x1: 105.123,
    y1: 125.141,
    x2: 107.842,
    y2: 125.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3449_10546",
    x1: 103.024,
    y1: 123.914,
    x2: 105.743,
    y2: 123.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3449_10546",
    x1: 100.926,
    y1: 122.688,
    x2: 103.644,
    y2: 122.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3449_10546",
    x1: 98.8271,
    y1: 121.459,
    x2: 101.546,
    y2: 121.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3449_10546",
    x1: 96.7285,
    y1: 120.232,
    x2: 99.447,
    y2: 120.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3449_10546",
    x1: 121.603,
    y1: 137.635,
    x2: 124.321,
    y2: 137.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3449_10546",
    x1: 119.504,
    y1: 136.406,
    x2: 122.222,
    y2: 136.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3449_10546",
    x1: 117.405,
    y1: 135.18,
    x2: 120.124,
    y2: 135.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3449_10546",
    x1: 115.307,
    y1: 133.953,
    x2: 118.025,
    y2: 133.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3449_10546",
    x1: 113.209,
    y1: 132.727,
    x2: 115.927,
    y2: 132.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3449_10546",
    x1: 111.11,
    y1: 131.5,
    x2: 113.829,
    y2: 131.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3449_10546",
    x1: 109.012,
    y1: 130.272,
    x2: 111.73,
    y2: 130.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3449_10546",
    x1: 106.913,
    y1: 129.045,
    x2: 109.632,
    y2: 129.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3449_10546",
    x1: 104.814,
    y1: 127.818,
    x2: 107.533,
    y2: 127.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3449_10546",
    x1: 102.716,
    y1: 126.592,
    x2: 105.434,
    y2: 126.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3449_10546",
    x1: 100.617,
    y1: 125.365,
    x2: 103.336,
    y2: 125.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3449_10546",
    x1: 98.5186,
    y1: 124.139,
    x2: 101.237,
    y2: 124.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3449_10546",
    x1: 96.4199,
    y1: 122.91,
    x2: 99.1384,
    y2: 122.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3449_10546",
    x1: 94.3213,
    y1: 121.684,
    x2: 97.0398,
    y2: 121.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3449_10546",
    x1: 117.597,
    y1: 138.614,
    x2: 121.912,
    y2: 138.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3449_10546",
    x1: 117.095,
    y1: 137.857,
    x2: 119.813,
    y2: 137.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3449_10546",
    x1: 114.996,
    y1: 136.631,
    x2: 117.715,
    y2: 136.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3449_10546",
    x1: 112.897,
    y1: 135.404,
    x2: 115.616,
    y2: 135.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3449_10546",
    x1: 110.8,
    y1: 134.178,
    x2: 113.518,
    y2: 134.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3449_10546",
    x1: 108.701,
    y1: 132.951,
    x2: 111.42,
    y2: 132.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3449_10546",
    x1: 106.603,
    y1: 131.723,
    x2: 109.321,
    y2: 131.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3449_10546",
    x1: 104.504,
    y1: 130.496,
    x2: 107.222,
    y2: 130.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3449_10546",
    x1: 102.405,
    y1: 129.27,
    x2: 105.124,
    y2: 129.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3449_10546",
    x1: 100.307,
    y1: 128.043,
    x2: 103.025,
    y2: 128.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3449_10546",
    x1: 98.208,
    y1: 126.816,
    x2: 100.926,
    y2: 126.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3449_10546",
    x1: 96.1093,
    y1: 125.59,
    x2: 98.8278,
    y2: 125.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3449_10546",
    x1: 94.0108,
    y1: 124.361,
    x2: 96.7293,
    y2: 124.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3449_10546",
    x1: 91.9121,
    y1: 123.615,
    x2: 96.2585,
    y2: 123.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3449_10546",
    x1: 116.785,
    y1: 140.535,
    x2: 119.504,
    y2: 140.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3449_10546",
    x1: 114.687,
    y1: 139.307,
    x2: 117.405,
    y2: 139.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3449_10546",
    x1: 112.588,
    y1: 138.08,
    x2: 115.306,
    y2: 138.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3449_10546",
    x1: 110.489,
    y1: 136.854,
    x2: 113.208,
    y2: 136.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3449_10546",
    x1: 108.392,
    y1: 135.627,
    x2: 111.11,
    y2: 135.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3449_10546",
    x1: 106.293,
    y1: 134.4,
    x2: 109.011,
    y2: 134.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3449_10546",
    x1: 104.194,
    y1: 133.172,
    x2: 106.913,
    y2: 133.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3449_10546",
    x1: 102.096,
    y1: 131.945,
    x2: 104.814,
    y2: 131.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3449_10546",
    x1: 99.9971,
    y1: 130.719,
    x2: 102.716,
    y2: 130.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_3449_10546",
    x1: 97.8984,
    y1: 129.492,
    x2: 100.617,
    y2: 129.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_3449_10546",
    x1: 95.7998,
    y1: 128.266,
    x2: 98.5183,
    y2: 128.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_3449_10546",
    x1: 93.7012,
    y1: 127.039,
    x2: 96.4197,
    y2: 127.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_3449_10546",
    x1: 91.6025,
    y1: 125.811,
    x2: 94.321,
    y2: 125.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_3449_10546",
    x1: 89.5039,
    y1: 124.584,
    x2: 92.2224,
    y2: 124.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_3449_10546",
    x1: 114.376,
    y1: 141.986,
    x2: 117.094,
    y2: 141.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_3449_10546",
    x1: 112.277,
    y1: 140.758,
    x2: 114.996,
    y2: 140.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_3449_10546",
    x1: 110.179,
    y1: 139.531,
    x2: 112.897,
    y2: 139.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_3449_10546",
    x1: 108.08,
    y1: 138.305,
    x2: 110.799,
    y2: 138.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_3449_10546",
    x1: 105.982,
    y1: 137.078,
    x2: 108.701,
    y2: 137.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_3449_10546",
    x1: 103.884,
    y1: 135.852,
    x2: 106.602,
    y2: 135.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_3449_10546",
    x1: 101.785,
    y1: 134.625,
    x2: 104.504,
    y2: 134.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_3449_10546",
    x1: 99.6865,
    y1: 133.397,
    x2: 102.405,
    y2: 133.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_3449_10546",
    x1: 97.5879,
    y1: 132.17,
    x2: 100.306,
    y2: 132.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_3449_10546",
    x1: 95.4893,
    y1: 130.943,
    x2: 98.2078,
    y2: 130.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_3449_10546",
    x1: 93.3906,
    y1: 129.717,
    x2: 96.1091,
    y2: 129.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_3449_10546",
    x1: 91.292,
    y1: 128.49,
    x2: 94.0105,
    y2: 128.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_3449_10546",
    x1: 89.1934,
    y1: 127.262,
    x2: 91.9119,
    y2: 127.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_3449_10546",
    x1: 87.0947,
    y1: 126.035,
    x2: 89.8132,
    y2: 126.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_3449_10546",
    x1: 111.967,
    y1: 143.436,
    x2: 114.685,
    y2: 143.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_3449_10546",
    x1: 109.868,
    y1: 142.207,
    x2: 112.587,
    y2: 142.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_3449_10546",
    x1: 107.77,
    y1: 140.981,
    x2: 110.488,
    y2: 140.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_3449_10546",
    x1: 105.671,
    y1: 139.754,
    x2: 108.389,
    y2: 139.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_3449_10546",
    x1: 95.8965,
    y1: 136.265,
    x2: 106.291,
    y2: 136.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_3449_10546",
    x1: 101.475,
    y1: 137.301,
    x2: 104.193,
    y2: 137.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_3449_10546",
    x1: 99.376,
    y1: 136.074,
    x2: 102.094,
    y2: 136.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_3449_10546",
    x1: 97.2774,
    y1: 134.846,
    x2: 99.9958,
    y2: 134.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_3449_10546",
    x1: 95.1787,
    y1: 133.619,
    x2: 97.8972,
    y2: 133.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_3449_10546",
    x1: 93.0801,
    y1: 132.393,
    x2: 95.7986,
    y2: 132.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_3449_10546",
    x1: 90.9814,
    y1: 131.166,
    x2: 93.6999,
    y2: 131.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_3449_10546",
    x1: 88.8828,
    y1: 129.94,
    x2: 91.6013,
    y2: 129.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_3449_10546",
    x1: 86.7842,
    y1: 128.711,
    x2: 89.5027,
    y2: 128.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_3449_10546",
    x1: 84.6856,
    y1: 127.484,
    x2: 87.4041,
    y2: 127.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_3449_10546",
    x1: 128.963,
    y1: 106.88,
    x2: 136.529,
    y2: 106.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_3449_10546",
    x1: 128.963,
    y1: 121.677,
    x2: 136.529,
    y2: 121.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_3449_10546",
    x1: 38.9743,
    y1: 99.0404,
    x2: 59.0827,
    y2: 25.1575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_3449_10546",
    x1: 86.7673,
    y1: 14.1828,
    x2: 36.1611,
    y2: 14.1828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_3449_10546",
    x1: 59.5119,
    y1: 24.5792,
    x2: 87.5348,
    y2: 94.6585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_3449_10546",
    x1: 85.2817,
    y1: 39.105,
    x2: 59.7285,
    y2: 39.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_3449_10546",
    x1: 83.8674,
    y1: 28.8718,
    x2: 83.8674,
    y2: 36.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_3449_10546",
    x1: 76.4135,
    y1: 33.225,
    x2: 76.4135,
    y2: 40.0665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_3449_10546",
    x1: 74.2816,
    y1: 35.9535,
    x2: 73.2705,
    y2: 35.9535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_3449_10546",
    x1: 72.6605,
    y1: 36.9067,
    x2: 71.6494,
    y2: 36.9067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_3449_10546",
    x1: 71.0385,
    y1: 37.8558,
    x2: 70.0274,
    y2: 37.8558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_3449_10546",
    x1: 69.4174,
    y1: 38.809,
    x2: 68.4062,
    y2: 38.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_3449_10546",
    x1: 67.7953,
    y1: 39.7621,
    x2: 66.7841,
    y2: 39.7621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_3449_10546",
    x1: 66.1742,
    y1: 40.7132,
    x2: 65.1631,
    y2: 40.7132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_3449_10546",
    x1: 74.2816,
    y1: 37.6508,
    x2: 73.2705,
    y2: 37.6508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_3449_10546",
    x1: 72.6605,
    y1: 38.6039,
    x2: 71.6494,
    y2: 38.6039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_3449_10546",
    x1: 71.0385,
    y1: 39.555,
    x2: 70.0274,
    y2: 39.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_3449_10546",
    x1: 69.4174,
    y1: 40.5062,
    x2: 68.4062,
    y2: 40.5062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_3449_10546",
    x1: 67.7962,
    y1: 41.4594,
    x2: 66.7851,
    y2: 41.4594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_3449_10546",
    x1: 66.1742,
    y1: 42.4105,
    x2: 65.1631,
    y2: 42.4105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_3449_10546",
    x1: 74.2816,
    y1: 39.3461,
    x2: 73.2705,
    y2: 39.3461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_3449_10546",
    x1: 72.6605,
    y1: 40.2992,
    x2: 71.6494,
    y2: 40.2992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_3449_10546",
    x1: 71.0385,
    y1: 41.2485,
    x2: 70.0274,
    y2: 41.2485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_3449_10546",
    x1: 69.4174,
    y1: 42.2016,
    x2: 68.4062,
    y2: 42.2016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_3449_10546",
    x1: 67.7953,
    y1: 43.1547,
    x2: 66.7841,
    y2: 43.1547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_3449_10546",
    x1: 66.1742,
    y1: 44.1058,
    x2: 65.1631,
    y2: 44.1058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_3449_10546",
    x1: 72.8323,
    y1: 31.1795,
    x2: 72.8323,
    y2: 47.5097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_3449_10546",
    x1: 60.5287,
    y1: 40.4908,
    x2: 60.5287,
    y2: 49.0378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_3449_10546",
    x1: 85.2817,
    y1: 54.4507,
    x2: 59.7285,
    y2: 54.4507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_3449_10546",
    x1: 83.8674,
    y1: 44.2175,
    x2: 83.8674,
    y2: 51.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_3449_10546",
    x1: 76.4135,
    y1: 48.5707,
    x2: 76.4135,
    y2: 55.4122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_3449_10546",
    x1: 74.2816,
    y1: 51.3012,
    x2: 73.2705,
    y2: 51.3012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_3449_10546",
    x1: 72.6605,
    y1: 52.2543,
    x2: 71.6494,
    y2: 52.2543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_3449_10546",
    x1: 71.0385,
    y1: 53.2036,
    x2: 70.0274,
    y2: 53.2036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_3449_10546",
    x1: 69.4174,
    y1: 54.1566,
    x2: 68.4062,
    y2: 54.1566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_3449_10546",
    x1: 67.7962,
    y1: 55.1098,
    x2: 66.7851,
    y2: 55.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_3449_10546",
    x1: 66.1742,
    y1: 56.061,
    x2: 65.1631,
    y2: 56.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_3449_10546",
    x1: 74.2816,
    y1: 52.9984,
    x2: 73.2705,
    y2: 52.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_3449_10546",
    x1: 72.6605,
    y1: 53.9516,
    x2: 71.6494,
    y2: 53.9516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_3449_10546",
    x1: 71.0385,
    y1: 54.9007,
    x2: 70.0274,
    y2: 54.9007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_3449_10546",
    x1: 69.4174,
    y1: 55.8539,
    x2: 68.4062,
    y2: 55.8539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_3449_10546",
    x1: 67.7953,
    y1: 56.8071,
    x2: 66.7841,
    y2: 56.8071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_3449_10546",
    x1: 66.1742,
    y1: 57.7582,
    x2: 65.1631,
    y2: 57.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_3449_10546",
    x1: 74.2816,
    y1: 54.6918,
    x2: 73.2705,
    y2: 54.6918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_3449_10546",
    x1: 72.6605,
    y1: 55.6449,
    x2: 71.6494,
    y2: 55.6449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_3449_10546",
    x1: 71.0385,
    y1: 56.5941,
    x2: 70.0274,
    y2: 56.5941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_3449_10546",
    x1: 69.4174,
    y1: 57.5473,
    x2: 68.4062,
    y2: 57.5473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_3449_10546",
    x1: 67.7953,
    y1: 58.5004,
    x2: 66.7841,
    y2: 58.5004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_3449_10546",
    x1: 66.1742,
    y1: 59.4515,
    x2: 65.1631,
    y2: 59.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_3449_10546",
    x1: 72.8323,
    y1: 46.5252,
    x2: 72.8323,
    y2: 62.8554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_3449_10546",
    x1: 60.5287,
    y1: 55.8365,
    x2: 60.5287,
    y2: 64.3835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_3449_10546",
    x1: 85.2817,
    y1: 69.7964,
    x2: 59.7285,
    y2: 69.7964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_3449_10546",
    x1: 83.8674,
    y1: 59.5632,
    x2: 83.8674,
    y2: 67.2587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_3449_10546",
    x1: 76.4135,
    y1: 63.9165,
    x2: 76.4135,
    y2: 70.7579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_3449_10546",
    x1: 74.2816,
    y1: 66.6469,
    x2: 73.2705,
    y2: 66.6469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_3449_10546",
    x1: 72.6605,
    y1: 67.6,
    x2: 71.6494,
    y2: 67.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_3449_10546",
    x1: 71.0385,
    y1: 68.5492,
    x2: 70.0274,
    y2: 68.5492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_3449_10546",
    x1: 69.4174,
    y1: 69.5023,
    x2: 68.4062,
    y2: 69.5023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_3449_10546",
    x1: 67.7953,
    y1: 70.4555,
    x2: 66.7841,
    y2: 70.4555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_3449_10546",
    x1: 66.1742,
    y1: 71.4067,
    x2: 65.1631,
    y2: 71.4067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_3449_10546",
    x1: 74.2816,
    y1: 68.3422,
    x2: 73.2705,
    y2: 68.3422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_3449_10546",
    x1: 72.6605,
    y1: 69.2953,
    x2: 71.6494,
    y2: 69.2953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_3449_10546",
    x1: 71.0385,
    y1: 70.2446,
    x2: 70.0274,
    y2: 70.2446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_3449_10546",
    x1: 69.4174,
    y1: 71.1977,
    x2: 68.4062,
    y2: 71.1977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_3449_10546",
    x1: 67.7953,
    y1: 72.1508,
    x2: 66.7841,
    y2: 72.1508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_3449_10546",
    x1: 66.1742,
    y1: 73.102,
    x2: 65.1631,
    y2: 73.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_3449_10546",
    x1: 74.2816,
    y1: 70.0375,
    x2: 73.2705,
    y2: 70.0375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_3449_10546",
    x1: 72.6605,
    y1: 70.9907,
    x2: 71.6494,
    y2: 70.9907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_3449_10546",
    x1: 71.0385,
    y1: 71.9398,
    x2: 70.0274,
    y2: 71.9398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_3449_10546",
    x1: 69.4174,
    y1: 72.893,
    x2: 68.4062,
    y2: 72.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_3449_10546",
    x1: 67.7962,
    y1: 73.8461,
    x2: 66.7851,
    y2: 73.8461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_3449_10546",
    x1: 66.1742,
    y1: 74.7972,
    x2: 65.1631,
    y2: 74.7972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_3449_10546",
    x1: 72.8323,
    y1: 61.8709,
    x2: 72.8323,
    y2: 78.2011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_3449_10546",
    x1: 60.5287,
    y1: 71.1822,
    x2: 60.5287,
    y2: 79.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_3449_10546",
    x1: 85.2817,
    y1: 85.1441,
    x2: 59.7285,
    y2: 85.1441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_3449_10546",
    x1: 83.8674,
    y1: 74.9109,
    x2: 83.8674,
    y2: 82.6064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_3449_10546",
    x1: 76.4135,
    y1: 79.2641,
    x2: 76.4135,
    y2: 86.1056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_3449_10546",
    x1: 74.2816,
    y1: 81.9926,
    x2: 73.2705,
    y2: 81.9926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_3449_10546",
    x1: 72.6605,
    y1: 82.9457,
    x2: 71.6494,
    y2: 82.9457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_3449_10546",
    x1: 71.0385,
    y1: 83.8949,
    x2: 70.0274,
    y2: 83.8949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_3449_10546",
    x1: 69.4174,
    y1: 84.8481,
    x2: 68.4062,
    y2: 84.8481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_3449_10546",
    x1: 67.7953,
    y1: 85.8012,
    x2: 66.7841,
    y2: 85.8012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_3449_10546",
    x1: 66.1742,
    y1: 86.7523,
    x2: 65.1631,
    y2: 86.7523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_3449_10546",
    x1: 74.2816,
    y1: 83.6898,
    x2: 73.2705,
    y2: 83.6898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_3449_10546",
    x1: 72.6605,
    y1: 84.643,
    x2: 71.6494,
    y2: 84.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_3449_10546",
    x1: 71.0385,
    y1: 85.5922,
    x2: 70.0274,
    y2: 85.5922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_3449_10546",
    x1: 69.4174,
    y1: 86.5453,
    x2: 68.4062,
    y2: 86.5453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_3449_10546",
    x1: 67.7962,
    y1: 87.4985,
    x2: 66.7851,
    y2: 87.4985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_3449_10546",
    x1: 66.1742,
    y1: 88.4496,
    x2: 65.1631,
    y2: 88.4496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_3449_10546",
    x1: 74.2816,
    y1: 85.3852,
    x2: 73.2705,
    y2: 85.3852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_3449_10546",
    x1: 72.6605,
    y1: 86.3383,
    x2: 71.6494,
    y2: 86.3383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_3449_10546",
    x1: 71.0385,
    y1: 87.2875,
    x2: 70.0274,
    y2: 87.2875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_3449_10546",
    x1: 69.4174,
    y1: 88.2406,
    x2: 68.4062,
    y2: 88.2406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_3449_10546",
    x1: 67.7953,
    y1: 89.1938,
    x2: 66.7841,
    y2: 89.1938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_3449_10546",
    x1: 66.1742,
    y1: 90.1449,
    x2: 65.1631,
    y2: 90.1449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_3449_10546",
    x1: 72.8323,
    y1: 77.2186,
    x2: 72.8323,
    y2: 93.5488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_3449_10546",
    x1: 60.5287,
    y1: 86.5299,
    x2: 60.5287,
    y2: 95.0769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_3449_10546",
    x1: 50.654,
    y1: 45.2054,
    x2: 50.1189,
    y2: 41.6064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_3449_10546",
    x1: 50.654,
    y1: 47.7796,
    x2: 50.1189,
    y2: 44.1806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_3449_10546",
    x1: 50.654,
    y1: 50.3577,
    x2: 50.1189,
    y2: 46.7588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_3449_10546",
    x1: 50.6541,
    y1: 52.9319,
    x2: 50.119,
    y2: 49.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_3449_10546",
    x1: 50.6541,
    y1: 55.5081,
    x2: 50.119,
    y2: 51.9091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_3449_10546",
    x1: 50.6541,
    y1: 58.0823,
    x2: 50.119,
    y2: 54.4834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_3449_10546",
    x1: 50.6541,
    y1: 60.6585,
    x2: 50.119,
    y2: 57.0595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_3449_10546",
    x1: 50.6541,
    y1: 63.2347,
    x2: 50.119,
    y2: 59.6357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_3449_10546",
    x1: 50.6541,
    y1: 65.8089,
    x2: 50.119,
    y2: 62.2099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_3449_10546",
    x1: 50.6541,
    y1: 68.3851,
    x2: 50.119,
    y2: 64.7861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_3449_10546",
    x1: 50.6541,
    y1: 70.9613,
    x2: 50.119,
    y2: 67.3623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_3449_10546",
    x1: 50.6541,
    y1: 73.5355,
    x2: 50.119,
    y2: 69.9365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_3449_10546",
    x1: 50.6541,
    y1: 76.1097,
    x2: 50.119,
    y2: 72.5107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_3449_10546",
    x1: 50.6541,
    y1: 78.6879,
    x2: 50.119,
    y2: 75.0889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_3449_10546",
    x1: 50.6541,
    y1: 81.2621,
    x2: 50.119,
    y2: 77.6631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_3449_10546",
    x1: 2.81317,
    y1: 116.763,
    x2: 22.9216,
    y2: 42.8801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_3449_10546",
    x1: 50.6061,
    y1: 31.9055,
    x2: -0.0000241309,
    y2: 31.9055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_3449_10546",
    x1: 23.3508,
    y1: 42.3019,
    x2: 51.3738,
    y2: 112.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_3449_10546",
    x1: 49.1205,
    y1: 56.8277,
    x2: 23.5673,
    y2: 56.8277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_3449_10546",
    x1: 47.7062,
    y1: 46.5945,
    x2: 47.7062,
    y2: 54.2899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_3449_10546",
    x1: 40.2524,
    y1: 50.9477,
    x2: 40.2524,
    y2: 57.7892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_3449_10546",
    x1: 38.1195,
    y1: 53.6801,
    x2: 37.1084,
    y2: 53.6801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_3449_10546",
    x1: 36.4984,
    y1: 54.6332,
    x2: 35.4873,
    y2: 54.6332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_3449_10546",
    x1: 34.8764,
    y1: 55.5824,
    x2: 33.8652,
    y2: 55.5824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_3449_10546",
    x1: 33.2552,
    y1: 56.5355,
    x2: 32.2441,
    y2: 56.5355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_3449_10546",
    x1: 31.6331,
    y1: 57.4887,
    x2: 30.622,
    y2: 57.4887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_3449_10546",
    x1: 30.0121,
    y1: 58.4399,
    x2: 29.001,
    y2: 58.4399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_3449_10546",
    x1: 38.1195,
    y1: 55.3734,
    x2: 37.1084,
    y2: 55.3734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_3449_10546",
    x1: 36.4984,
    y1: 56.3266,
    x2: 35.4873,
    y2: 56.3266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_3449_10546",
    x1: 34.8764,
    y1: 57.2758,
    x2: 33.8652,
    y2: 57.2758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_3449_10546",
    x1: 33.2552,
    y1: 58.229,
    x2: 32.2441,
    y2: 58.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_3449_10546",
    x1: 31.6331,
    y1: 59.182,
    x2: 30.622,
    y2: 59.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_3449_10546",
    x1: 30.0121,
    y1: 60.1332,
    x2: 29.001,
    y2: 60.1332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_3449_10546",
    x1: 38.1195,
    y1: 57.0707,
    x2: 37.1084,
    y2: 57.0707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_3449_10546",
    x1: 36.4984,
    y1: 58.0238,
    x2: 35.4873,
    y2: 58.0238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_3449_10546",
    x1: 34.8764,
    y1: 58.9731,
    x2: 33.8652,
    y2: 58.9731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_3449_10546",
    x1: 33.2552,
    y1: 59.9262,
    x2: 32.2441,
    y2: 59.9262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_3449_10546",
    x1: 31.6331,
    y1: 60.8793,
    x2: 30.622,
    y2: 60.8793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_3449_10546",
    x1: 30.0121,
    y1: 61.8305,
    x2: 29.001,
    y2: 61.8305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_3449_10546",
    x1: 36.6711,
    y1: 48.9022,
    x2: 36.6711,
    y2: 65.2324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_3449_10546",
    x1: 24.3675,
    y1: 58.2134,
    x2: 24.3675,
    y2: 66.7605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_3449_10546",
    x1: 49.1205,
    y1: 72.1734,
    x2: 23.5673,
    y2: 72.1734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_3449_10546",
    x1: 47.7062,
    y1: 61.9402,
    x2: 47.7062,
    y2: 69.6356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_3449_10546",
    x1: 40.2524,
    y1: 66.2935,
    x2: 40.2524,
    y2: 73.1349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_3449_10546",
    x1: 38.1195,
    y1: 69.0218,
    x2: 37.1084,
    y2: 69.0218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_3449_10546",
    x1: 36.4984,
    y1: 69.975,
    x2: 35.4873,
    y2: 69.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_3449_10546",
    x1: 34.8764,
    y1: 70.9242,
    x2: 33.8652,
    y2: 70.9242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_3449_10546",
    x1: 33.2552,
    y1: 71.8773,
    x2: 32.2441,
    y2: 71.8773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_3449_10546",
    x1: 31.6331,
    y1: 72.8305,
    x2: 30.622,
    y2: 72.8305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_3449_10546",
    x1: 30.0121,
    y1: 73.7817,
    x2: 29.001,
    y2: 73.7817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_3449_10546",
    x1: 38.1195,
    y1: 70.7172,
    x2: 37.1084,
    y2: 70.7172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_3449_10546",
    x1: 36.4984,
    y1: 71.6703,
    x2: 35.4873,
    y2: 71.6703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_3449_10546",
    x1: 34.8764,
    y1: 72.6195,
    x2: 33.8652,
    y2: 72.6195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_3449_10546",
    x1: 33.2552,
    y1: 73.5726,
    x2: 32.2441,
    y2: 73.5726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_3449_10546",
    x1: 31.6331,
    y1: 74.5258,
    x2: 30.622,
    y2: 74.5258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_3449_10546",
    x1: 30.0121,
    y1: 75.477,
    x2: 29.001,
    y2: 75.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_3449_10546",
    x1: 38.1195,
    y1: 72.4144,
    x2: 37.1084,
    y2: 72.4144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_3449_10546",
    x1: 36.4984,
    y1: 73.3676,
    x2: 35.4873,
    y2: 73.3676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_3449_10546",
    x1: 34.8764,
    y1: 74.3168,
    x2: 33.8652,
    y2: 74.3168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_3449_10546",
    x1: 33.2552,
    y1: 75.2699,
    x2: 32.2441,
    y2: 75.2699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_3449_10546",
    x1: 31.6331,
    y1: 76.223,
    x2: 30.622,
    y2: 76.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_3449_10546",
    x1: 30.0121,
    y1: 77.1742,
    x2: 29.001,
    y2: 77.1742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_3449_10546",
    x1: 36.6721,
    y1: 64.2479,
    x2: 36.6721,
    y2: 80.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_3449_10546",
    x1: 24.3675,
    y1: 73.5591,
    x2: 24.3675,
    y2: 82.1062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_3449_10546",
    x1: 49.1205,
    y1: 87.521,
    x2: 23.5673,
    y2: 87.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_3449_10546",
    x1: 47.7062,
    y1: 77.2878,
    x2: 47.7062,
    y2: 84.9833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_3449_10546",
    x1: 40.2524,
    y1: 81.6411,
    x2: 40.2524,
    y2: 88.4826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_3449_10546",
    x1: 38.1195,
    y1: 84.3715,
    x2: 37.1084,
    y2: 84.3715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_3449_10546",
    x1: 36.4984,
    y1: 85.3246,
    x2: 35.4873,
    y2: 85.3246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_3449_10546",
    x1: 34.8764,
    y1: 86.2739,
    x2: 33.8652,
    y2: 86.2739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_3449_10546",
    x1: 33.2552,
    y1: 87.2269,
    x2: 32.2441,
    y2: 87.2269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_3449_10546",
    x1: 31.6331,
    y1: 88.1801,
    x2: 30.622,
    y2: 88.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_3449_10546",
    x1: 30.0121,
    y1: 89.1313,
    x2: 29.001,
    y2: 89.1313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_3449_10546",
    x1: 38.1195,
    y1: 86.0668,
    x2: 37.1084,
    y2: 86.0668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_3449_10546",
    x1: 36.4984,
    y1: 87.0199,
    x2: 35.4873,
    y2: 87.0199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_3449_10546",
    x1: 34.8764,
    y1: 87.9692,
    x2: 33.8652,
    y2: 87.9692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_3449_10546",
    x1: 33.2552,
    y1: 88.9222,
    x2: 32.2441,
    y2: 88.9222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_3449_10546",
    x1: 31.6331,
    y1: 89.8754,
    x2: 30.622,
    y2: 89.8754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_3449_10546",
    x1: 30.0121,
    y1: 90.8266,
    x2: 29.001,
    y2: 90.8266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_3449_10546",
    x1: 38.1195,
    y1: 87.7621,
    x2: 37.1084,
    y2: 87.7621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_3449_10546",
    x1: 36.4984,
    y1: 88.7152,
    x2: 35.4873,
    y2: 88.7152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_3449_10546",
    x1: 34.8764,
    y1: 89.6645,
    x2: 33.8652,
    y2: 89.6645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_3449_10546",
    x1: 33.2552,
    y1: 90.6176,
    x2: 32.2441,
    y2: 90.6176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_3449_10546",
    x1: 31.6331,
    y1: 91.5707,
    x2: 30.622,
    y2: 91.5707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_3449_10546",
    x1: 30.0121,
    y1: 92.5219,
    x2: 29.001,
    y2: 92.5219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_3449_10546",
    x1: 36.6711,
    y1: 79.5956,
    x2: 36.6711,
    y2: 95.9258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_3449_10546",
    x1: 24.3675,
    y1: 88.9068,
    x2: 24.3675,
    y2: 97.4538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_3449_10546",
    x1: 49.1205,
    y1: 102.865,
    x2: 23.5673,
    y2: 102.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_3449_10546",
    x1: 47.7062,
    y1: 92.6316,
    x2: 47.7062,
    y2: 100.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_3449_10546",
    x1: 40.2524,
    y1: 96.9848,
    x2: 40.2524,
    y2: 103.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_3449_10546",
    x1: 38.1195,
    y1: 99.7153,
    x2: 37.1084,
    y2: 99.7153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_3449_10546",
    x1: 36.4984,
    y1: 100.668,
    x2: 35.4873,
    y2: 100.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_3449_10546",
    x1: 34.8764,
    y1: 101.618,
    x2: 33.8652,
    y2: 101.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_3449_10546",
    x1: 33.2552,
    y1: 102.571,
    x2: 32.2441,
    y2: 102.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_3449_10546",
    x1: 31.6331,
    y1: 103.524,
    x2: 30.622,
    y2: 103.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_3449_10546",
    x1: 30.0121,
    y1: 104.475,
    x2: 29.001,
    y2: 104.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_3449_10546",
    x1: 38.1195,
    y1: 101.409,
    x2: 37.1084,
    y2: 101.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_3449_10546",
    x1: 36.4984,
    y1: 102.362,
    x2: 35.4873,
    y2: 102.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_3449_10546",
    x1: 34.8764,
    y1: 103.311,
    x2: 33.8652,
    y2: 103.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_3449_10546",
    x1: 33.2552,
    y1: 104.264,
    x2: 32.2441,
    y2: 104.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_3449_10546",
    x1: 31.6331,
    y1: 105.217,
    x2: 30.622,
    y2: 105.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_3449_10546",
    x1: 30.0121,
    y1: 106.168,
    x2: 29.001,
    y2: 106.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_3449_10546",
    x1: 38.1195,
    y1: 103.106,
    x2: 37.1084,
    y2: 103.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_3449_10546",
    x1: 36.4984,
    y1: 104.059,
    x2: 35.4873,
    y2: 104.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_3449_10546",
    x1: 34.8764,
    y1: 105.008,
    x2: 33.8652,
    y2: 105.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_3449_10546",
    x1: 33.2552,
    y1: 105.961,
    x2: 32.2441,
    y2: 105.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_3449_10546",
    x1: 31.6331,
    y1: 106.914,
    x2: 30.622,
    y2: 106.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_3449_10546",
    x1: 30.0121,
    y1: 107.866,
    x2: 29.001,
    y2: 107.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_3449_10546",
    x1: 36.6711,
    y1: 94.9393,
    x2: 36.6711,
    y2: 111.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_3449_10546",
    x1: 24.3675,
    y1: 104.251,
    x2: 24.3675,
    y2: 112.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_3449_10546",
    x1: 14.4929,
    y1: 62.9281,
    x2: 13.9578,
    y2: 59.3291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_3449_10546",
    x1: 14.493,
    y1: 65.5023,
    x2: 13.9578,
    y2: 61.9033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_3449_10546",
    x1: 14.493,
    y1: 68.0804,
    x2: 13.9578,
    y2: 64.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_3449_10546",
    x1: 14.493,
    y1: 70.6547,
    x2: 13.9578,
    y2: 67.0557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_3449_10546",
    x1: 14.493,
    y1: 73.2308,
    x2: 13.9578,
    y2: 69.6319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_3449_10546",
    x1: 14.493,
    y1: 75.805,
    x2: 13.9578,
    y2: 72.2061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_3449_10546",
    x1: 14.4929,
    y1: 78.3812,
    x2: 13.9578,
    y2: 74.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_3449_10546",
    x1: 14.493,
    y1: 80.9573,
    x2: 13.9578,
    y2: 77.3584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_3449_10546",
    x1: 14.493,
    y1: 83.5315,
    x2: 13.9578,
    y2: 79.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_3449_10546",
    x1: 14.4929,
    y1: 86.1077,
    x2: 13.9578,
    y2: 82.5087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_3449_10546",
    x1: 14.4929,
    y1: 88.6839,
    x2: 13.9578,
    y2: 85.0849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_3449_10546",
    x1: 14.493,
    y1: 91.2581,
    x2: 13.9578,
    y2: 87.6591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_3449_10546",
    x1: 14.4929,
    y1: 93.8323,
    x2: 13.9578,
    y2: 90.2334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_3449_10546",
    x1: 14.4929,
    y1: 96.4105,
    x2: 13.9578,
    y2: 92.8115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_3449_10546",
    x1: 14.4929,
    y1: 98.9847,
    x2: 13.9578,
    y2: 95.3857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_3449_10546",
    x1: 59.5137,
    y1: 47.8392,
    x2: 79.6046,
    y2: 47.8392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_3449_10546",
    x1: 46.915,
    y1: 91.9138,
    x2: 45.7848,
    y2: 75.1617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_3449_10546",
    x1: 39.5684,
    y1: 57.0439,
    x2: 61.546,
    y2: 57.0439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_3449_10546",
    x1: 43.5663,
    y1: 71.6148,
    x2: 79.6173,
    y2: 71.6148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_3449_10546",
    x1: 46.087,
    y1: 72.3625,
    x2: 77.1016,
    y2: 72.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_3449_10546",
    x1: 46.087,
    y1: 72.3644,
    x2: 62.4553,
    y2: 72.3644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#879CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F5BAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutonomusopsNew);
export default __webpack_public_path__ + "static/media/autonomusops-new.240497fefe495c7c21c04f12891f3b74.svg";
export { ForwardRef as ReactComponent };